const translations = {
  en: {
    nav: {
      home: 'Home',
      bhaktiSamadhan: 'Bhakti Samadhan',
      onlinePooja: 'Online Pooja',
      bhaktiDarshan: 'Bhakti Darshan',
      bhaktiStore: 'Bhakti Store',
      bhaktiYoga: 'Bhakti Yoga',
      bhaktiJaapa: 'Bhakti Jaapa',
      bhaktiBalChitraKatha: 'Bal Chitra Katha',
      dashboard: 'Dashboard',
      adminPanel: 'Admin Panel',
      logout: 'Logout',
      login: 'Login',
      signUp: 'Sign Up',
      selectLanguage: 'Select language',
      language: 'Language',
      openShoppingCart: 'Open shopping cart',
    },
    footer: {
      contact: 'Contact',
      allRightsReserved: 'All Rights Reserved.',
    },
    auth: {
      login: {
        welcomeBack: 'Welcome Back',
        subtitle: 'Sign in to continue your spiritual journey',
        googleTermsPrefix: 'By signing in with Google, you agree to our',
        termsAndPrivacy: 'Terms & Conditions and Privacy Policy',
        separator: 'OR',
        redirectMessage: 'You must be logged in to view the page you were trying to access.',
        emailAddress: 'Email Address',
        enterEmail: 'Enter your email',
        password: 'Password',
        enterPassword: 'Enter your password',
        rememberMe: 'Remember me',
        forgotPassword: 'Forgot Password?',
        signingIn: 'Signing In...',
        signIn: 'Sign In',
        noAccount: "Don't have an account?",
        signUp: 'Sign Up',
        welcomeToast: 'Welcome back, {{name}}!',
        emailRequired: 'Email is required',
        emailInvalid: 'Email is invalid',
        passwordRequired: 'Password is required',
        passwordMin: 'Password must be at least 6 characters',
        loginFailed: 'Login failed. Please try again.',
      },
      signup: {
        joinAnandmaya: 'Join Anandmaya',
        subtitle: 'Begin your spiritual journey with us',
        firstName: 'First Name',
        enterFirstName: 'Enter first name',
        lastName: 'Last Name',
        enterLastName: 'Enter last name',
        emailAddress: 'Email Address',
        enterEmail: 'Enter your email',
        password: 'Password',
        createPassword: 'Create a password',
        confirmPassword: 'Confirm Password',
        confirmPasswordPlaceholder: 'Confirm your password',
        agreeToPrefix: 'I agree to the',
        termsAndConditions: 'Terms and Conditions',
        and: 'and',
        privacyPolicy: 'Privacy Policy',
        creatingAccount: 'Creating Account...',
        createAccount: 'Create Account',
        alreadyHaveAccount: 'Already have an account?',
        signIn: 'Sign In',
        accountCreatedAlert: 'Account created successfully! Welcome to Anandmaya!',
        firstNameRequired: 'First name is required',
        lastNameRequired: 'Last name is required',
        emailRequired: 'Email is required',
        emailInvalid: 'Email is invalid',
        passwordRequired: 'Password is required',
        passwordMin: 'Password must be at least 6 characters',
        confirmPasswordRequired: 'Please confirm your password',
        passwordsNoMatch: 'Passwords do not match',
        agreeToTermsRequired: 'You must agree to the terms and conditions',
        registrationFailed: 'Registration failed. Please try again.',
      },
      progressiveSignup: {
        closeAria: 'Close sign up prompt',
        kicker: 'Continue your journey',
        title: 'Save your spiritual progress',
        description: 'Create a free account to keep your activity, recommendations, and saved items connected across visits.',
        loginPrompt: 'Sign in or continue with Google to save your progress.',
        benefitOne: 'Save progress',
        benefitTwo: 'Personalized guidance',
        benefitThree: 'Faster future access',
        createAccount: 'Create free account',
        signIn: 'I already have an account',
      },
    },
    home: {
      hero: {
        liveDarshan: 'Divine Darshan',
        watchNow: 'Watch Now',
        bhakti: 'Bhakti',
        balChitrakatha: 'Bal-Chitrakatha',
        mindBodySoul: 'Body ~ Mind ~ Soul',
        subtitle: 'Discover the path of devotion, spiritual enlightenment and physical wellness',
        deviGalleryAria: 'Rotating devi gallery',
        cards: {
          bhaktiSamadhan: {
            title: 'Bhakti\nSamadhan',
            description: 'AI-powered spiritual guidance on poojas, mantras, and Vedic remedies.',
          },
          onlinePooja: {
            title: 'Online Pooja',
            description: 'Participate in sacred Vedic rituals from the comfort of your home.',
          },
          bhaktiDarshan: {
            title: 'Bhakti\nDarshan',
            description: 'Real-time divine sightings from major temples across India.',
          },
          bhaktiStore: {
            title: 'Bhakti Store',
            description: 'Curated spiritual items, idols, and books for your journey.',
          },
          bhaktiYoga: {
            title: 'Bhakti Yoga',
            description: 'Connect body, mind, and soul through devotional yoga practices.',
          },
          bhaktiJaapa: {
            title: 'Bhakti Jaapa',
            description: 'Track and deepen your daily mantra chanting practice.',
          },
        },
        deity: {
          maaDurga: 'Maa Durga',
          goddessSaraswati: 'Goddess Saraswati',
          maaParvati: 'Maa Parvati',
          maaKali: 'Maa Kali',
          maaLakshmi: 'Maa Lakshmi',
          lordGanesha: 'Lord Ganesha',
          lordHanuman: 'Lord Hanuman',
          lordShiva: 'Lord Shiva',
          lordVishnu: 'Lord Vishnu',
          lordKrishna: 'Lord Krishna',
          lordMurugan: 'Lord Murugan',
          lordBrahma: 'Lord Brahma',
          maaBagalamukhi: 'Maa Bagalamukhi',
          lordKubera: 'Lord Kubera',
          lordShani: 'Lord Shani',
          navgraha: 'Navgraha',
          vastuPurusha: 'Vastu Purusha',
          guru: 'Spiritual Guru',
        },
      },
      sections: {
        bhaktiSamadhan: {
          title: 'Bhakti Samadhan',
          subtitle: 'AI-powered spiritual guidance for your life situations',
          description: 'Get personalized Vedic guidance powered by AI. Ask about poojas, mantras, astrology, meditation, or any spiritual queries. Browse curated remedies for health, wealth, career, relationships, and more.',
          features: [
            'AI-powered pooja recommendations',
            'Personalized spiritual chat assistant',
            'Curated Vedic remedies by category',
            'Citations from sacred scriptures',
          ],
          buttonText: 'Get Spiritual Guidance',
        },
        onlinePooja: {
          title: 'Online Pooja',
          subtitle: 'Perform sacred rituals and prayers from anywhere in the world',
          description: 'Experience the power of traditional pooja ceremonies through our online platform. Our experienced priests conduct live pooja sessions that you can participate in from the comfort of your home.',
          features: [
            'Personalized prayers and offerings',
          ],
          buttonText: 'Book Online Pooja',
        },
        bhaktiDarshan: {
          title: 'Bhakti Darshan',
          subtitle: 'Stay connected to the divine, wherever you are',
          description: 'Experience the divine presence through our live streaming of temple darshan from renowned spiritual centers. Join thousands of devotees in real-time worship and receive blessings from sacred deities.',
          features: [
            'Discover the Divine Essence of India’s Sacred Temples',
            'Immerse Yourself in Rich, Soulful Spiritual Experiences',
            'Feel the Presence of the Divine in Every Moment',
          ],
          buttonText: 'Watch Bhakti Darshan',
          secondaryButtonText: 'Bhakti Bal-Chitrakatha',
        },
        bhaktiStore: {
          title: 'Bhakti Store',
          subtitle: 'Sacred items, books, and spiritual offerings for your journey',
          description: 'Discover a curated collection of spiritual items, sacred books, meditation tools, and devotional offerings. Each item is carefully selected to enhance your spiritual practice.',
          features: [
            'Sacred idols and deities',
            'Spiritual books and scriptures',
            'Meditation and yoga accessories',
            'Incense, candles, and offerings',
          ],
          buttonText: 'Visit Store',
        },
        bhaktiYoga: {
          title: 'Bhakti Yoga',
          subtitle: 'Yoga practices that connect body, mind, and spirit',
          description: 'Experience the transformative power of Bhakti Yoga, where physical postures meet spiritual devotion. Our classes combine traditional yoga with devotional practices for complete spiritual growth.',
          features: [
            'Traditional Yoga, Pranayam & Asana',
            'Devotional chanting and mantras',
            'Meditation and pranayama',
            'Spiritual philosophy integration',
          ],
          buttonText: 'Join Yoga Courses',
        },
        bhaktiJaapa: {
          title: 'Bhakti Jaapa',
          subtitle: 'Track and deepen your daily mantra chanting practice',
          description: 'Maintain a consistent spiritual practice with our Jaapa tracker. Log your daily mantra repetitions, track your progress over time, and build a powerful habit of devotional chanting.',
          features: [
            'Daily mantra chanting tracker',
            'Progress logs and streaks',
            'Multiple mantra support',
            'Personal spiritual journal',
          ],
          buttonText: 'Start Jaapa Practice',
        },
        upcoming: {
          title: 'Other Upcoming Services',
          subtitle: 'Stay tuned with us for upcoming services like...',
          features: [
            'AI Astrology & Daily Horoscope: Integrate personalized Kundli/Birth Chart analysis, daily "Shubh Muhurat" (auspicious timings), and AI-driven personalized remedies.',
            'Virtual "Seva" & Charity: Allow users to perform Gau Seva (cow feeding), Brahmin Bhojan, or donate to specific temple renovation projects with digital certificates and video proof.',
            'Subscription-based "Nirantar Chadhava": Automated weekly or monthly offerings (flowers/sweets) made in the user\'s name at a chosen temple.',
            'Spiritual Content Feed: Short-form video content including Kathas, daily mantras, and explanations of Hindu rituals to educate younger users.',
          ],
        },
      },
      contact: {
        mailSubject: 'Customer Feedback for Anandmaya',
        getInTouch: 'Get in Touch',
        subtitle: 'We\'d love to hear from you and help you on your spiritual journey',
        address: 'Address',
        addressLine1: 'Bhubaneswar',
        addressLine2: 'Odisha, India 751006',
        phone: 'Phone',
        email: 'Email',
        prompt: 'Have a question or a special request? Click the button below to send us an email directly from your favorite email application.',
        sendEmail: 'Send an Email',
      },
    },
    onlinePooja: {
      pageHeader: {
        title: 'Online Pooja Services',
        subtitle: 'Book your sacred ceremony and receive divine blessings from home.',
      },
      poojaTypes: {
        sectionTitle: 'Book Your Online Pooja',
        sectionSubtitle: 'Choose from our various pooja services designed for different occasions and needs',
        mostPopular: 'Most Popular',
        bookNow: 'Book Now',
        items: {
          daily: {
            title: 'Daily Pooja',
            description: 'Regular daily prayers for spiritual well-being.',
          },
          special: {
            title: 'Special Occasion Pooja',
            description: 'Customized pooja for birthdays, anniversaries, and special milestones.',
          },
          festival: {
            title: 'Festival Pooja',
            description: 'Ceremonies for major Hindu festivals.',
          },
          remedial: {
            title: 'Remedial Pooja',
            description: 'To overcome obstacles and bring positive energy.',
          },
          'house-warming': {
            title: 'House Warming Pooja',
            description: 'Sacred ceremony for blessing new homes.',
          },
          success: {
            title: 'Success Pooja',
            description: 'For academic success and career growth.',
          },
        },
      },
      bookingForm: {
        title: 'Book Your Pooja',
        subtitle: 'Fill in the details to book your sacred ceremony',
        labels: {
          poojaType: 'Select Pooja Type',
          temple: 'Select Temple',
          preferredDate: 'Preferred Date',
          preferredTime: 'Preferred Time',
          devoteeName: 'Devotee Name',
          email: 'Email Address',
          phone: 'Phone Number',
          upiId: 'UPI ID (Optional)',
          specialRequests: 'Special Requests (Optional)',
        },
        placeholders: {
          choosePoojaType: 'Choose Pooja Type',
          chooseTemple: 'Choose Temple',
          selectTime: 'Select Time',
          devoteeName: 'Enter your full name',
          email: 'Enter your email',
          phone: 'Enter your phone number',
          upiId: 'yourname@bank',
          specialRequests: 'Enter your complete address with pincode to receive deliverables (Prashad, Pooja mala/phool, Kumkum/Haldi/Chandan/Vibhuti, Pooja incense sticks, etc.)',
        },
        errors: {
          selectPoojaType: 'Please select a pooja type',
          selectTemple: 'Please select a temple',
          selectDate: 'Please select a date',
          selectTime: 'Please select a time',
          enterName: 'Please enter your name',
          validEmail: 'Please enter a valid email',
          validPhone: 'Please enter a valid phone number',
          validUpi: 'Please enter a valid UPI ID (example: name@bank)',
        },
        submit: {
          processing: 'Processing...',
          proceedToPayment: 'Proceed to Payment',
        },
        toasts: {
          loginRequired: 'Please log in to book a pooja.',
          poojaDetailsMissing: 'Could not find pooja details for payment.',
          bookingCreationFailed: 'Booking creation failed.',
          orderCreationFailed: 'Failed to create payment order.',
          bookingConfirmed: 'Booking confirmed!',
          viewBookings: 'View Bookings',
          paymentVerificationFailed: 'Payment verification failed.',
          paymentCancelled: 'Payment was cancelled. Your booking is pending payment.',
        },
        paymentDescription: 'Payment for {{title}}',
        temples: {
          varanasi: 'Kashi Vishwanath Temple, Varanasi',
          jagannath: 'Jagannath Temple, Puri',
          sidhhaMahavir: 'Sidhha Mahavir Temple, Puri',
          navaGraha: 'Nava Graha Temple, Puri',
          loknath: 'Lokanath Temple, Puri',
          mangala: 'Bata Mangala Temple, Puri',
          cuttackChandi: 'Chandi Temple, Cuttack',
          ugraTara: 'Ugra Tara Temple, Khordha',
          tarini: 'Tarini Temple',
          mahavir: 'Shiruli Mahavir Temple, Puri',
          mangalnath: 'Mangalnath Temple, Ujjain',
          lakshmi: 'Lakshmi Temple, Puri',
          vimala: 'Vimala Temple, Puri',
          bhubaneswari: 'Bhubaneswari Temple, Bhubaneswar',
          bagalamukhi: 'Maa Bagalamukhi Temple, Puri',
          lingaraj: 'Lingaraj Temple, Bhubaneswar',
        },
        timeSlots: {
          '06_00': '6:00 AM',
          '08_00': '8:00 AM',
          '10_00': '10:00 AM',
          '12_00': '12:00 PM',
          '14_00': '2:00 PM',
          '16_00': '4:00 PM',
          '18_00': '6:00 PM',
          '20_00': '8:00 PM',
        },
      },
      howItWorks: {
        title: 'How Online Pooja Works',
        subtitle: 'Simple steps to book and participate in our sacred ceremonies',
        steps: [
          {
            title: 'Choose Your Pooja',
            description: 'Select the type of pooja that suits your needs and occasion',
          },
          {
            title: 'Book & Pay',
            description: 'Complete your booking and make secure payment online',
          },
          {
            title: 'Receive Details',
            description: 'Get confirmation with pooja details and live streaming link',
          },
        ],
      },
      testimonials: {
        title: 'What Our Devotees Say',
        subtitle: 'Experiences from our community of spiritual seekers',
        items: [
          {
            content: 'The online pooja experience was truly divine. I felt connected to the divine energy even from miles away. The priest was very knowledgeable and the ceremony was conducted with utmost devotion.',
            author: 'Priya Sharma',
            location: 'Mumbai, India',
          },
          {
            content: 'I was skeptical about online pooja initially, but the experience exceeded my expectations. The quality of the ceremony and the spiritual energy was incredible. Highly recommended!',
            author: 'Rajesh Kumar',
            location: 'Delhi, India',
          },
          {
            content: 'As someone living abroad, this online pooja service has been a blessing. I can now participate in traditional ceremonies and maintain my spiritual connection with my roots.',
            author: 'Anita Patel',
            location: 'New York, USA',
          },
        ],
      },
    },
    bhaktiStore: {
      pageHeader: {
        title: 'Bhakti Store',
        subtitle: 'Discover a curated collection of sacred items for your spiritual journey.',
      },
      loadingProducts: 'Loading Products...',
      errorPrefix: 'Error',
      messages: {
        fetchFailed: 'Failed to fetch products',
        addedToCart: 'Added to cart!',
        viewCart: 'View Cart',
        noProductsInCategory: 'No products found in this category.',
        outOfStock: 'This product is out of stock.',
      },
      actions: {
        addToCart: 'Add to Cart',
        buyNow: 'Buy Now',
        outOfStock: 'Out of Stock',
      },
      categories: {
        allProducts: 'All Products',
        sacred_idols: 'Sacred Idols',
        malas_and_beads: 'Malas & Beads',
        spiritual_books: 'Spiritual Books',
        incense_and_fragrance: 'Incense & Fragrance',
        pooja_items: 'Pooja Items',
        yoga_accessories: 'Yoga Accessories',
      },
      products: {
        sacred_ganesha_idol: {
          name: 'Sacred Ganesha Idol',
          description: 'Beautiful brass Ganesha idol for home worship and blessings of prosperity.',
        },
        rudraksha_panch_mukhi_original: {
          name: 'Rudraksha Panch Mukhi (Original)',
          description: 'Authentic Panch Mukhi Rudraksha for chanting and spiritual well-being.',
        },
        rudraksha_mala: {
          name: 'Rudraksha Mala',
          description: 'Authentic 108-bead 5-mukhi Rudraksha mala for meditation and Japa.',
        },
        bhagavad_gita_book: {
          name: 'Bhagavad Gita Book',
          description: 'The complete Bhagavad Gita with detailed commentary and translation.',
        },
        sandalwood_incense: {
          name: 'Sandalwood Incense',
          description: 'Pack of 50 pure, aromatic sandalwood incense sticks for pooja and meditation.',
        },
        copper_pooja_thali: {
          name: 'Copper Pooja Thali',
          description: 'A traditional, beautifully crafted copper pooja thali set for daily rituals.',
        },
        crystal_shiva_lingam: {
          name: 'Crystal Shiva Lingam',
          description: 'A natural, high-quality crystal Shiva Lingam for powerful meditation and energy.',
        },
        eco_friendly_yoga_mat: {
          name: 'Eco-Friendly Yoga Mat',
          description: 'A non-slip, eco-friendly yoga mat for your spiritual and physical practice.',
        },
        tulsi_mala: {
          name: 'Tulsi Mala',
          description: 'A sacred 108-bead Tulsi wood mala for chanting and wearing.',
        },
      },
    },
    checkout: {
      emptyCartTitle: 'Your cart is empty.',
      continueShopping: 'Continue Shopping',
      title: 'Checkout',
      form: {
        shippingAddress: 'Shipping Address',
        address: 'Address',
        city: 'City',
        state: 'State',
        postalCode: 'Postal Code',
        countryDisplay: 'India',
        phoneNumber: 'Phone Number',
        gstNumberLabel: 'GST Number (Optional)',
        gstNumberPlaceholder: 'e.g., 22AAAAA0000A1Z5',
        upiIdLabel: 'UPI ID (Optional)',
        upiIdPlaceholder: 'yourname@bank',
      },
      actions: {
        processing: 'Processing...',
        pay: 'Pay ₹{{amount}}',
      },
      orderSummary: {
        title: 'Order Summary',
        itemLine: '{{name}} x {{quantity}}',
        total: 'Total',
      },
      errors: {
        invalidUpi: 'Please enter a valid UPI ID (example: name@bank).',
        paymentFailedPrefix: 'Payment failed',
        unexpected: 'An unexpected error occurred.',
      },
    },
    coursePlayer: {
      loading: 'Loading Course Player...',
      errorPrefix: 'Error',
      courseContentNotFound: 'Course content not found.',
      progressComplete: '{{percent}}% Complete ({{completed}}/{{total}})',
      nonVideoFallback: 'This lesson\'s primary content is a downloadable resource.',
      lockedContentTitle: 'This Content is Locked',
      lockedContentMessage: 'This module is only available for \'{{tier}}\' subscribers.',
      upgradePlan: 'Upgrade Your Plan',
      completed: '✓ Completed',
      markAsComplete: 'Mark as Complete',
      viewOrDownloadNotes: 'View or Download Notes',
      welcomeTitle: 'Welcome!',
      selectLessonPrompt: 'Select a lesson from the sidebar to begin your journey.',
      errors: {
        fetchCourseContent: 'Failed to fetch course content.',
      },
    },
    shoppingCart: {
      title: 'Your Cart',
      closeCart: 'Close cart',
      emptyTitle: 'Your cart is empty',
      emptyDescription: 'Add some spiritual items to get started.',
      subtotal: 'Subtotal',
      proceedToCheckout: 'Proceed to Checkout',
      decreaseQuantity: 'Decrease quantity for {{name}}',
      increaseQuantity: 'Increase quantity for {{name}}',
      removeItem: 'Remove {{name}} from cart',
      outOfStockRemovedMessage: 'These product(s) are out of stock and were removed from your cart: {{items}}',
      quantityExceedsStockMessage: 'Requested quantity exceeds available stock. Please reduce the quantity to proceed.',
    },
    bhaktiYogaPage: {
      header: {
        title: 'Bhakti Yoga Courses',
        subtitle: 'Embark on a transformative journey with our curated courses for spiritual, physical, and mental wellness.',
      },
      loadingCourses: 'Loading Courses...',
      errorPrefix: 'Error',
      noCoursesMessage: 'No courses are available at the moment. Please check back later.',
      errors: {
        loadCourses: 'Failed to load courses.',
      },
      levels: {
        beginner: 'Beginner',
        intermediate: 'Intermediate',
        advanced: 'Advanced',
        all_levels: 'All Levels',
        all_level: 'All Level',
        all_ages: 'All Ages',
        children: 'Children',
        special: 'Special',
      },
      tiers: {
        free: 'Free',
        plus: 'Plus',
        premium: 'Premium',
      },
      catalogues: {},
      courses: {},
    },
    bhaktiYogaCourseDetail: {
      loadingCourse: 'Loading Course...',
      errorPrefix: 'Error',
      courseNotFound: 'Course not found.',
      minutesShort: 'min',
      sections: {
        aboutThisCourse: 'About this Course',
        curriculum: 'Curriculum',
      },
      actions: {
        goToCourse: 'Go to Course',
        loginToEnroll: 'Login to Enroll',
        processing: 'Processing...',
        startCourse: 'Start Course',
        enrolling: 'Enrolling...',
        enrollForFree: 'Enroll for Free',
        subscribeToTier: 'Subscribe to {{tier}}',
      },
      form: {
        upiIdLabel: 'UPI ID (Optional)',
        upiIdPlaceholder: 'yourname@bank',
      },
      sidebar: {
        fullAccessNote: 'Full access to all course videos and notes upon enrollment.',
      },
      errors: {
        loadCourseDetails: 'Failed to load course details.',
        invalidUpi: 'Please enter a valid UPI ID (example: name@bank).',
        unexpected: 'An unexpected error occurred.',
      },
      courses: {},
      modules: {},
      lessons: {},
    },
    bhaktiJaapaPage: {
      header: {
        title: 'Bhakti Jaapa',
        subtitle: 'A sacred space for your daily chanting practice.',
      },
      settings: {
        chooseDivineName: 'Choose a Divine Name:',
      },
      chantingArea: {
        tapToChant: 'Tap to Chant',
      },
      counters: {
        sessionJaapa: 'Session Jaapa',
        malasCompleted: 'Malas Completed',
      },
      analytics: {
        todaysTotalJaapas: 'Today\'s Total Jaapas',
        todaysMalasCompleted: 'Today\'s Malas Completed',
        viewMyAnalytics: 'View My Analytics',
      },
      voiceSelector: {
        loadingVoices: 'Loading voices...',
        selectVoice: 'Select Voice:',
        silent: 'Silent',
        hindiIndian: 'Hindi Voice (India)',
        hindiIndianCloser: 'Hindi Voice (India - Clear)',
      },
      soundToggle: {
        toggleBackgroundSound: 'Toggle background sound',
        backgroundFlute: 'Background Flute',
        mute: 'Mute',
        unmute: 'Unmute',
      },
      divineNames: {
        omNamahaShivaya: 'Om Namaha Shivaya',
        omNamahShivaya: 'Om Namah Shivaya',
        jaiShreeKrishna: 'Jai Shree Krishna',
        jaiShreeRam: 'Jai Shree Ram',
        shreeRadha: 'Shree Radha',
        sitaRam: 'Sita Ram',
        omGanGanapatayeNamah: 'Om Gan Ganapataye Namah',
        omRudrayaNamah: 'Om Rudraya Namah',
        radheKrishna: 'Radhe Krishna',
        omSaiRam: 'Om Sai Ram',
        omKalabhiravayNamah: 'Om Kalabhiravay Namah',
        shreem: 'Shreem',
        aim: 'Aim',
        hareKrishnaMahaMantra: 'Hare Krishna Hare Krishna\nKrishna Krishna Hare Hare\nHare Rama Hare Rama\nRama Rama Hare Hare',
        // Backward compatibility for historical entries.
        hareKrishna: 'Hare Krishna',
        shreeRam: 'Shree Ram',
        shreeKrishna: 'Shree Krishna',
        jaiMaaDurga: 'Jai Maa Durga',
        maaDurga: 'Maa Durga',
        jaiHanuman: 'Jai Hanuman',
        hanuman: 'Hanuman',
      },
    },
    dashboard: {
      sidebar: {
        myPoojaBookings: 'My Pooja Bookings',
        myStoreOrders: 'My Store Orders',
        myCourses: 'My Courses',
        jaapaAnalytics: 'Jaapa Analytics',
        myProfile: 'My Profile',
        menu: 'Menu',
      },
      common: {
        errorPrefix: 'Error',
        status: {
          pending: 'Pending',
          paid: 'Paid',
          completed: 'Completed',
          failed: 'Failed',
          cancelled: 'Cancelled',
          canceled: 'Canceled',
          processing: 'Processing',
          shipped: 'Shipped',
          delivered: 'Delivered',
          refunded: 'Refunded',
        },
      },
      bookings: {
        loading: 'Loading your bookings...',
        emptyMessage: 'You have not booked any poojas yet.',
        bookNow: 'Book a Pooja Now',
        fields: {
          bookingId: 'Booking ID',
          temple: 'Temple',
          date: 'Date',
          time: 'Time',
          bookedOn: 'Booked on',
        },
        errors: {
          fetchFailed: 'Failed to fetch bookings',
        },
      },
      orders: {
        loading: 'Loading your orders...',
        emptyMessage: 'You have not placed any orders yet.',
        shopNow: 'Shop Now',
        orderLabel: 'Order',
        placedOn: 'Placed on',
        quantity: 'Quantity',
        total: 'Total',
        errors: {
          fetchFailed: 'Failed to fetch orders',
        },
      },
      courses: {
        title: 'My Bhakti Yoga Courses',
        loading: 'Loading your courses...',
        emptyMessage: 'You are not enrolled in any courses yet.',
        exploreCourses: 'Explore Courses',
        courseTitleMissing: 'Course Title Missing',
        progressComplete: '{{percent}}% Complete',
        resumeCourse: 'Resume Course',
        startCourse: 'Start Course',
        errors: {
          fetchFailed: 'Failed to fetch courses',
        },
      },
      profile: {
        loading: 'Loading profile...',
        loadFailed: 'Could not load user profile. Please try logging in again.',
        avatarAlt: 'User Avatar',
        confirmChangePassword: 'You will be logged out to securely change your password. Do you want to continue?',
        fields: {
          fullName: 'Full Name',
          emailAddress: 'Email Address',
          role: 'Role',
          memberSince: 'Member Since',
        },
        editProfile: 'Edit Profile',
        changePassword: 'Change Password',
      },
    },
    jaapaAnalyticsPage: {
      title: 'My Jaapa Analytics',
      actions: {
        backToBhaktiJaapa: 'Back to Bhakti Jaapa',
      },
      loadingAnalytics: 'Loading analytics...',
      errorPrefix: 'Error',
      filters: {
        today: 'Today',
        thisWeek: 'This Week',
        thisMonth: 'This Month',
        allTime: 'All Time',
      },
      cards: {
        totalJaapas: 'Total Jaapas',
        malasCompleted: 'Malas Completed',
      },
      breakdown: {
        title: 'Mantra Breakdown',
        chants: 'chants',
        malaSingular: 'mala',
        malasPlural: 'malas',
        noData: 'No chanting recorded for this period.',
        startChanting: 'Start Chanting',
      },
      errors: {
        fetchFailed: 'Failed to fetch analytics',
      },
    },
    liveDarshan: {
      header: {
        title: 'Bhakti Darshan',
        subtitle: 'Watch sacred darshan from temples and shrines across India.',
      },
      liveBadge: 'LIVE',
      iframeTitle: 'Bhakti Darshan - {{name}}',
      temples: {
        'puri-jagannath': {
          name: 'Puri Jagannath Temple (Source: Jai Jagannath TV)',
          location: 'Puri, Odisha',
        },
        'kashi-vishwanath': {
          name: 'Kashi Vishwanath Temple',
          location: 'Varanasi, Uttar Pradesh',
        },
        'shirdi-sai': {
          name: 'Shirdi Sai Baba Temple',
          location: 'Shirdi, Maharashtra',
        },
        'somnath-temple': {
          name: 'Somnath Temple',
          location: 'Veraval, Gujarat',
        },
        'vaishno-devi': {
          name: 'Vaishno Devi Temple',
          location: 'Katra, Jammu & Kashmir',
        },
        'golden-temple': {
          name: 'Golden Temple (Harmandir Sahib)',
          location: 'Amritsar, Punjab',
        },
        'tirupati-balaji': {
          name: 'Tirupati Balaji Temple',
          location: 'Tirupati, Andhra Pradesh',
        },
        rameshwaram: {
          name: 'Rameshwaram Temple',
          location: 'Rameshwaram, Tamil Nadu',
        },
        'Vitthal-Rukmini': {
          name: 'Vitthal-Rukmini Temple',
          location: 'Pandharpur, Maharashtra',
        },
        Dwarkadhish: {
          name: 'Dwarkadhish Temple',
          location: 'Dwarka, Gujarat',
        },
        Sidhhivinayak: {
          name: 'Siddhivinayak Temple',
          location: 'Mumbai, Maharashtra',
        },
        'ISKCON-Vrindavan': {
          name: 'ISKCON Temple',
          location: 'Vrindavan, Uttar Pradesh',
        },
      },
    },
    bhaktiSamadhan: {
      hero: {
        title: 'Bhakti AI Guru',
        subtitle: 'Intelligent Guidance: Divine Guidance for Your Life\'s Sacred Journey',
      },
      tabs: {
        askAdvisor: 'Ask Advisor',
        chat: 'Chat',
        browseRemedies: 'Browse Remedies',
      },
      advisor: {
        describeTitle: 'Describe Your Situation',
        describeDesc: 'Tell us about your current situation or what you\'re seeking blessings for, and our AI Bhakti Guru will recommend the most suitable pooja and deity.',
        placeholder: 'e.g., Advise me for a pooja to remove obstacle of my son\'s upcoming important exam',
        gettingRecommendation: 'Getting Recommendation...',
        getRecommendation: 'Get Recommendation',
        consultingWisdom: 'Consulting spiritual wisdom...',
        spiritualGuidance: 'Spiritual Guidance',
        noRecommendation: 'No recommendation available.',
        genericError: 'Sorry, something went wrong. Please try again.',
      },
      guest: {
        defaultLimitMessage: 'Daily limit exceeded. You have reached the maximum of 3 requests per day as a guest user. Please log in or sign up to continue with unlimited access.',
        tryAgainAfter: '{{baseMessage}} You can also try again after {{time}}.',
      },
      chat: {
        genericError: 'I apologize, something went wrong. Please try again.',
        historyTitle: 'Chat History',
        newChat: 'New Chat',
        loading: 'Loading...',
        noConversations: 'No conversations yet',
        untitled: 'Untitled',
        deleteConversation: 'Delete conversation',
        spiritualChat: 'Spiritual Chat',
        namaste: 'Namaste!',
        emptyPrompt: 'Ask me about Vedic knowledge, poojas, mantras, astrology, yoga, meditation, or any spiritual queries.',
        guestModeInfo: 'Guest mode — 3 messages/day. Log in for unlimited queries to ask',
        suggestions: [
          'What is the significance of Hanuman Chalisa?',
          'Which pooja should I do for career growth?',
          'Explain Karma in Bhagavad Gita',
          'Benefits of chanting Om Namah Shivaya?',
          'How can I reduce negative thoughts spiritually?',
          'Which mantra is best for mental peace and focus?',
          'What pooja can help with marriage delays?',
          'How do I bring more positivity into my home?',
          'Which spiritual practice helps with stress and anxiety?',
          'What remedy is best for family harmony?'
        ],
        askPlaceholder: 'Ask your spiritual question...',
        askButton: 'Ask',
      },
      categories: {
        education: 'Education',
        career: 'Career',
        marriage: 'Marriage',
        health: 'Health',
        wealth: 'Wealth',
        family: 'Family',
        protection: 'Protection',
        children: 'Children',
        spiritualGrowth: 'Spiritual Growth',
        allRemedies: 'All Remedies',
      },
      remedies: {
        browseByCategory: 'Browse by Category',
        primaryDeity: 'Primary Deity',
        recommendedPoojas: 'Recommended Poojas',
        morePrompt: 'Tell me more about {{title}} — {{desc}}',
        wealthFinancialProsperity: {
          title: 'Wealth And Financial Prosperity',
          desc: 'For attaining financial stability, business success, and material prosperity',
          deity: 'Lakshmi',
          deityDesc: 'Lakshmi is the supreme source of all wealth, abundance, and prosperity. She blesses with financial success and material comfort.',
          poojas: ['Lakshmi-Archana', 'Lakshmi-Homam', 'Lakshmi-Sahasranam', 'Kuber-Pooja'],
        },
        familyHarmonyHouseholdPeace: {
          title: 'Family Harmony And Household Peace',
          desc: 'For creating peaceful home environment, resolving family conflicts, and maintaining domestic harmony',
          deity: 'Annapurna',
          deityDesc: 'Annapurna symbolizes nurturing, care, and family well-being. She ensures household harmony and prosperity.',
          poojas: ['Annapurna-Archana', 'Durga-Saptashati', 'Ganesha-Maha-Puja', 'House-Blessing-Havan'],
        },
        academicExcellenceKnowledge: {
          title: 'Academic Excellence And Knowledge',
          desc: 'For success in studies, exams, and acquiring deep knowledge and wisdom',
          deity: 'Saraswati',
          deityDesc: 'Saraswati is the goddess of knowledge, music, and learning. She bestows wisdom, intellect, and academic success.',
          poojas: ['Saraswati-Pooja', 'Hayagriva-Homam', 'Vidya-Lakshmi-Pooja', 'Aksharabhyasam'],
        },
        careerGrowthProfessionalSuccess: {
          title: 'Career Growth And Professional Success',
          desc: 'For job promotions, business growth, removing professional obstacles, and achieving career goals',
          deity: 'Ganesha',
          deityDesc: 'Ganesha is the remover of obstacles and the lord of new beginnings. He clears the path for career advancement.',
          poojas: ['Ganesha-Homam', 'Navagraha-Pooja', 'Vishnu-Sahasranam', 'Shani-Pooja'],
        },
        marriageRelationshipBliss: {
          title: 'Marriage And Relationship Bliss',
          desc: 'For finding the right partner, happy married life, and resolving relationship issues',
          deity: 'Parvati',
          deityDesc: 'Parvati is the goddess of love, devotion, and marital harmony. She blesses with strong and lasting relationships.',
          poojas: ['Swayamvara-Parvati-Homam', 'Mangala-Gauri-Pooja', 'Vivah-Panchami-Pooja', 'Katyayani-Pooja'],
        },
        healthHealing: {
          title: 'Health And Healing',
          desc: 'For recovery from illness, maintaining good health, longevity, and overall physical well-being',
          deity: 'Dhanvantari',
          deityDesc: 'Dhanvantari is the divine physician and god of Ayurveda. He grants healing, health, and freedom from disease.',
          poojas: ['Maha-Mrityunjaya-Jaap', 'Dhanvantari-Homam', 'Sudarshana-Homam', 'Ayush-Homam'],
        },
        protectionSafety: {
          title: 'Protection And Safety',
          desc: 'For shielding from negative energies, evil eye, and ensuring safety of family and property',
          deity: 'Hanuman',
          deityDesc: 'Hanuman is the embodiment of strength, courage, and devotion. He protects devotees from all dangers and evil forces.',
          poojas: ['Hanuman-Chalisa-Path', 'Sudarshana-Homam', 'Durga-Kavach-Path', 'Baglamukhi-Pooja'],
        },
        childrenProgeny: {
          title: 'Children And Progeny',
          desc: 'For blessed parenthood, child health, academic success of children, and their overall well-being',
          deity: 'Santoshi Maa',
          deityDesc: 'Santoshi Maa is the goddess of satisfaction and happiness. She blesses families with healthy children and contentment.',
          poojas: ['Santana-Gopala-Homam', 'Putrakameshti-Yajna', 'Garba-Raksha-Pooja', 'Santoshi-Maa-Vrat'],
        },
        spiritualAwakeningInnerPeace: {
          title: 'Spiritual Awakening And Inner Peace',
          desc: 'For deepening meditation, spiritual progress, attaining inner peace, and self-realization',
          deity: 'Shiva',
          deityDesc: 'Shiva is the supreme consciousness, the lord of meditation and transformation. He grants liberation and inner peace.',
          poojas: ['Rudra-Abhishek', 'Maha-Shivaratri-Pooja', 'Lingashtakam-Path', 'Dhyana-Pooja'],
        },
      },
    },
  },
  hi: {
    nav: {
      home: 'होम',
      bhaktiSamadhan: 'भक्ति समाधान',
      onlinePooja: 'ऑनलाइन पूजा',
      bhaktiDarshan: 'भक्ति दर्शन',
      bhaktiStore: 'भक्ति स्टोर',
      bhaktiYoga: 'भक्ति योग',
      bhaktiJaapa: 'भक्ति जाप',
      bhaktiBalChitraKatha: 'बाल चित्र कथा',
      dashboard: 'डैशबोर्ड',
      adminPanel: 'एडमिन पैनल',
      logout: 'लॉग आउट',
      login: 'लॉग इन',
      signUp: 'साइन अप',
      selectLanguage: 'भाषा चुनें',
      language: 'भाषा',
      openShoppingCart: 'शॉपिंग कार्ट खोलें',
    },
    footer: {
      contact: 'संपर्क',
      allRightsReserved: 'सर्वाधिकार सुरक्षित।',
    },
    auth: {
      login: {
        welcomeBack: 'वापसी पर स्वागत है',
        subtitle: 'अपनी आध्यात्मिक यात्रा जारी रखने के लिए साइन इन करें',
        googleTermsPrefix: 'Google से साइन इन करके आप हमारी',
        termsAndPrivacy: 'नियम एवं शर्तें और गोपनीयता नीति',
        separator: 'या',
        redirectMessage: 'जिस पेज को आप देखना चाहते थे, उसे देखने के लिए लॉगिन आवश्यक है।',
        emailAddress: 'ईमेल पता',
        enterEmail: 'अपना ईमेल दर्ज करें',
        password: 'पासवर्ड',
        enterPassword: 'अपना पासवर्ड दर्ज करें',
        rememberMe: 'मुझे याद रखें',
        forgotPassword: 'पासवर्ड भूल गए?',
        signingIn: 'साइन इन हो रहा है...',
        signIn: 'साइन इन',
        noAccount: 'क्या आपका खाता नहीं है?',
        signUp: 'साइन अप',
        welcomeToast: 'फिर से स्वागत है, {{name}}!',
        emailRequired: 'ईमेल आवश्यक है',
        emailInvalid: 'ईमेल मान्य नहीं है',
        passwordRequired: 'पासवर्ड आवश्यक है',
        passwordMin: 'पासवर्ड कम से कम 6 अक्षरों का होना चाहिए',
        loginFailed: 'लॉगिन विफल रहा। कृपया पुनः प्रयास करें।',
      },
      signup: {
        joinAnandmaya: 'आनंदमय से जुड़ें',
        subtitle: 'हमारे साथ अपनी आध्यात्मिक यात्रा शुरू करें',
        firstName: 'पहला नाम',
        enterFirstName: 'पहला नाम दर्ज करें',
        lastName: 'अंतिम नाम',
        enterLastName: 'अंतिम नाम दर्ज करें',
        emailAddress: 'ईमेल पता',
        enterEmail: 'अपना ईमेल दर्ज करें',
        password: 'पासवर्ड',
        createPassword: 'पासवर्ड बनाएं',
        confirmPassword: 'पासवर्ड की पुष्टि करें',
        confirmPasswordPlaceholder: 'अपने पासवर्ड की पुष्टि करें',
        agreeToPrefix: 'मैं',
        termsAndConditions: 'नियम एवं शर्तों',
        and: 'और',
        privacyPolicy: 'गोपनीयता नीति',
        creatingAccount: 'खाता बनाया जा रहा है...',
        createAccount: 'खाता बनाएं',
        alreadyHaveAccount: 'क्या आपका पहले से खाता है?',
        signIn: 'साइन इन',
        accountCreatedAlert: 'खाता सफलतापूर्वक बन गया! आनंदमय में आपका स्वागत है!',
        firstNameRequired: 'पहला नाम आवश्यक है',
        lastNameRequired: 'अंतिम नाम आवश्यक है',
        emailRequired: 'ईमेल आवश्यक है',
        emailInvalid: 'ईमेल मान्य नहीं है',
        passwordRequired: 'पासवर्ड आवश्यक है',
        passwordMin: 'पासवर्ड कम से कम 6 अक्षरों का होना चाहिए',
        confirmPasswordRequired: 'कृपया पासवर्ड की पुष्टि करें',
        passwordsNoMatch: 'पासवर्ड मेल नहीं खाते',
        agreeToTermsRequired: 'आपको नियम एवं शर्तें स्वीकार करनी होंगी',
        registrationFailed: 'पंजीकरण विफल रहा। कृपया पुनः प्रयास करें।',
      },
    },
    home: {
      hero: {
        liveDarshan: 'दिव्य दर्शन',
        watchNow: 'अभी देखें',
        bhakti: 'भक्ति',
        balChitrakatha: 'बाल-चित्रकथा',
        mindBodySoul: 'शरीर ~ मन ~ आत्मा',
        subtitle: 'भक्ति, आध्यात्मिक ज्ञान और शारीरिक संतुलन की राह खोजें',
        deviGalleryAria: 'घूमती हुई देवी गैलरी',
        cards: {
          bhaktiSamadhan: {
            title: 'भक्ति\nसमाधान',
            description: 'पूजा, मंत्र और वैदिक उपायों पर एआई-आधारित आध्यात्मिक मार्गदर्शन।',
          },
          onlinePooja: {
            title: 'ऑनलाइन पूजा',
            description: 'घर बैठे पवित्र वैदिक अनुष्ठानों में भाग लें।',
          },
          bhaktiDarshan: {
            title: 'भक्ति\nदर्शन',
            description: 'भारत के प्रमुख मंदिरों से रीयल-टाइम दिव्य दर्शन।',
          },
          bhaktiStore: {
            title: 'भक्ति स्टोर',
            description: 'आपकी साधना यात्रा के लिए चुने हुए आध्यात्मिक उत्पाद, मूर्तियां और पुस्तकें।',
          },
          bhaktiYoga: {
            title: 'भक्ति योग',
            description: 'भक्ति योग साधना से शरीर, मन और आत्मा को जोड़ें।',
          },
          bhaktiJaapa: {
            title: 'भक्ति जाप',
            description: 'अपने दैनिक मंत्र-जाप अभ्यास को ट्रैक करें और गहराई दें।',
          },
        },
        deity: {
          maaDurga: 'मां दुर्गा',
          goddessSaraswati: 'देवी सरस्वती',
          maaParvati: 'मां पार्वती',
          maaKali: 'मां काली',
          maaLakshmi: 'मां लक्ष्मी',
          lordGanesha: 'भगवान गणेश',
          lordHanuman: 'भगवान हनुमान',
          lordShiva: 'भगवान शिव',
          lordVishnu: 'भगवान विष्णु',
          lordKrishna: 'भगवान कृष्ण',
          lordMurugan: 'भगवान मुरुगन',
          lordBrahma: 'भगवान ब्रह्मा',
          maaBagalamukhi: 'मां बगलामुखी',
          lordKubera: 'भगवान कुबेर',
          lordShani: 'भगवान शनि',
          navgraha: 'नवग्रह',
          vastuPurusha: 'वास्तु पुरुष',
          guru: 'आध्यात्मिक गुरु',
        },
      },
      sections: {
        bhaktiSamadhan: {
          title: 'भक्ति समाधान',
          subtitle: 'आपकी जीवन परिस्थितियों के लिए एआई-आधारित आध्यात्मिक मार्गदर्शन',
          description: 'एआई द्वारा समर्थित व्यक्तिगत वैदिक मार्गदर्शन प्राप्त करें। पूजा, मंत्र, ज्योतिष, ध्यान या किसी भी आध्यात्मिक प्रश्न के बारे में पूछें। स्वास्थ्य, धन, करियर, संबंध आदि के लिए चुने हुए वैदिक उपाय देखें।',
          features: [
            'एआई-आधारित पूजा सिफारिशें',
            'व्यक्तिगत आध्यात्मिक चैट सहायक',
            'श्रेणीवार चुने हुए वैदिक उपाय',
            'पवित्र ग्रंथों से संदर्भ',
          ],
          buttonText: 'आध्यात्मिक मार्गदर्शन प्राप्त करें',
        },
        onlinePooja: {
          title: 'ऑनलाइन पूजा',
          subtitle: 'दुनिया में कहीं से भी पवित्र पूजा और प्रार्थना करें',
          description: 'हमारे ऑनलाइन मंच के माध्यम से पारंपरिक पूजा विधियों की शक्ति का अनुभव करें। हमारे अनुभवी पुजारी लाइव पूजा सत्र करते हैं, जिनमें आप घर बैठे भाग ले सकते हैं।',
          features: [
            'व्यक्तिगत प्रार्थनाएं और अर्पण',
          ],
          buttonText: 'ऑनलाइन पूजा बुक करें',
        },
        bhaktiDarshan: {
          title: 'भक्ति दर्शन',
          subtitle: 'जहां भी रहें, ईश्वरीय जुड़ाव बनाए रखें',
          description: 'प्रसिद्ध आध्यात्मिक केंद्रों से मंदिर दर्शन की लाइव स्ट्रीमिंग के माध्यम से दिव्य उपस्थिति का अनुभव करें। हजारों भक्तों के साथ रीयल-टाइम में जुड़ें और आशीर्वाद प्राप्त करें।',
          features: [
            'भारत के पवित्र मंदिरों की दिव्य अनुभूति',
            'गहरे और आत्मीय आध्यात्मिक अनुभव में डूबें',
            'हर क्षण में ईश्वर की उपस्थिति का अनुभव करें',
          ],
          buttonText: 'भक्ति दर्शन देखें',
          secondaryButtonText: 'भक्ति बाल-चित्रकथा',
        },
        bhaktiStore: {
          title: 'भक्ति स्टोर',
          subtitle: 'आपकी साधना यात्रा के लिए पवित्र सामग्री, पुस्तकें और अर्पण',
          description: 'आध्यात्मिक वस्तुओं, पवित्र पुस्तकों, ध्यान उपकरणों और भक्ति सामग्री का चुना हुआ संग्रह देखें। प्रत्येक वस्तु आपकी साधना को बेहतर बनाने के लिए सावधानी से चुनी गई है।',
          features: [
            'पवित्र मूर्तियां और देव प्रतिमाएं',
            'आध्यात्मिक पुस्तकें और ग्रंथ',
            'ध्यान और योग सहायक सामग्री',
            'अगरबत्ती, दीप और पूजा सामग्री',
          ],
          buttonText: 'स्टोर देखें',
        },
        bhaktiYoga: {
          title: 'भक्ति योग',
          subtitle: 'योग अभ्यास जो शरीर, मन और आत्मा को जोड़ता है',
          description: 'भक्ति योग की परिवर्तनकारी शक्ति का अनुभव करें, जहां योगासन और भक्ति एक साथ आते हैं। हमारी कक्षाएं परंपरागत योग और भक्ति साधना को जोड़कर समग्र विकास देती हैं।',
          features: [
            'परंपरागत योग, प्राणायाम और आसन',
            'भक्ति गायन और मंत्र',
            'ध्यान और प्राणायाम',
            'आध्यात्मिक दर्शन का समावेश',
          ],
          buttonText: 'योग कोर्स जॉइन करें',
        },
        bhaktiJaapa: {
          title: 'भक्ति जाप',
          subtitle: 'अपने दैनिक मंत्र-जाप अभ्यास को ट्रैक करें और गहराई दें',
          description: 'हमारे जाप ट्रैकर के साथ नियमित साधना बनाएं। अपने दैनिक मंत्र-जाप को दर्ज करें, समय के साथ प्रगति देखें और भक्ति की मजबूत आदत बनाएं।',
          features: [
            'दैनिक मंत्र-जाप ट्रैकर',
            'प्रगति लॉग और स्ट्रीक',
            'अनेक मंत्रों का समर्थन',
            'व्यक्तिगत आध्यात्मिक जर्नल',
          ],
          buttonText: 'जाप अभ्यास शुरू करें',
        },
        upcoming: {
          title: 'अन्य आने वाली सेवाएं',
          subtitle: 'हमारी आगामी सेवाओं के लिए जुड़े रहें, जैसे...',
          features: [
            'एआई ज्योतिष और दैनिक राशिफल: व्यक्तिगत कुंडली विश्लेषण, दैनिक शुभ मुहूर्त और एआई-आधारित उपाय।',
            'वर्चुअल सेवा एवं दान: गौ सेवा, ब्राह्मण भोजन या मंदिर नवीनीकरण परियोजनाओं में डिजिटल प्रमाणपत्र और वीडियो प्रमाण सहित योगदान।',
            'सदस्यता आधारित "निरंतर चढ़ावा": चुने हुए मंदिर में आपके नाम से साप्ताहिक या मासिक अर्पण की स्वचालित व्यवस्था।',
            'आध्यात्मिक कंटेंट फीड: कथा, दैनिक मंत्र और हिंदू अनुष्ठानों की व्याख्या वाले छोटे वीडियो, विशेषकर युवा पीढ़ी के लिए।',
          ],
        },
      },
      contact: {
        mailSubject: 'आनंदमय के लिए ग्राहक प्रतिक्रिया',
        getInTouch: 'संपर्क करें',
        subtitle: 'हम आपकी बात सुनना चाहते हैं और आपकी आध्यात्मिक यात्रा में सहयोग करना चाहते हैं',
        address: 'पता',
        addressLine1: 'भुवनेश्वर',
        addressLine2: 'ओडिशा, भारत 751006',
        phone: 'फोन',
        email: 'ईमेल',
        prompt: 'कोई प्रश्न या विशेष अनुरोध है? नीचे दिए गए बटन पर क्लिक करें और अपने पसंदीदा ईमेल ऐप से हमें सीधे ईमेल भेजें।',
        sendEmail: 'ईमेल भेजें',
      },
    },
    onlinePooja: {
      pageHeader: {
        title: 'ऑनलाइन पूजा सेवाएं',
        subtitle: 'अपना पवित्र अनुष्ठान बुक करें और घर से दिव्य आशीर्वाद प्राप्त करें।',
      },
      poojaTypes: {
        sectionTitle: 'अपनी ऑनलाइन पूजा बुक करें',
        sectionSubtitle: 'विभिन्न अवसरों और आवश्यकताओं के अनुसार उपलब्ध पूजा सेवाओं में से चुनें',
        mostPopular: 'सबसे लोकप्रिय',
        bookNow: 'अभी बुक करें',
        items: {
          daily: {
            title: 'दैनिक पूजा',
            description: 'आध्यात्मिक कल्याण के लिए नियमित दैनिक प्रार्थनाएं।',
          },
          special: {
            title: 'विशेष अवसर पूजा',
            description: 'जन्मदिन, वर्षगांठ और विशेष अवसरों के लिए अनुकूलित पूजा।',
          },
          festival: {
            title: 'त्योहार पूजा',
            description: 'प्रमुख हिंदू त्योहारों के लिए विशेष अनुष्ठान।',
          },
          remedial: {
            title: 'उपाय पूजा',
            description: 'बाधाओं को दूर कर सकारात्मक ऊर्जा प्राप्त करने के लिए।',
          },
          'house-warming': {
            title: 'गृह प्रवेश पूजा',
            description: 'नए घर के मंगल और आशीर्वाद के लिए पवित्र अनुष्ठान।',
          },
          success: {
            title: 'सफलता पूजा',
            description: 'शैक्षणिक सफलता और कैरियर उन्नति के लिए।',
          },
        },
      },
      bookingForm: {
        title: 'अपनी पूजा बुक करें',
        subtitle: 'पवित्र अनुष्ठान बुक करने के लिए विवरण भरें',
        labels: {
          poojaType: 'पूजा प्रकार चुनें',
          temple: 'मंदिर चुनें',
          preferredDate: 'पसंदीदा तिथि',
          preferredTime: 'पसंदीदा समय',
          devoteeName: 'भक्त का नाम',
          email: 'ईमेल पता',
          phone: 'फोन नंबर',
          upiId: 'यूपीआई आईडी (वैकल्पिक)',
          specialRequests: 'विशेष अनुरोध (वैकल्पिक)',
        },
        placeholders: {
          choosePoojaType: 'पूजा प्रकार चुनें',
          chooseTemple: 'मंदिर चुनें',
          selectTime: 'समय चुनें',
          devoteeName: 'अपना पूरा नाम दर्ज करें',
          email: 'अपना ईमेल दर्ज करें',
          phone: 'अपना फोन नंबर दर्ज करें',
          upiId: 'yourname@bank',
          specialRequests: 'प्रसाद/पूजा सामग्री प्राप्त करने हेतु पिनकोड सहित अपना पूरा पता दर्ज करें (प्रसाद, पूजा माला/फूल, कुमकुम/हल्दी/चंदन/विभूति, अगरबत्ती आदि)।',
        },
        errors: {
          selectPoojaType: 'कृपया पूजा प्रकार चुनें',
          selectTemple: 'कृपया मंदिर चुनें',
          selectDate: 'कृपया तिथि चुनें',
          selectTime: 'कृपया समय चुनें',
          enterName: 'कृपया अपना नाम दर्ज करें',
          validEmail: 'कृपया वैध ईमेल दर्ज करें',
          validPhone: 'कृपया वैध फोन नंबर दर्ज करें',
          validUpi: 'कृपया वैध यूपीआई आईडी दर्ज करें (उदाहरण: name@bank)',
        },
        submit: {
          processing: 'प्रोसेस हो रहा है...',
          proceedToPayment: 'भुगतान के लिए आगे बढ़ें',
        },
        toasts: {
          loginRequired: 'पूजा बुक करने के लिए कृपया लॉग इन करें।',
          poojaDetailsMissing: 'भुगतान के लिए पूजा विवरण नहीं मिला।',
          bookingCreationFailed: 'बुकिंग बनाना असफल रहा।',
          orderCreationFailed: 'भुगतान ऑर्डर बनाना असफल रहा।',
          bookingConfirmed: 'बुकिंग सफलतापूर्वक पुष्टि हो गई!',
          viewBookings: 'बुकिंग देखें',
          paymentVerificationFailed: 'भुगतान सत्यापन असफल रहा।',
          paymentCancelled: 'भुगतान रद्द कर दिया गया। आपकी बुकिंग भुगतान लंबित है।',
        },
        paymentDescription: '{{title}} के लिए भुगतान',
        temples: {
          varanasi: 'काशी विश्वनाथ मंदिर, वाराणसी',
          jagannath: 'जगन्नाथ मंदिर, पुरी',
          sidhhaMahavir: 'सिद्ध महावीर मंदिर, पुरी',
          navaGraha: 'नवग्रह मंदिर, पुरी',
          loknath: 'लोकनाथ मंदिर, पुरी',
          mangala: 'बाटा मंगला मंदिर, पुरी',
          cuttackChandi: 'चंडी मंदिर, कटक',
          ugraTara: 'उग्र तारा मंदिर, खोरधा',
          tarini: 'तारिणी मंदिर',
          mahavir: 'शिरुली महावीर मंदिर, पुरी',
          mangalnath: 'मंगलनाथ मंदिर, उज्जैन',
          lakshmi: 'लक्ष्मी मंदिर, पुरी',
          vimala: 'विमला मंदिर, पुरी',
          bhubaneswari: 'भुवनेश्वरी मंदिर, भुवनेश्वर',
          bagalamukhi: 'मां बगलामुखी मंदिर, पुरी',
          lingaraj: 'लिंगराज मंदिर, भुवनेश्वर',
        },
        timeSlots: {
          '06_00': 'सुबह 6:00',
          '08_00': 'सुबह 8:00',
          '10_00': 'सुबह 10:00',
          '12_00': 'दोपहर 12:00',
          '14_00': 'दोपहर 2:00',
          '16_00': 'शाम 4:00',
          '18_00': 'शाम 6:00',
          '20_00': 'रात 8:00',
        },
      },
      howItWorks: {
        title: 'ऑनलाइन पूजा कैसे काम करती है',
        subtitle: 'हमारे पवित्र अनुष्ठानों में भाग लेने के लिए आसान चरण',
        steps: [
          {
            title: 'अपनी पूजा चुनें',
            description: 'अपनी आवश्यकता और अवसर के अनुसार पूजा प्रकार चुनें',
          },
          {
            title: 'बुकिंग और भुगतान करें',
            description: 'बुकिंग पूरी करें और सुरक्षित ऑनलाइन भुगतान करें',
          },
          {
            title: 'विवरण प्राप्त करें',
            description: 'पूजा विवरण और लाइव स्ट्रीमिंग लिंक सहित पुष्टि प्राप्त करें',
          },
        ],
      },
      testimonials: {
        title: 'हमारे भक्त क्या कहते हैं',
        subtitle: 'आध्यात्मिक साधकों के समुदाय से अनुभव',
        items: [
          {
            content: 'ऑनलाइन पूजा का अनुभव सचमुच दिव्य था। दूर रहकर भी मुझे दिव्य ऊर्जा से जुड़ाव महसूस हुआ। पुजारी जी अत्यंत ज्ञानवान थे और अनुष्ठान बहुत श्रद्धा से संपन्न हुआ।',
            author: 'Priya Sharma',
            location: 'मुंबई, भारत',
          },
          {
            content: 'शुरुआत में मुझे ऑनलाइन पूजा को लेकर संदेह था, लेकिन अनुभव मेरी उम्मीदों से कहीं बेहतर रहा। अनुष्ठान की गुणवत्ता और आध्यात्मिक ऊर्जा अद्भुत थी। अत्यंत अनुशंसित!',
            author: 'Rajesh Kumar',
            location: 'दिल्ली, भारत',
          },
          {
            content: 'विदेश में रहने वाले व्यक्ति के लिए यह ऑनलाइन पूजा सेवा वरदान साबित हुई है। अब मैं पारंपरिक अनुष्ठानों में भाग ले सकता हूं और अपनी आध्यात्मिक जड़ों से जुड़ाव बनाए रख सकता हूं।',
            author: 'Anita Patel',
            location: 'न्यूयॉर्क, यूएसए',
          },
        ],
      },
    },
    bhaktiStore: {
      pageHeader: {
        title: 'भक्ति स्टोर',
        subtitle: 'अपनी आध्यात्मिक यात्रा के लिए पवित्र वस्तुओं का चयनित संग्रह देखें।',
      },
      loadingProducts: 'उत्पाद लोड हो रहे हैं...',
      errorPrefix: 'त्रुटि',
      messages: {
        fetchFailed: 'उत्पाद प्राप्त नहीं हो सके',
        addedToCart: 'कार्ट में जोड़ा गया!',
        viewCart: 'कार्ट देखें',
        noProductsInCategory: 'इस श्रेणी में कोई उत्पाद नहीं मिला।',
        outOfStock: 'यह उत्पाद स्टॉक में नहीं है।',
      },
      actions: {
        addToCart: 'कार्ट में जोड़ें',
        buyNow: 'अभी खरीदें',
        outOfStock: 'स्टॉक खत्म',
      },
      categories: {
        allProducts: 'सभी उत्पाद',
        sacred_idols: 'पवित्र मूर्तियां',
        malas_and_beads: 'मालाएं और मनके',
        spiritual_books: 'आध्यात्मिक पुस्तकें',
        incense_and_fragrance: 'धूप और सुगंध',
        pooja_items: 'पूजा सामग्री',
        yoga_accessories: 'योग सहायक सामग्री',
      },
      products: {
        sacred_ganesha_idol: {
          name: 'पवित्र गणेश प्रतिमा',
          description: 'घर में पूजा और समृद्धि के आशीर्वाद के लिए सुंदर पीतल की गणेश प्रतिमा।',
        },
        rudraksha_panch_mukhi_original: {
          name: 'रुद्राक्ष पंच मुखी (मूल)',
          description: 'जप और आध्यात्मिक कल्याण के लिए प्रामाणिक पंचमुखी रुद्राक्ष।',
        },
        rudraksha_mala: {
          name: 'रुद्राक्ष माला',
          description: 'ध्यान और जाप के लिए प्रामाणिक 108 मनकों वाली 5 मुखी रुद्राक्ष माला।',
        },
        bhagavad_gita_book: {
          name: 'भगवद्गीता पुस्तक',
          description: 'विस्तृत टीका और अनुवाद सहित संपूर्ण भगवद्गीता।',
        },
        sandalwood_incense: {
          name: 'चंदन धूप',
          description: 'पूजा और ध्यान के लिए 50 शुद्ध, सुगंधित चंदन अगरबत्तियों का पैक।',
        },
        copper_pooja_thali: {
          name: 'तांबे की पूजा थाली',
          description: 'दैनिक अनुष्ठानों के लिए पारंपरिक और सुंदर तांबे की पूजा थाली सेट।',
        },
        crystal_shiva_lingam: {
          name: 'क्रिस्टल शिवलिंग',
          description: 'गहन ध्यान और सकारात्मक ऊर्जा के लिए प्राकृतिक, उच्च गुणवत्ता वाला क्रिस्टल शिवलिंग।',
        },
        eco_friendly_yoga_mat: {
          name: 'पर्यावरण-अनुकूल योगा मैट',
          description: 'आपके आध्यात्मिक और शारीरिक अभ्यास के लिए नॉन-स्लिप, पर्यावरण-अनुकूल योगा मैट।',
        },
        tulsi_mala: {
          name: 'तुलसी माला',
          description: 'जप और धारण के लिए पवित्र 108 मनकों वाली तुलसी लकड़ी की माला।',
        },
      },
    },
    checkout: {
      emptyCartTitle: 'आपकी कार्ट खाली है।',
      continueShopping: 'खरीदारी जारी रखें',
      title: 'चेकआउट',
      form: {
        shippingAddress: 'डिलीवरी पता',
        address: 'पता',
        city: 'शहर',
        state: 'राज्य',
        postalCode: 'पिन कोड',
        countryDisplay: 'भारत',
        phoneNumber: 'फोन नंबर',
        gstNumberLabel: 'जीएसटी नंबर (वैकल्पिक)',
        gstNumberPlaceholder: 'उदाहरण: 22AAAAA0000A1Z5',
        upiIdLabel: 'यूपीआई आईडी (वैकल्पिक)',
        upiIdPlaceholder: 'yourname@bank',
      },
      actions: {
        processing: 'प्रोसेस हो रहा है...',
        pay: '₹{{amount}} भुगतान करें',
      },
      orderSummary: {
        title: 'ऑर्डर सारांश',
        itemLine: '{{name}} x {{quantity}}',
        total: 'कुल',
      },
      errors: {
        invalidUpi: 'कृपया वैध यूपीआई आईडी दर्ज करें (उदाहरण: name@bank)।',
        paymentFailedPrefix: 'भुगतान विफल',
        unexpected: 'एक अप्रत्याशित त्रुटि हुई।',
      },
    },
    coursePlayer: {
      loading: 'कोर्स प्लेयर लोड हो रहा है...',
      errorPrefix: 'त्रुटि',
      courseContentNotFound: 'कोर्स सामग्री नहीं मिली।',
      progressComplete: '{{percent}}% पूर्ण ({{completed}}/{{total}})',
      nonVideoFallback: 'इस पाठ का मुख्य सामग्री एक डाउनलोड करने योग्य संसाधन है।',
      lockedContentTitle: 'यह सामग्री लॉक है',
      lockedContentMessage: 'यह मॉड्यूल केवल \'{{tier}}\' सदस्यों के लिए उपलब्ध है।',
      upgradePlan: 'अपनी योजना अपग्रेड करें',
      completed: '✓ पूर्ण',
      markAsComplete: 'पूर्ण के रूप में चिह्नित करें',
      viewOrDownloadNotes: 'नोट्स देखें या डाउनलोड करें',
      welcomeTitle: 'स्वागत है!',
      selectLessonPrompt: 'अपनी यात्रा शुरू करने के लिए साइडबार से एक पाठ चुनें।',
      errors: {
        fetchCourseContent: 'कोर्स सामग्री प्राप्त नहीं हो सकी।',
      },
    },
    shoppingCart: {
      title: 'आपकी कार्ट',
      closeCart: 'कार्ट बंद करें',
      emptyTitle: 'आपकी कार्ट खाली है',
      emptyDescription: 'शुरू करने के लिए कुछ आध्यात्मिक वस्तुएं जोड़ें।',
      subtotal: 'उप-योग',
      proceedToCheckout: 'चेकआउट पर जाएं',
      decreaseQuantity: '{{name}} की मात्रा घटाएं',
      increaseQuantity: '{{name}} की मात्रा बढ़ाएं',
      removeItem: '{{name}} को कार्ट से हटाएं',
      outOfStockRemovedMessage: 'ये उत्पाद स्टॉक में नहीं हैं और आपकी कार्ट से हटा दिए गए हैं: {{items}}',
      quantityExceedsStockMessage: 'मांगी गई मात्रा उपलब्ध स्टॉक से अधिक है। आगे बढ़ने के लिए कृपया मात्रा कम करें।',
    },
    bhaktiYogaPage: {
      header: {
        title: 'भक्ति योग पाठ्यक्रम',
        subtitle: 'आध्यात्मिक, शारीरिक और मानसिक कल्याण के लिए हमारे चयनित पाठ्यक्रमों के साथ एक परिवर्तनकारी यात्रा शुरू करें।',
      },
      loadingCourses: 'पाठ्यक्रम लोड हो रहे हैं...',
      errorPrefix: 'त्रुटि',
      noCoursesMessage: 'इस समय कोई पाठ्यक्रम उपलब्ध नहीं है। कृपया बाद में फिर देखें।',
      errors: {
        loadCourses: 'पाठ्यक्रम लोड नहीं हो सके।',
      },
      levels: {
        beginner: 'शुरुआती',
        intermediate: 'मध्यम स्तर',
        advanced: 'उन्नत',
        all_levels: 'सभी स्तर',
        all_level: 'सभी स्तर',
        all_ages: 'सभी आयु',
        children: 'बच्चे',
        special: 'विशेष',
      },
      tiers: {
        free: 'निःशुल्क',
        plus: 'प्लस',
        premium: 'प्रीमियम',
      },
      catalogues: {},
      courses: {},
    },
    bhaktiYogaCourseDetail: {
      loadingCourse: 'पाठ्यक्रम लोड हो रहा है...',
      errorPrefix: 'त्रुटि',
      courseNotFound: 'पाठ्यक्रम नहीं मिला।',
      minutesShort: 'मिनट',
      sections: {
        aboutThisCourse: 'इस पाठ्यक्रम के बारे में',
        curriculum: 'पाठ्यक्रम संरचना',
      },
      actions: {
        goToCourse: 'पाठ्यक्रम पर जाएं',
        loginToEnroll: 'नामांकन के लिए लॉग इन करें',
        processing: 'प्रोसेस हो रहा है...',
        startCourse: 'पाठ्यक्रम शुरू करें',
        enrolling: 'नामांकन हो रहा है...',
        enrollForFree: 'निःशुल्क नामांकन करें',
        subscribeToTier: '{{tier}} के लिए सदस्यता लें',
      },
      form: {
        upiIdLabel: 'यूपीआई आईडी (वैकल्पिक)',
        upiIdPlaceholder: 'yourname@bank',
      },
      sidebar: {
        fullAccessNote: 'नामांकन के बाद सभी कोर्स वीडियो और नोट्स का पूरा एक्सेस मिलेगा।',
      },
      errors: {
        loadCourseDetails: 'पाठ्यक्रम विवरण लोड नहीं हो सका।',
        invalidUpi: 'कृपया वैध यूपीआई आईडी दर्ज करें (उदाहरण: name@bank)।',
        unexpected: 'एक अप्रत्याशित त्रुटि हुई।',
      },
      courses: {},
      modules: {},
      lessons: {},
    },
    bhaktiJaapaPage: {
      header: {
        title: 'भक्ति जाप',
        subtitle: 'आपके दैनिक मंत्र-जप अभ्यास के लिए एक पवित्र स्थान।',
      },
      settings: {
        chooseDivineName: 'एक दिव्य नाम चुनें:',
      },
      chantingArea: {
        tapToChant: 'जप के लिए स्पर्श करें',
      },
      counters: {
        sessionJaapa: 'सत्र जाप',
        malasCompleted: 'पूर्ण मालाएं',
      },
      analytics: {
        todaysTotalJaapas: 'आज का कुल जाप',
        todaysMalasCompleted: 'आज की पूर्ण मालाएं',
        viewMyAnalytics: 'मेरा एनालिटिक्स देखें',
      },
      voiceSelector: {
        loadingVoices: 'आवाज़ें लोड हो रही हैं...',
        selectVoice: 'आवाज़ चुनें:',
        silent: 'मौन',
        hindiIndian: 'हिंदी आवाज़ (भारत)',
        hindiIndianCloser: 'हिंदी आवाज़ (भारत - स्पष्ट)',
      },
      soundToggle: {
        toggleBackgroundSound: 'पृष्ठभूमि ध्वनि टॉगल करें',
        backgroundFlute: 'पृष्ठभूमि बांसुरी',
        mute: 'म्यूट करें',
        unmute: 'अनम्यूट करें',
      },
      divineNames: {
        omNamahaShivaya: 'ॐ नमः शिवाय',
        omNamahShivaya: 'ॐ नमः शिवाय',
        jaiShreeKrishna: 'जय श्री कृष्ण',
        jaiShreeRam: 'जय श्री राम',
        shreeRadha: 'श्री राधा',
        sitaRam: 'सीता राम',
        omGanGanapatayeNamah: 'ॐ गं गणपतये नमः',
        omRudrayaNamah: 'ॐ रुद्राय नमः',
        radheKrishna: 'राधे कृष्ण',
        omSaiRam: 'ॐ साईं राम',
        omKalabhiravayNamah: 'ॐ कालभैरवाय नमः',
        shreem: 'श्रीं',
        aim: 'ऐं',
        hareKrishnaMahaMantra: 'हरे कृष्ण हरे कृष्ण\nकृष्ण कृष्ण हरे हरे\nहरे राम हरे राम\nराम राम हरे हरे',
        // Backward compatibility for historical entries.
        hareKrishna: 'हरे कृष्ण',
        shreeRam: 'श्री राम',
        shreeKrishna: 'श्री कृष्ण',
        jaiMaaDurga: 'जय मां दुर्गा',
        maaDurga: 'मां दुर्गा',
        jaiHanuman: 'जय हनुमान',
        hanuman: 'हनुमान',
      },
    },
    dashboard: {
      sidebar: {
        myPoojaBookings: 'मेरी पूजा बुकिंग',
        myStoreOrders: 'मेरे स्टोर ऑर्डर',
        myCourses: 'मेरे कोर्स',
        jaapaAnalytics: 'जाप एनालिटिक्स',
        myProfile: 'मेरी प्रोफ़ाइल',
        menu: 'मेनू',
      },
      common: {
        errorPrefix: 'त्रुटि',
        status: {
          pending: 'लंबित',
          paid: 'भुगतान हो गया',
          completed: 'पूर्ण',
          failed: 'विफल',
          cancelled: 'रद्द',
          canceled: 'रद्द',
          processing: 'प्रसंस्करण में',
          shipped: 'भेजा गया',
          delivered: 'डिलीवर हुआ',
          refunded: 'रिफंड किया गया',
        },
      },
      bookings: {
        loading: 'आपकी बुकिंग लोड हो रही हैं...',
        emptyMessage: 'आपने अभी तक कोई पूजा बुक नहीं की है।',
        bookNow: 'अभी पूजा बुक करें',
        fields: {
          bookingId: 'बुकिंग आईडी',
          temple: 'मंदिर',
          date: 'तिथि',
          time: 'समय',
          bookedOn: 'बुकिंग की तिथि',
        },
        errors: {
          fetchFailed: 'बुकिंग प्राप्त नहीं हो सकीं',
        },
      },
      orders: {
        loading: 'आपके ऑर्डर लोड हो रहे हैं...',
        emptyMessage: 'आपने अभी तक कोई ऑर्डर नहीं किया है।',
        shopNow: 'अभी खरीदारी करें',
        orderLabel: 'ऑर्डर',
        placedOn: 'ऑर्डर की तिथि',
        quantity: 'मात्रा',
        total: 'कुल',
        errors: {
          fetchFailed: 'ऑर्डर प्राप्त नहीं हो सके',
        },
      },
      courses: {
        title: 'मेरे भक्ति योग कोर्स',
        loading: 'आपके कोर्स लोड हो रहे हैं...',
        emptyMessage: 'आप अभी तक किसी भी कोर्स में नामांकित नहीं हैं।',
        exploreCourses: 'कोर्स देखें',
        courseTitleMissing: 'कोर्स शीर्षक उपलब्ध नहीं',
        progressComplete: '{{percent}}% पूर्ण',
        resumeCourse: 'कोर्स जारी रखें',
        startCourse: 'कोर्स प्रारंभ करें',
        errors: {
          fetchFailed: 'कोर्स प्राप्त नहीं हो सके',
        },
      },
      profile: {
        loading: 'प्रोफ़ाइल लोड हो रही है...',
        loadFailed: 'उपयोगकर्ता प्रोफ़ाइल लोड नहीं हो सकी। कृपया दोबारा लॉग इन करें।',
        avatarAlt: 'उपयोगकर्ता अवतार',
        confirmChangePassword: 'पासवर्ड सुरक्षित रूप से बदलने के लिए आपको लॉग आउट किया जाएगा। क्या आप जारी रखना चाहते हैं?',
        fields: {
          fullName: 'पूरा नाम',
          emailAddress: 'ईमेल पता',
          role: 'भूमिका',
          memberSince: 'सदस्यता तिथि',
        },
        editProfile: 'प्रोफ़ाइल संपादित करें',
        changePassword: 'पासवर्ड बदलें',
      },
    },
    jaapaAnalyticsPage: {
      title: 'मेरा जाप एनालिटिक्स',
      actions: {
        backToBhaktiJaapa: 'भक्ति जाप पर वापस जाएं',
      },
      loadingAnalytics: 'एनालिटिक्स लोड हो रहा है...',
      errorPrefix: 'त्रुटि',
      filters: {
        today: 'आज',
        thisWeek: 'इस सप्ताह',
        thisMonth: 'इस माह',
        allTime: 'संपूर्ण समय',
      },
      cards: {
        totalJaapas: 'कुल जाप',
        malasCompleted: 'पूर्ण मालाएं',
      },
      breakdown: {
        title: 'मंत्र विवरण',
        chants: 'जप',
        malaSingular: 'माला',
        malasPlural: 'मालाएं',
        noData: 'इस अवधि के लिए कोई जप दर्ज नहीं है।',
        startChanting: 'जप प्रारंभ करें',
      },
      errors: {
        fetchFailed: 'एनालिटिक्स प्राप्त नहीं हो सका',
      },
    },
    liveDarshan: {
      header: {
        title: 'भक्ति दर्शन',
        subtitle: 'भारत भर के मंदिरों और तीर्थस्थलों से पवित्र दर्शन देखें।',
      },
      liveBadge: 'लाइव',
      iframeTitle: 'भक्ति दर्शन - {{name}}',
      temples: {
        'puri-jagannath': {
          name: 'पुरी जगन्नाथ मंदिर (स्रोत: जय जगन्नाथ टीवी)',
          location: 'पुरी, ओडिशा',
        },
        'kashi-vishwanath': {
          name: 'काशी विश्वनाथ मंदिर',
          location: 'वाराणसी, उत्तर प्रदेश',
        },
        'shirdi-sai': {
          name: 'शिरडी साईं बाबा मंदिर',
          location: 'शिरडी, महाराष्ट्र',
        },
        'somnath-temple': {
          name: 'सोमनाथ मंदिर',
          location: 'वेरावल, गुजरात',
        },
        'vaishno-devi': {
          name: 'वैष्णो देवी मंदिर',
          location: 'कटरा, जम्मू और कश्मीर',
        },
        'golden-temple': {
          name: 'स्वर्ण मंदिर (हरमंदिर साहिब)',
          location: 'अमृतसर, पंजाब',
        },
        'tirupati-balaji': {
          name: 'तिरुपति बालाजी मंदिर',
          location: 'तिरुपति, आंध्र प्रदेश',
        },
        rameshwaram: {
          name: 'रामेश्वरम मंदिर',
          location: 'रामेश्वरम, तमिलनाडु',
        },
        'Vitthal-Rukmini': {
          name: 'विठ्ठल-रुक्मिणी मंदिर',
          location: 'पंढरपुर, महाराष्ट्र',
        },
        Dwarkadhish: {
          name: 'द्वारकाधीश मंदिर',
          location: 'द्वारका, गुजरात',
        },
        Sidhhivinayak: {
          name: 'सिद्धिविनायक मंदिर',
          location: 'मुंबई, महाराष्ट्र',
        },
        'ISKCON-Vrindavan': {
          name: 'इस्कॉन मंदिर',
          location: 'वृंदावन, उत्तर प्रदेश',
        },
      },
    },
    bhaktiSamadhan: {
      hero: {
        title: 'भक्ति एआई गुरु',
        subtitle: 'बुद्धिमान मार्गदर्शन: आपके जीवन की पवित्र यात्रा के लिए दिव्य दिशा',
      },
      tabs: {
        askAdvisor: 'एडवाइज़र से पूछें',
        chat: 'चैट',
        browseRemedies: 'उपाय देखें',
      },
      advisor: {
        describeTitle: 'अपनी स्थिति बताएं',
        describeDesc: 'अपनी वर्तमान स्थिति या जिस विषय में आप आशीर्वाद चाहते हैं, उसके बारे में बताएं। हमारा एआई भक्ति गुरु सबसे उपयुक्त पूजा और देवता की सलाह देगा।',
        placeholder: 'उदाहरण: मेरे बेटे की आने वाली महत्वपूर्ण परीक्षा में बाधा दूर करने के लिए कौन सी पूजा करनी चाहिए?',
        gettingRecommendation: 'सिफारिश ली जा रही है...',
        getRecommendation: 'सिफारिश प्राप्त करें',
        consultingWisdom: 'आध्यात्मिक ज्ञान से परामर्श जारी है...',
        spiritualGuidance: 'आध्यात्मिक मार्गदर्शन',
        noRecommendation: 'कोई सिफारिश उपलब्ध नहीं है।',
        genericError: 'क्षमा करें, कुछ गलत हो गया। कृपया पुनः प्रयास करें।',
      },
      guest: {
        defaultLimitMessage: 'गेस्ट की दैनिक सीमा पूरी हो गई है। आगे बढ़ने के लिए लॉग इन या साइन अप करें।',
        tryAgainAfter: '{{baseMessage}} आप {{time}} के बाद फिर प्रयास कर सकते हैं।',
      },
      chat: {
        genericError: 'क्षमा करें, कुछ गलत हो गया। कृपया पुनः प्रयास करें।',
        historyTitle: 'चैट इतिहास',
        newChat: 'नई चैट',
        loading: 'लोड हो रहा है...',
        noConversations: 'अभी तक कोई बातचीत नहीं',
        untitled: 'बिना शीर्षक',
        deleteConversation: 'बातचीत हटाएं',
        spiritualChat: 'आध्यात्मिक चैट',
        namaste: 'नमस्ते!',
        emptyPrompt: 'मुझसे वैदिक ज्ञान, पूजा, मंत्र, ज्योतिष, योग, ध्यान या किसी भी आध्यात्मिक विषय पर पूछें।',
        guestModeInfo: 'गेस्ट मोड — 3 संदेश/दिन। असीमित उपयोग के लिए लॉग इन करें।',
        suggestions: [
          'हनुमान चालीसा का महत्व क्या है?',
          'करियर विकास के लिए कौन सी पूजा करनी चाहिए?',
          'भगवद्गीता में कर्म का अर्थ समझाइए।',
          'ॐ नमः शिवाय जप के क्या लाभ हैं?',
          'नकारात्मक विचारों को आध्यात्मिक रूप से कैसे कम करें?',
          'मानसिक शांति और एकाग्रता के लिए कौन सा मंत्र श्रेष्ठ है?',
          'विवाह में देरी दूर करने के लिए कौन सी पूजा सहायक है?',
          'घर में अधिक सकारात्मकता कैसे लाएं?',
          'तनाव और चिंता में कौन सा आध्यात्मिक अभ्यास सहायक है?',
          'पारिवारिक सौहार्द के लिए कौन सा उपाय सबसे अच्छा है?'
        ],
        askPlaceholder: 'अपना आध्यात्मिक प्रश्न पूछें...',
        askButton: 'पूछें',
      },
      categories: {
        education: 'शिक्षा',
        career: 'कैरियर',
        marriage: 'विवाह',
        health: 'स्वास्थ्य',
        wealth: 'धन',
        family: 'परिवार',
        protection: 'सुरक्षा',
        children: 'संतान',
        spiritualGrowth: 'आध्यात्मिक उन्नति',
        allRemedies: 'सभी उपाय',
      },
      remedies: {
        browseByCategory: 'श्रेणी के अनुसार देखें',
        primaryDeity: 'मुख्य देवता',
        recommendedPoojas: 'अनुशंसित पूजाएं',
        morePrompt: '{{title}} के बारे में विस्तार से बताइए — {{desc}}',
        wealthFinancialProsperity: {
          title: 'धन और आर्थिक समृद्धि',
          desc: 'आर्थिक स्थिरता, व्यवसायिक सफलता और भौतिक समृद्धि के लिए',
          deity: 'मां लक्ष्मी',
          deityDesc: 'मां लक्ष्मी धन, समृद्धि और वैभव की सर्वोच्च स्रोत हैं। वे आर्थिक सफलता और सुख-सुविधा का आशीर्वाद देती हैं।',
          poojas: ['लक्ष्मी अर्चना', 'लक्ष्मी होमम्', 'लक्ष्मी सहस्रनाम', 'कुबेर पूजा'],
        },
        familyHarmonyHouseholdPeace: {
          title: 'पारिवारिक सामंजस्य और गृह शांति',
          desc: 'घर में शांति, पारिवारिक विवाद समाधान और घरेलू संतुलन के लिए',
          deity: 'मां अन्नपूर्णा',
          deityDesc: 'मां अन्नपूर्णा पोषण, देखभाल और परिवार के कल्याण का प्रतीक हैं। वे घर में सुख-शांति और समृद्धि प्रदान करती हैं।',
          poojas: ['अन्नपूर्णा अर्चना', 'दुर्गा सप्तशती', 'गणेश महा पूजा', 'गृह-आशीर्वाद हवन'],
        },
        academicExcellenceKnowledge: {
          title: 'शैक्षिक उत्कृष्टता और ज्ञान',
          desc: 'पढ़ाई, परीक्षा और गहन ज्ञान की प्राप्ति में सफलता के लिए',
          deity: 'मां सरस्वती',
          deityDesc: 'मां सरस्वती ज्ञान, कला और विद्या की देवी हैं। वे बुद्धि, विवेक और शिक्षा में सफलता प्रदान करती हैं।',
          poojas: ['सरस्वती पूजा', 'हयग्रीव होमम्', 'विद्या लक्ष्मी पूजा', 'अक्षराभ्यासम्'],
        },
        careerGrowthProfessionalSuccess: {
          title: 'कैरियर वृद्धि और पेशेवर सफलता',
          desc: 'नौकरी में उन्नति, व्यवसाय विकास, बाधा निवारण और लक्ष्य प्राप्ति के लिए',
          deity: 'भगवान गणेश',
          deityDesc: 'भगवान गणेश विघ्नहर्ता और शुभारंभ के देवता हैं। वे सफलता का मार्ग प्रशस्त करते हैं।',
          poojas: ['गणेश होमम्', 'नवग्रह पूजा', 'विष्णु सहस्रनाम', 'शनि पूजा'],
        },
        marriageRelationshipBliss: {
          title: 'विवाह और संबंधों में सौभाग्य',
          desc: 'उपयुक्त जीवनसाथी, सुखी वैवाहिक जीवन और संबंध समस्याओं के समाधान के लिए',
          deity: 'मां पार्वती',
          deityDesc: 'मां पार्वती प्रेम, समर्पण और दांपत्य सौहार्द की देवी हैं। वे स्थायी और मजबूत संबंधों का आशीर्वाद देती हैं।',
          poojas: ['स्वयंवर पार्वती होमम्', 'मंगला गौरी पूजा', 'विवाह पंचमी पूजा', 'कात्यायनी पूजा'],
        },
        healthHealing: {
          title: 'स्वास्थ्य और आरोग्य',
          desc: 'रोगमुक्ति, उत्तम स्वास्थ्य, दीर्घायु और समग्र कल्याण के लिए',
          deity: 'भगवान धन्वंतरि',
          deityDesc: 'भगवान धन्वंतरि आयुर्वेद के देवता और दिव्य वैद्य हैं। वे स्वास्थ्य और उपचार का आशीर्वाद देते हैं।',
          poojas: ['महामृत्युंजय जाप', 'धन्वंतरि होमम्', 'सुदर्शन होमम्', 'आयुष होमम्'],
        },
        protectionSafety: {
          title: 'रक्षा और सुरक्षा',
          desc: 'नकारात्मक ऊर्जा, दृष्टिदोष और पारिवारिक सुरक्षा के लिए',
          deity: 'भगवान हनुमान',
          deityDesc: 'भगवान हनुमान शक्ति, साहस और भक्ति के प्रतीक हैं। वे भक्तों की सभी संकटों से रक्षा करते हैं।',
          poojas: ['हनुमान चालीसा पाठ', 'सुदर्शन होमम्', 'दुर्गा कवच पाठ', 'बगलामुखी पूजा'],
        },
        childrenProgeny: {
          title: 'संतान और वंश वृद्धि',
          desc: 'सुखी मातृत्व-पितृत्व, बच्चों के स्वास्थ्य और उज्ज्वल भविष्य के लिए',
          deity: 'संतोषी मां',
          deityDesc: 'संतोषी मां संतोष और सुख की देवी हैं। वे परिवार को स्वस्थ संतान और प्रसन्नता का आशीर्वाद देती हैं।',
          poojas: ['संतान गोपाल होमम्', 'पुत्रकामेष्टि यज्ञ', 'गर्भ रक्षा पूजा', 'संतोषी मां व्रत'],
        },
        spiritualAwakeningInnerPeace: {
          title: 'आध्यात्मिक जागरण और आंतरिक शांति',
          desc: 'ध्यान की गहराई, आध्यात्मिक प्रगति और आत्मबोध के लिए',
          deity: 'भगवान शिव',
          deityDesc: 'भगवान शिव परम चेतना, ध्यान और परिवर्तन के अधिष्ठाता हैं। वे मोक्ष और अंतर्मन की शांति प्रदान करते हैं।',
          poojas: ['रुद्र अभिषेक', 'महाशिवरात्रि पूजा', 'लिंगाष्टकम् पाठ', 'ध्यान पूजा'],
        },
      },
    },
  },
  or: {
    nav: {
      home: 'ହୋମ',
      bhaktiSamadhan: 'ଭକ୍ତି ସମାଧାନ',
      onlinePooja: 'ଅନଲାଇନ ପୂଜା',
      bhaktiDarshan: 'ଭକ୍ତି ଦର୍ଶନ',
      bhaktiStore: 'ଭକ୍ତି ଷ୍ଟୋର',
      bhaktiYoga: 'ଭକ୍ତି ଯୋଗ',
      bhaktiJaapa: 'ଭକ୍ତି ଜାପ',
      bhaktiBalChitraKatha: 'ବାଳ ଚିତ୍ର କଥା',
      dashboard: 'ଡ୍ୟାଶବୋର୍ଡ',
      adminPanel: 'ଏଡମିନ ପ୍ୟାନେଲ',
      logout: 'ଲଗ୍ ଆଉଟ',
      login: 'ଲଗ୍ ଇନ',
      signUp: 'ସାଇନ୍ ଅପ୍',
      selectLanguage: 'ଭାଷା ବାଛନ୍ତୁ',
      language: 'ଭାଷା',
      openShoppingCart: 'ଶପିଙ୍ଗ କାର୍ଟ ଖୋଲନ୍ତୁ',
    },
    footer: {
      contact: 'ସମ୍ପର୍କ',
      allRightsReserved: 'ସମସ୍ତ ଅଧିକାର ସଂରକ୍ଷିତ।',
    },
    auth: {
      login: {
        welcomeBack: 'ପୁଣିଥରେ ସ୍ୱାଗତ',
        subtitle: 'ଆପଣଙ୍କ ଆଧ୍ୟାତ୍ମିକ ଯାତ୍ରା ଜାରି ରଖିବା ପାଇଁ ସାଇନ୍ ଇନ କରନ୍ତୁ',
        googleTermsPrefix: 'Google ଦ୍ୱାରା ସାଇନ୍ ଇନ କଲେ ଆପଣ ଆମ',
        termsAndPrivacy: 'ନିୟମ ଓ ଶର୍ତ୍ତାବଳୀ ଏବଂ ଗୋପନୀୟତା ନୀତି',
        separator: 'କିମ୍ବା',
        redirectMessage: 'ଆପଣ ଯେ ପୃଷ୍ଠା ଦେଖିବାକୁ ଚାହୁଁଥିଲେ, ସେଥିପାଇଁ ଲଗ୍ ଇନ ଆବଶ୍ୟକ।',
        emailAddress: 'ଇମେଲ ଠିକଣା',
        enterEmail: 'ଆପଣଙ୍କ ଇମେଲ ଲେଖନ୍ତୁ',
        password: 'ପାସୱାର୍ଡ',
        enterPassword: 'ଆପଣଙ୍କ ପାସୱାର୍ଡ ଲେଖନ୍ତୁ',
        rememberMe: 'ମୋତେ ମନେ ରଖନ୍ତୁ',
        forgotPassword: 'ପାସୱାର୍ଡ ଭୁଲିଗଲେ?',
        signingIn: 'ସାଇନ୍ ଇନ ହେଉଛି...',
        signIn: 'ସାଇନ୍ ଇନ',
        noAccount: 'ଖାତା ନାହିଁ କି?',
        signUp: 'ସାଇନ୍ ଅପ୍',
        welcomeToast: 'ପୁଣିଥରେ ସ୍ୱାଗତ, {{name}}!',
        emailRequired: 'ଇମେଲ ଆବଶ୍ୟକ',
        emailInvalid: 'ଇମେଲ ଠିକ୍ ନୁହେଁ',
        passwordRequired: 'ପାସୱାର୍ଡ ଆବଶ୍ୟକ',
        passwordMin: 'ପାସୱାର୍ଡ କମ୍ ସେ କମ୍ 6 ଅକ୍ଷର ହେବା ଉଚିତ',
        loginFailed: 'ଲଗ୍ ଇନ ବିଫଳ ହେଲା। ଦୟାକରି ପୁଣି ଚେଷ୍ଟା କରନ୍ତୁ।',
      },
      signup: {
        joinAnandmaya: 'ଆନନ୍ଦମୟ ସହ ଯୋଗ ଦିଅନ୍ତୁ',
        subtitle: 'ଆମ ସହିତ ଆପଣଙ୍କ ଆଧ୍ୟାତ୍ମିକ ଯାତ୍ରା ଆରମ୍ଭ କରନ୍ତୁ',
        firstName: 'ପ୍ରଥମ ନାମ',
        enterFirstName: 'ପ୍ରଥମ ନାମ ଲେଖନ୍ତୁ',
        lastName: 'ଶେଷ ନାମ',
        enterLastName: 'ଶେଷ ନାମ ଲେଖନ୍ତୁ',
        emailAddress: 'ଇମେଲ ଠିକଣା',
        enterEmail: 'ଆପଣଙ୍କ ଇମେଲ ଲେଖନ୍ତୁ',
        password: 'ପାସୱାର୍ଡ',
        createPassword: 'ନୂତନ ପାସୱାର୍ଡ ସୃଷ୍ଟି କରନ୍ତୁ',
        confirmPassword: 'ପାସୱାର୍ଡ ନିଶ୍ଚିତ କରନ୍ତୁ',
        confirmPasswordPlaceholder: 'ପାସୱାର୍ଡ ପୁନଃ ଲେଖନ୍ତୁ',
        agreeToPrefix: 'ମୁଁ',
        termsAndConditions: 'ନିୟମ ଓ ଶର୍ତ୍ତାବଳୀ',
        and: 'ଏବଂ',
        privacyPolicy: 'ଗୋପନୀୟତା ନୀତି',
        creatingAccount: 'ଖାତା ସୃଷ୍ଟି ହେଉଛି...',
        createAccount: 'ଖାତା ସୃଷ୍ଟି କରନ୍ତୁ',
        alreadyHaveAccount: 'ଆଗରୁ ଖାତା ଅଛି କି?',
        signIn: 'ସାଇନ୍ ଇନ',
        accountCreatedAlert: 'ଖାତା ସଫଳତାର ସହ ତିଆରି ହେଲା! ଆନନ୍ଦମୟରେ ସ୍ୱାଗତ!',
        firstNameRequired: 'ପ୍ରଥମ ନାମ ଆବଶ୍ୟକ',
        lastNameRequired: 'ଶେଷ ନାମ ଆବଶ୍ୟକ',
        emailRequired: 'ଇମେଲ ଆବଶ୍ୟକ',
        emailInvalid: 'ଇମେଲ ଠିକ୍ ନୁହେଁ',
        passwordRequired: 'ପାସୱାର୍ଡ ଆବଶ୍ୟକ',
        passwordMin: 'ପାସୱାର୍ଡ କମ୍ ସେ କମ୍ 6 ଅକ୍ଷର ହେବା ଉଚିତ',
        confirmPasswordRequired: 'ଦୟାକରି ପାସୱାର୍ଡ ନିଶ୍ଚିତ କରନ୍ତୁ',
        passwordsNoMatch: 'ପାସୱାର୍ଡ ମେଳ ଖାଉନାହିଁ',
        agreeToTermsRequired: 'ନିୟମ ଓ ଶର୍ତ୍ତାବଳୀକୁ ଅବଶ୍ୟ ସ୍ୱୀକାର କରିବାକୁ ପଡିବ',
        registrationFailed: 'ନିବନ୍ଧନ ବିଫଳ ହେଲା। ଦୟାକରି ପୁଣି ଚେଷ୍ଟା କରନ୍ତୁ।',
      },
    },
    home: {
      hero: {
        liveDarshan: 'ଦିବ୍ୟ ଦର୍ଶନ',
        watchNow: 'ଏବେ ଦେଖନ୍ତୁ',
        bhakti: 'ଭକ୍ତି',
        balChitrakatha: 'ବାଳ-ଚିତ୍ରକଥା',
        mindBodySoul: 'ଶରୀର ~ ମନ ~ ଆତ୍ମା',
        subtitle: 'ଭକ୍ତି, ଆଧ୍ୟାତ୍ମିକ ଜାଗରଣ ଓ ଶାରୀରିକ ସମତୋଳନର ପଥ ଖୋଜନ୍ତୁ',
        deviGalleryAria: 'ଘୂର୍ଣ୍ଣିତ ଦେବୀ ଗ୍ୟାଲେରୀ',
        cards: {
          bhaktiSamadhan: {
            title: 'ଭକ୍ତି\nସମାଧାନ',
            description: 'ପୂଜା, ମନ୍ତ୍ର ଏବଂ ବେଦିକ ଉପାୟ ଉପରେ ଏଆଇ-ଆଧାରିତ ଆଧ୍ୟାତ୍ମିକ ପରାମର୍ଶ।',
          },
          onlinePooja: {
            title: 'ଅନଲାଇନ ପୂଜା',
            description: 'ଘରର ସୁବିଧାରୁ ପବିତ୍ର ବେଦିକ କ୍ରିୟାକଳାପରେ ଅଂଶଗ୍ରହଣ କରନ୍ତୁ।',
          },
          bhaktiDarshan: {
            title: 'ଭକ୍ତି\nଦର୍ଶନ',
            description: 'ଭାରତର ପ୍ରମୁଖ ମନ୍ଦିରରୁ ତତ୍କ୍ଷଣାତ ଦିବ୍ୟ ଦର୍ଶନ।',
          },
          bhaktiStore: {
            title: 'ଭକ୍ତି ଷ୍ଟୋର',
            description: 'ଆପଣଙ୍କ ସାଧନା ଯାତ୍ରା ପାଇଁ ଚୟନିତ ଆଧ୍ୟାତ୍ମିକ ପଦାର୍ଥ, ମୂର୍ତ୍ତି ଏବଂ ପୁସ୍ତକ।',
          },
          bhaktiYoga: {
            title: 'ଭକ୍ତି ଯୋଗ',
            description: 'ଭକ୍ତିମୟ ଯୋଗ ସାଧନାରେ ଶରୀର, ମନ ଓ ଆତ୍ମାକୁ ଏକତ୍ର କରନ୍ତୁ।',
          },
          bhaktiJaapa: {
            title: 'ଭକ୍ତି ଜାପ',
            description: 'ଦୈନିକ ମନ୍ତ୍ର-ଜାପ ଅଭ୍ୟାସକୁ ଟ୍ରାକ କରି ଗଭୀର କରନ୍ତୁ।',
          },
        },
        deity: {
          maaDurga: 'ମା ଦୁର୍ଗା',
          goddessSaraswati: 'ଦେବୀ ସରସ୍ୱତୀ',
          maaParvati: 'ମା ପାର୍ବତୀ',
          maaKali: 'ମା କାଳୀ',
          maaLakshmi: 'ମା ଲକ୍ଷ୍ମୀ',
          lordGanesha: 'ଭଗବାନ ଗଣେଶ',
          lordHanuman: 'ଭଗବାନ ହନୁମାନ',
          lordShiva: 'ଭଗବାନ ଶିବ',
          lordVishnu: 'ଭଗବାନ ବିଷ୍ଣୁ',
          lordKrishna: 'ଭଗବାନ କୃଷ୍ଣ',
          lordMurugan: 'ଭଗବାନ ମୁରୁଗନ',
          lordBrahma: 'ଭଗବାନ ବ୍ରହ୍ମା',
          maaBagalamukhi: 'ମା ବଗଳାମୁଖୀ',
          lordKubera: 'ଭଗବାନ କୁବେର',
          lordShani: 'ଭଗବାନ ଶନି',
          navgraha: 'ନବଗ୍ରହ',
          vastuPurusha: 'ବାସ୍ତୁ ପୁରୁଷ',
          guru: 'ଆଧ୍ୟାତ୍ମିକ ଗୁରୁ',
        },
      },
      sections: {
        bhaktiSamadhan: {
          title: 'ଭକ୍ତି ସମାଧାନ',
          subtitle: 'ଆପଣଙ୍କ ଜୀବନ ପରିସ୍ଥିତି ପାଇଁ ଏଆଇ-ଆଧାରିତ ଆଧ୍ୟାତ୍ମିକ ପରାମର୍ଶ',
          description: 'ଏଆଇ ଦ୍ୱାରା ସମର୍ଥିତ ବ୍ୟକ୍ତିଗତ ବେଦିକ ପରାମର୍ଶ ପାଆନ୍ତୁ। ପୂଜା, ମନ୍ତ୍ର, ଜ୍ୟୋତିଷ, ଧ୍ୟାନ କିମ୍ବା ଯେକୌଣସି ଆଧ୍ୟାତ୍ମିକ ପ୍ରଶ୍ନ ପଚାରନ୍ତୁ। ସ୍ୱାସ୍ଥ୍ୟ, ଧନ, କାରିଆର, ସମ୍ପର୍କ ଇତ୍ୟାଦି ପାଇଁ ଚୟନିତ ବେଦିକ ଉପାୟ ଦେଖନ୍ତୁ।',
          features: [
            'ଏଆଇ-ଆଧାରିତ ପୂଜା ପରାମର୍ଶ',
            'ବ୍ୟକ୍ତିଗତ ଆଧ୍ୟାତ୍ମିକ ଚାଟ ସହାୟକ',
            'ଶ୍ରେଣୀଭିତ୍ତିକ ଚୟନିତ ବେଦିକ ଉପାୟ',
            'ପବିତ୍ର ଶାସ୍ତ୍ରରୁ ଉଦ୍ଧୃତି',
          ],
          buttonText: 'ଆଧ୍ୟାତ୍ମିକ ପରାମର୍ଶ ପାଆନ୍ତୁ',
        },
        onlinePooja: {
          title: 'ଅନଲାଇନ ପୂଜା',
          subtitle: 'ଦୁନିଆର ଯେକୌଣସି ସ୍ଥାନରୁ ପବିତ୍ର ପୂଜା ଏବଂ ପ୍ରାର୍ଥନା କରନ୍ତୁ',
          description: 'ଆମର ଅନଲାଇନ ପ୍ଲାଟଫର୍ମ ମାଧ୍ୟମରେ ପାରମ୍ପରିକ ପୂଜା ଆନୁଷ୍ଠାନର ଶକ୍ତି ଅନୁଭବ କରନ୍ତୁ। ଆମର ଅନୁଭବୀ ପୁଜାରୀମାନେ ଲାଇଭ ପୂଜା କରନ୍ତି, ଯାହାରେ ଆପଣ ଘରରୁ ଅଂଶଗ୍ରହଣ କରିପାରିବେ।',
          features: [
            'ବ୍ୟକ୍ତିଗତ ପ୍ରାର୍ଥନା ଏବଂ ଅର୍ପଣ',
          ],
          buttonText: 'ଅନଲାଇନ ପୂଜା ବୁକ କରନ୍ତୁ',
        },
        bhaktiDarshan: {
          title: 'ଭକ୍ତି ଦର୍ଶନ',
          subtitle: 'ଆପଣ ଯେଉଁଠି ଥାନ୍ତୁ, ଦିବ୍ୟ ସମ୍ପର୍କରେ ରୁହନ୍ତୁ',
          description: 'ପ୍ରସିଦ୍ଧ ଆଧ୍ୟାତ୍ମିକ କେନ୍ଦ୍ରଗୁଡିକରୁ ମନ୍ଦିର ଦର୍ଶନର ଲାଇଭ ପ୍ରସାରଣ ମାଧ୍ୟମରେ ଦିବ୍ୟ ଉପସ୍ଥିତି ଅନୁଭବ କରନ୍ତୁ। ହଜାର ହଜାର ଭକ୍ତଙ୍କ ସହ ତତ୍କ୍ଷଣାତ ଭାବେ ଯୋଗ ଦିଅନ୍ତୁ ଏବଂ ଆଶୀର୍ବାଦ ପାଆନ୍ତୁ।',
          features: [
            'ଭାରତର ପବିତ୍ର ମନ୍ଦିରମାନଙ୍କର ଦିବ୍ୟ ସାରକୁ ଅନୁଭବ କରନ୍ତୁ',
            'ଗଭୀର ଓ ଆତ୍ମୀୟ ଆଧ୍ୟାତ୍ମିକ ଅନୁଭୂତିରେ ଡୁବିଯାଆନ୍ତୁ',
            'ପ୍ରତ୍ୟେକ ମୁହୂର୍ତ୍ତରେ ଦିବ୍ୟ ଉପସ୍ଥିତିକୁ ଅନୁଭବ କରନ୍ତୁ',
          ],
          buttonText: 'ଭକ୍ତି ଦର୍ଶନ ଦେଖନ୍ତୁ',
          secondaryButtonText: 'ଭକ୍ତି ବାଳ-ଚିତ୍ରକଥା',
        },
        bhaktiStore: {
          title: 'ଭକ୍ତି ଷ୍ଟୋର',
          subtitle: 'ଆପଣଙ୍କ ସାଧନା ଯାତ୍ରା ପାଇଁ ପବିତ୍ର ସାମଗ୍ରୀ, ପୁସ୍ତକ ଏବଂ ଅର୍ପଣ',
          description: 'ଆଧ୍ୟାତ୍ମିକ ସାମଗ୍ରୀ, ପବିତ୍ର ପୁସ୍ତକ, ଧ୍ୟାନ ସାଧନ ଏବଂ ଭକ୍ତିମୟ ଅର୍ପଣର ଚୟନିତ ସଂଗ୍ରହ ଦେଖନ୍ତୁ। ପ୍ରତ୍ୟେକ ସାମଗ୍ରୀ ଆପଣଙ୍କ ସାଧନାକୁ ଉନ୍ନତ କରିବା ପାଇଁ ଭଲଭାବେ ଚୟନିତ।',
          features: [
            'ପବିତ୍ର ମୂର୍ତ୍ତି ଏବଂ ଦେବ ଭିଗ୍ରହ',
            'ଆଧ୍ୟାତ୍ମିକ ପୁସ୍ତକ ଏବଂ ଶାସ୍ତ୍ର',
            'ଧ୍ୟାନ ଏବଂ ଯୋଗ ସାଧନ',
            'ଧୂପ, ଦୀପ ଏବଂ ପୂଜା ସାମଗ୍ରୀ',
          ],
          buttonText: 'ଷ୍ଟୋର ଦେଖନ୍ତୁ',
        },
        bhaktiYoga: {
          title: 'ଭକ୍ତି ଯୋଗ',
          subtitle: 'ଏମିତି ଯୋଗ ଅଭ୍ୟାସ ଯାହା ଶରୀର, ମନ ଓ ଆତ୍ମାକୁ ଯୋଡେ',
          description: 'ଭକ୍ତି ଯୋଗର ପରିବର୍ତ୍ତନଶୀଳ ଶକ୍ତିକୁ ଅନୁଭବ କରନ୍ତୁ, ଯେଉଁଠାରେ ଯୋଗାସନ ଓ ଭକ୍ତି ଏକତ୍ର ହୁଏ। ଆମ କ୍ଲାସରେ ପାରମ୍ପରିକ ଯୋଗ ଓ ଭକ୍ତି ସାଧନା ମିଶି ମୋଟ ଆଧ୍ୟାତ୍ମିକ ଉନ୍ନତି ଦେଇଥାଏ।',
          features: [
            'ପାରମ୍ପରିକ ଯୋଗ, ପ୍ରାଣାୟାମ ଓ ଆସନ',
            'ଭକ୍ତିମୟ ଗାନ ଏବଂ ମନ୍ତ୍ର',
            'ଧ୍ୟାନ ଏବଂ ପ୍ରାଣାୟାମ',
            'ଆଧ୍ୟାତ୍ମିକ ଦର୍ଶନର ସମାବେଶ',
          ],
          buttonText: 'ଯୋଗ କୋର୍ସରେ ଯୋଗଦିଅନ୍ତୁ',
        },
        bhaktiJaapa: {
          title: 'ଭକ୍ତି ଜାପ',
          subtitle: 'ଦୈନିକ ମନ୍ତ୍ର-ଜାପ ଅଭ୍ୟାସକୁ ଟ୍ରାକ କରି ଗଭୀର କରନ୍ତୁ',
          description: 'ଆମ ଜାପ ଟ୍ରାକର ସହିତ ନିୟମିତ ସାଧନା ଗଢନ୍ତୁ। ଦୈନିକ ମନ୍ତ୍ର ପୁନରାବୃତ୍ତି ଲଗ କରନ୍ତୁ, ପ୍ରଗତି ଦେଖନ୍ତୁ ଏବଂ ଭକ୍ତିର ଦୃଢ଼ ଅଭ୍ୟାସ ଗଢନ୍ତୁ।',
          features: [
            'ଦୈନିକ ମନ୍ତ୍ର-ଜାପ ଟ୍ରାକର',
            'ପ୍ରଗତି ଲଗ ଓ ଷ୍ଟ୍ରିକ',
            'ଅନେକ ମନ୍ତ୍ର ସମର୍ଥନ',
            'ବ୍ୟକ୍ତିଗତ ଆଧ୍ୟାତ୍ମିକ ଜର୍ନାଲ',
          ],
          buttonText: 'ଜାପ ଅଭ୍ୟାସ ଆରମ୍ଭ କରନ୍ତୁ',
        },
        upcoming: {
          title: 'ଅନ୍ୟାନ୍ୟ ଆସନ୍ତା ସେବା',
          subtitle: 'ଆମ ସହିତ ଯୋଡି ରୁହନ୍ତୁ, ଆସନ୍ତା ସେବାଗୁଡିକ ଯେପରି...',
          features: [
            'ଏଆଇ ଜ୍ୟୋତିଷ ଓ ଦୈନିକ ରାଶିଫଳ: ବ୍ୟକ୍ତିଗତ କୁଣ୍ଡଳୀ ବିଶ୍ଳେଷଣ, ଦୈନିକ ଶୁଭ ମୁହୂର୍ତ୍ତ ଏବଂ ଏଆଇ-ଆଧାରିତ ଉପାୟ।',
            'ଭର୍ଚୁଆଲ "ସେବା" ଓ ଦାନ: ଗୌ ସେବା, ବ୍ରାହ୍ମଣ ଭୋଜନ କିମ୍ବା ମନ୍ଦିର ନବୀକରଣ ପ୍ରକଳ୍ପ ପାଇଁ ଡିଜିଟାଲ ସର୍ଟିଫିକେଟ ଓ ଭିଡିଓ ପ୍ରମାଣ ସହିତ ଅବଦାନ।',
            'ସଦସ୍ୟତା-ଆଧାରିତ "ନିରନ୍ତର ଚଢାଭା": ଚୟନିତ ମନ୍ଦିରରେ ଆପଣଙ୍କ ନାମରେ ସାପ୍ତାହିକ କିମ୍ବା ମାସିକ ଅର୍ପଣର ସ୍ୱୟଂଚାଳିତ ବ୍ୟବସ୍ଥା।',
            'ଆଧ୍ୟାତ୍ମିକ କଣ୍ଟେଣ୍ଟ ଫିଡ: କଥା, ଦୈନିକ ମନ୍ତ୍ର ଏବଂ ହିନ୍ଦୁ ଆଚାର-ବିଧିର ବ୍ୟାଖ୍ୟା ସହିତ ସ୍ୱଳ୍ପ ଭିଡିଓ।',
          ],
        },
      },
      contact: {
        mailSubject: 'ଆନନ୍ଦମୟ ପାଇଁ ଗ୍ରାହକ ମତାମତ',
        getInTouch: 'ସମ୍ପର୍କ କରନ୍ତୁ',
        subtitle: 'ଆପଣଙ୍କ କଥା ଶୁଣିବାକୁ ଏବଂ ଆଧ୍ୟାତ୍ମିକ ଯାତ୍ରାରେ ସହଯୋଗ କରିବାକୁ ଆମେ ଇଚ୍ଛୁଛୁ',
        address: 'ଠିକଣା',
        addressLine1: 'ଭୁବନେଶ୍ୱର',
        addressLine2: 'ଓଡିଶା, ଭାରତ 751006',
        phone: 'ଫୋନ',
        email: 'ଇମେଲ',
        prompt: 'କୌଣସି ପ୍ରଶ୍ନ କିମ୍ବା ବିଶେଷ ଅନୁରୋଧ ଅଛି କି? ତେବେ ତଳର ବଟନରେ କ୍ଲିକ କରି ଆପଣଙ୍କ ପସନ୍ଦର ଇମେଲ ଆପ୍‌ରୁ ସିଧାସଳଖ ଆମକୁ ଇମେଲ ପଠାନ୍ତୁ।',
        sendEmail: 'ଇମେଲ ପଠାନ୍ତୁ',
      },
    },
    onlinePooja: {
      pageHeader: {
        title: 'ଅନଲାଇନ ପୂଜା ସେବା',
        subtitle: 'ଆପଣଙ୍କ ପବିତ୍ର ଅନୁଷ୍ଠାନ ବୁକ କରନ୍ତୁ ଏବଂ ଘରୁ ଦିବ୍ୟ ଆଶୀର୍ବାଦ ପାଆନ୍ତୁ।',
      },
      poojaTypes: {
        sectionTitle: 'ଆପଣଙ୍କ ଅନଲାଇନ ପୂଜା ବୁକ କରନ୍ତୁ',
        sectionSubtitle: 'ବିଭିନ୍ନ ଅବସର ଓ ଆବଶ୍ୟକତା ପାଇଁ ଆମ ପୂଜା ସେବାଗୁଡିକ ମଧ୍ୟରୁ ବାଛନ୍ତୁ',
        mostPopular: 'ସବୁଠୁ ଲୋକପ୍ରିୟ',
        bookNow: 'ଏବେ ବୁକ କରନ୍ତୁ',
        items: {
          daily: {
            title: 'ଦୈନିକ ପୂଜା',
            description: 'ଆଧ୍ୟାତ୍ମିକ ମଙ୍ଗଳ ପାଇଁ ନିୟମିତ ଦୈନିକ ପ୍ରାର୍ଥନା।',
          },
          special: {
            title: 'ବିଶେଷ ଅବସର ପୂଜା',
            description: 'ଜନ୍ମଦିନ, ବାର୍ଷିକୀ ଓ ବିଶେଷ ଅବସର ପାଇଁ ଅନୁକୂଳିତ ପୂଜା।',
          },
          festival: {
            title: 'ପର୍ବ ପୂଜା',
            description: 'ପ୍ରମୁଖ ହିନ୍ଦୁ ପର୍ବପର୍ବାଣୀ ପାଇଁ ବିଶେଷ ଅନୁଷ୍ଠାନ।',
          },
          remedial: {
            title: 'ଉପାୟ ପୂଜା',
            description: 'ବାଧା ଦୂର କରି ସକାରାତ୍ମକ ଶକ୍ତି ଆଣିବା ପାଇଁ।',
          },
          'house-warming': {
            title: 'ଗୃହ ପ୍ରବେଶ ପୂଜା',
            description: 'ନୂତନ ଘରର ମଙ୍ଗଳ ଓ ଆଶୀର୍ବାଦ ପାଇଁ ପବିତ୍ର ଅନୁଷ୍ଠାନ।',
          },
          success: {
            title: 'ସଫଳତା ପୂଜା',
            description: 'ଶିକ୍ଷାଗତ ସଫଳତା ଓ କ୍ୟାରିଅର ବୃଦ୍ଧି ପାଇଁ।',
          },
        },
      },
      bookingForm: {
        title: 'ଆପଣଙ୍କ ପୂଜା ବୁକ କରନ୍ତୁ',
        subtitle: 'ପବିତ୍ର ଅନୁଷ୍ଠାନ ବୁକ କରିବା ପାଇଁ ବିବରଣୀ ଭରନ୍ତୁ',
        labels: {
          poojaType: 'ପୂଜା ପ୍ରକାର ବାଛନ୍ତୁ',
          temple: 'ମନ୍ଦିର ବାଛନ୍ତୁ',
          preferredDate: 'ପସନ୍ଦର ତାରିଖ',
          preferredTime: 'ପସନ୍ଦର ସମୟ',
          devoteeName: 'ଭକ୍ତଙ୍କ ନାମ',
          email: 'ଇମେଲ ଠିକଣା',
          phone: 'ଫୋନ ନମ୍ବର',
          upiId: 'ୟୁପିଆଇ ଆଇଡି (ଇଚ୍ଛାନୁସାରେ)',
          specialRequests: 'ବିଶେଷ ଅନୁରୋଧ (ଇଚ୍ଛାନୁସାରେ)',
        },
        placeholders: {
          choosePoojaType: 'ପୂଜା ପ୍ରକାର ବାଛନ୍ତୁ',
          chooseTemple: 'ମନ୍ଦିର ବାଛନ୍ତୁ',
          selectTime: 'ସମୟ ବାଛନ୍ତୁ',
          devoteeName: 'ଆପଣଙ୍କ ପୂର୍ଣ୍ଣ ନାମ ଲେଖନ୍ତୁ',
          email: 'ଆପଣଙ୍କ ଇମେଲ ଲେଖନ୍ତୁ',
          phone: 'ଆପଣଙ୍କ ଫୋନ ନମ୍ବର ଲେଖନ୍ତୁ',
          upiId: 'yourname@bank',
          specialRequests: 'ପ୍ରସାଦ/ପୂଜା ସାମଗ୍ରୀ ପାଇବା ପାଇଁ ପିନକୋଡ ସହିତ ଆପଣଙ୍କ ପୂର୍ଣ୍ଣ ଠିକଣା ଲେଖନ୍ତୁ (ପ୍ରସାଦ, ପୂଜା ମାଳା/ଫୁଲ, କୁଙ୍କୁମ/ହଳଦୀ/ଚନ୍ଦନ/ବିଭୂତି, ଧୂପକାଠି ଇତ୍ୟାଦି)।',
        },
        errors: {
          selectPoojaType: 'ଦୟାକରି ପୂଜା ପ୍ରକାର ବାଛନ୍ତୁ',
          selectTemple: 'ଦୟାକରି ମନ୍ଦିର ବାଛନ୍ତୁ',
          selectDate: 'ଦୟାକରି ତାରିଖ ବାଛନ୍ତୁ',
          selectTime: 'ଦୟାକରି ସମୟ ବାଛନ୍ତୁ',
          enterName: 'ଦୟାକରି ଆପଣଙ୍କ ନାମ ଲେଖନ୍ତୁ',
          validEmail: 'ଦୟାକରି ଏକ ବୈଧ ଇମେଲ ଲେଖନ୍ତୁ',
          validPhone: 'ଦୟାକରି ଏକ ବୈଧ ଫୋନ ନମ୍ବର ଲେଖନ୍ତୁ',
          validUpi: 'ଦୟାକରି ଏକ ବୈଧ UPI ଆଇଡି ଲେଖନ୍ତୁ (ଉଦାହରଣ: name@bank)',
        },
        submit: {
          processing: 'ପ୍ରକ୍ରିୟା ଚାଲିଛି...',
          proceedToPayment: 'ଭୁଗତାନକୁ ଆଗେଇବେ',
        },
        toasts: {
          loginRequired: 'ପୂଜା ବୁକ କରିବା ପାଇଁ ଦୟାକରି ଲଗ୍ ଇନ କରନ୍ତୁ।',
          poojaDetailsMissing: 'ଭୁଗତାନ ପାଇଁ ପୂଜା ବିବରଣୀ ମିଳିଲା ନାହିଁ।',
          bookingCreationFailed: 'ବୁକିଂ ସୃଷ୍ଟି ବିଫଳ ହେଲା।',
          orderCreationFailed: 'ଭୁଗତାନ ଅର୍ଡର ସୃଷ୍ଟି ବିଫଳ ହେଲା।',
          bookingConfirmed: 'ବୁକିଂ ସଫଳତାର ସହ ନିଶ୍ଚିତ ହେଲା!',
          viewBookings: 'ବୁକିଂ ଦେଖନ୍ତୁ',
          paymentVerificationFailed: 'ଭୁଗତାନ ସତ୍ୟାପନ ବିଫଳ ହେଲା।',
          paymentCancelled: 'ଭୁଗତାନ ବାତିଲ ହେଲା। ଆପଣଙ୍କ ବୁକିଂର ଭୁଗତାନ ଅପେକ୍ଷାରତ ଅଛି।',
        },
        paymentDescription: '{{title}} ପାଇଁ ଭୁଗତାନ',
        temples: {
          varanasi: 'କାଶୀ ବିଶ୍ୱନାଥ ମନ୍ଦିର, ବାରାଣସୀ',
          jagannath: 'ଜଗନ୍ନାଥ ମନ୍ଦିର, ପୁରୀ',
          sidhhaMahavir: 'ସିଦ୍ଧ ମହାବୀର ମନ୍ଦିର, ପୁରୀ',
          navaGraha: 'ନବଗ୍ରହ ମନ୍ଦିର, ପୁରୀ',
          loknath: 'ଲୋକନାଥ ମନ୍ଦିର, ପୁରୀ',
          mangala: 'ବାଟ ମଙ୍ଗଳା ମନ୍ଦିର, ପୁରୀ',
          cuttackChandi: 'ଚଣ୍ଡୀ ମନ୍ଦିର, କଟକ',
          ugraTara: 'ଉଗ୍ରତାରା ମନ୍ଦିର, ଖୋର୍ଧା',
          tarini: 'ତାରିଣୀ ମନ୍ଦିର',
          mahavir: 'ଶିରୁଳି ମହାବୀର ମନ୍ଦିର, ପୁରୀ',
          mangalnath: 'ମଙ୍ଗଳନାଥ ମନ୍ଦିର, ଉଜ୍ଜୟିନ',
          lakshmi: 'ଲକ୍ଷ୍ମୀ ମନ୍ଦିର, ପୁରୀ',
          vimala: 'ବିମଳା ମନ୍ଦିର, ପୁରୀ',
          bhubaneswari: 'ଭୁବନେଶ୍ୱରୀ ମନ୍ଦିର, ଭୁବନେଶ୍ୱର',
          bagalamukhi: 'ମା ବଗଳାମୁଖୀ ମନ୍ଦିର, ପୁରୀ',
          lingaraj: 'ଲିଙ୍ଗରାଜ ମନ୍ଦିର, ଭୁବନେଶ୍ୱର',
        },
        timeSlots: {
          '06_00': 'ସକାଳ 6:00',
          '08_00': 'ସକାଳ 8:00',
          '10_00': 'ସକାଳ 10:00',
          '12_00': 'ମଧ୍ୟାହ୍ନ 12:00',
          '14_00': 'ଦିନ 2:00',
          '16_00': 'ସନ୍ଧ୍ୟା 4:00',
          '18_00': 'ସନ୍ଧ୍ୟା 6:00',
          '20_00': 'ରାତି 8:00',
        },
      },
      howItWorks: {
        title: 'ଅନଲାଇନ ପୂଜା କେମିତି କାମ କରେ',
        subtitle: 'ଆମ ପବିତ୍ର ଅନୁଷ୍ଠାନରେ ଯୋଗଦେବା ପାଇଁ ସହଜ ପଦକ୍ରମ',
        steps: [
          {
            title: 'ଆପଣଙ୍କ ପୂଜା ବାଛନ୍ତୁ',
            description: 'ଆପଣଙ୍କ ଆବଶ୍ୟକତା ଓ ଅବସର ଅନୁଯାୟୀ ପୂଜା ବାଛନ୍ତୁ',
          },
          {
            title: 'ବୁକ ଏବଂ ଭୁଗତାନ କରନ୍ତୁ',
            description: 'ବୁକିଂ ସମ୍ପୂର୍ଣ୍ଣ କରି ସୁରକ୍ଷିତ ଅନଲାଇନ ଭୁଗତାନ କରନ୍ତୁ',
          },
          {
            title: 'ବିବରଣୀ ପାଆନ୍ତୁ',
            description: 'ପୂଜା ବିବରଣୀ ଓ ଲାଇଭ୍ ଷ୍ଟ୍ରିମିଂ ଲିଙ୍କ ସହିତ ନିଶ୍ଚିତିକରଣ ପାଆନ୍ତୁ',
          },
        ],
      },
      testimonials: {
        title: 'ଆମ ଭକ୍ତମାନେ କଣ କହୁଛନ୍ତି',
        subtitle: 'ଆଧ୍ୟାତ୍ମିକ ସନ୍ଧାନକାରୀ ଆମ ସମୁଦାୟର ଅନୁଭବ',
        items: [
          {
            content: 'ଅନଲାଇନ ପୂଜାର ଅନୁଭବ ନିଶ୍ଚୟ ଦିବ୍ୟ ଥିଲା। ଦୂରେ ଥାଇ ସୁଦ୍ଧା ମୁଁ ଦିବ୍ୟ ଶକ୍ତି ସହିତ ଯୋଗ ଅନୁଭବ କରିଲି। ପୁଜାରୀ ଅତ୍ୟନ୍ତ ଜ୍ଞାନୀ ଥିଲେ ଏବଂ ଅନୁଷ୍ଠାନ ଗଭୀର ଭକ୍ତି ସହିତ କରାଗଲା।',
            author: 'Priya Sharma',
            location: 'ମୁମ୍ବାଇ, ଭାରତ',
          },
          {
            content: 'ଆରମ୍ଭରେ ମୋର ଅନଲାଇନ ପୂଜା ପ୍ରତି ସନ୍ଦେହ ଥିଲା, କିନ୍ତୁ ଅନୁଭବ ମୋ ଆଶାଠାରୁ ଅଧିକ ଭଲ ହେଲା। ଅନୁଷ୍ଠାନର ଗୁଣମାନ ଓ ଆଧ୍ୟାତ୍ମିକ ଶକ୍ତି ଅଦ୍ଭୁତ ଥିଲା। ନିଶ୍ଚୟ ସୁପାରିଶ କରୁଛି!',
            author: 'Rajesh Kumar',
            location: 'ଦିଲ୍ଲୀ, ଭାରତ',
          },
          {
            content: 'ବିଦେଶରେ ରହୁଥିବା ମୋ ପାଇଁ ଏହି ଅନଲାଇନ ପୂଜା ସେବା ଏକ ଆଶୀର୍ବାଦ ସମାନ। ବର୍ତ୍ତମାନ ମୁଁ ପାରମ୍ପରିକ ଅନୁଷ୍ଠାନରେ ଭାଗ ନେଇ ପାରୁଛି ଏବଂ ନିଜ ଆଧ୍ୟାତ୍ମିକ ମୂଳ ସହ ଯୋଗ ରଖିପାରୁଛି।',
            author: 'Anita Patel',
            location: 'ନ୍ୟୁୟର୍କ, ୟୁଏସଏ',
          },
        ],
      },
    },
    bhaktiStore: {
      pageHeader: {
        title: 'ଭକ୍ତି ଷ୍ଟୋର',
        subtitle: 'ଆପଣଙ୍କ ଆଧ୍ୟାତ୍ମିକ ଯାତ୍ରା ପାଇଁ ପବିତ୍ର ସାମଗ୍ରୀର ଚୟନିତ ସଂଗ୍ରହ ଦେଖନ୍ତୁ।',
      },
      loadingProducts: 'ଉତ୍ପାଦ ଲୋଡ୍ ହେଉଛି...',
      errorPrefix: 'ତ୍ରୁଟି',
      messages: {
        fetchFailed: 'ଉତ୍ପାଦ ଆଣିବାରେ ବିଫଳ।',
        addedToCart: 'କାର୍ଟରେ ଯୋଡାଗଲା!',
        viewCart: 'କାର୍ଟ ଦେଖନ୍ତୁ',
        noProductsInCategory: 'ଏହି ଶ୍ରେଣୀରେ କୌଣସି ଉତ୍ପାଦ ମିଳିଲା ନାହିଁ।',
        outOfStock: 'ଏହି ଉତ୍ପାଦ ଷ୍ଟକ୍‌ରେ ନାହିଁ।',
      },
      actions: {
        addToCart: 'କାର୍ଟରେ ଯୋଡନ୍ତୁ',
        buyNow: 'ଏବେ କିଣନ୍ତୁ',
        outOfStock: 'ଷ୍ଟକ୍ ଶେଷ',
      },
      categories: {
        allProducts: 'ସମସ୍ତ ଉତ୍ପାଦ',
        sacred_idols: 'ପବିତ୍ର ମୂର୍ତ୍ତି',
        malas_and_beads: 'ମାଳା ଏବଂ ମଣି',
        spiritual_books: 'ଆଧ୍ୟାତ୍ମିକ ପୁସ୍ତକ',
        incense_and_fragrance: 'ଧୂପ ଏବଂ ସୁଗନ୍ଧ',
        pooja_items: 'ପୂଜା ସାମଗ୍ରୀ',
        yoga_accessories: 'ଯୋଗ ସାହାଯ୍ୟକାରୀ ସାମଗ୍ରୀ',
      },
      products: {
        sacred_ganesha_idol: {
          name: 'ପବିତ୍ର ଗଣେଶ ମୂର୍ତ୍ତି',
          description: 'ଘରୋଇ ପୂଜା ଏବଂ ସମୃଦ୍ଧିର ଆଶୀର୍ବାଦ ପାଇଁ ସୁନ୍ଦର ପିତଳ ଗଣେଶ ମୂର୍ତ୍ତି।',
        },
        rudraksha_panch_mukhi_original: {
          name: 'ରୁଦ୍ରାକ୍ଷ ପଞ୍ଚମୁଖୀ (ମୂଳ)',
          description: 'ଜପ ଏବଂ ଆଧ୍ୟାତ୍ମିକ କୁଶଳତା ପାଇଁ ପ୍ରାମାଣିକ ପଞ୍ଚମୁଖୀ ରୁଦ୍ରାକ୍ଷ।',
        },
        rudraksha_mala: {
          name: 'ରୁଦ୍ରାକ୍ଷ ମାଳା',
          description: 'ଧ୍ୟାନ ଏବଂ ଜପ ପାଇଁ 108 ମଣିର ପ୍ରାମାଣିକ 5-ମୁଖୀ ରୁଦ୍ରାକ୍ଷ ମାଳା।',
        },
        bhagavad_gita_book: {
          name: 'ଭଗବଦ୍‌ଗୀତା ପୁସ୍ତକ',
          description: 'ବିସ୍ତୃତ ଭାଷ୍ୟ ଏବଂ ଅନୁବାଦ ସହିତ ସମ୍ପୂର୍ଣ୍ଣ ଭଗବଦ୍‌ଗୀତା।',
        },
        sandalwood_incense: {
          name: 'ଚନ୍ଦନ ଧୂପ',
          description: 'ପୂଜା ଏବଂ ଧ୍ୟାନ ପାଇଁ 50ଟି ଶୁଦ୍ଧ ଓ ସୁଗନ୍ଧିତ ଚନ୍ଦନ ଅଗରବତ୍ତିର ପ୍ୟାକ୍।',
        },
        copper_pooja_thali: {
          name: 'ତାମ୍ବାର ପୂଜା ଥାଳି',
          description: 'ଦୈନନ୍ଦିନ ଆଚାର ପାଇଁ ପାରମ୍ପରିକ ଏବଂ ସୁନ୍ଦର ତାମ୍ବାର ପୂଜା ଥାଳି ସେଟ୍।',
        },
        crystal_shiva_lingam: {
          name: 'ସ୍ଫଟିକ ଶିବଲିଙ୍ଗ',
          description: 'ଗଭୀର ଧ୍ୟାନ ଏବଂ ସକାରାତ୍ମକ ଶକ୍ତି ପାଇଁ ପ୍ରାକୃତିକ, ଉଚ୍ଚ ଗୁଣବତ୍ତାର ସ୍ଫଟିକ ଶିବଲିଙ୍ଗ।',
        },
        eco_friendly_yoga_mat: {
          name: 'ପରିବେଶ-ମିତ୍ର ଯୋଗ ମ୍ୟାଟ୍',
          description: 'ଆପଣଙ୍କ ଆଧ୍ୟାତ୍ମିକ ଏବଂ ଶାରୀରିକ ଅଭ୍ୟାସ ପାଇଁ ନନ୍-ସ୍ଲିପ୍, ପରିବେଶ-ମିତ୍ର ଯୋଗ ମ୍ୟାଟ୍।',
        },
        tulsi_mala: {
          name: 'ତୁଳସୀ ମାଳା',
          description: 'ଜପ ଏବଂ ଧାରଣ ପାଇଁ ପବିତ୍ର 108 ମଣିର ତୁଳସୀ କାଠର ମାଳା।',
        },
      },
    },
    checkout: {
      emptyCartTitle: 'ଆପଣଙ୍କ କାର୍ଟ ଖାଲି ଅଛି।',
      continueShopping: 'କିଣାକାଟା ଜାରି ରଖନ୍ତୁ',
      title: 'ଚେକଆଉଟ୍',
      form: {
        shippingAddress: 'ଡିଲିଭେରି ଠିକଣା',
        address: 'ଠିକଣା',
        city: 'ସହର',
        state: 'ରାଜ୍ୟ',
        postalCode: 'ପୋଷ୍ଟାଲ କୋଡ୍',
        countryDisplay: 'ଭାରତ',
        phoneNumber: 'ଫୋନ ନମ୍ବର',
        gstNumberLabel: 'ଜିଏସଟି ନମ୍ବର (ଇଚ୍ଛାନୁସାରେ)',
        gstNumberPlaceholder: 'ଉଦାହରଣ: 22AAAAA0000A1Z5',
        upiIdLabel: 'ୟୁପିଆଇ ଆଇଡି (ଇଚ୍ଛାନୁସାରେ)',
        upiIdPlaceholder: 'yourname@bank',
      },
      actions: {
        processing: 'ପ୍ରକ୍ରିୟା ଚାଲିଛି...',
        pay: '₹{{amount}} ଦେୟ କରନ୍ତୁ',
      },
      orderSummary: {
        title: 'ଅର୍ଡର ସାରାଂଶ',
        itemLine: '{{name}} x {{quantity}}',
        total: 'ମୋଟ',
      },
      errors: {
        invalidUpi: 'ଦୟାକରି ବୈଧ UPI ଆଇଡି ଲେଖନ୍ତୁ (ଉଦାହରଣ: name@bank)।',
        paymentFailedPrefix: 'ଭୁଗତାନ ବିଫଳ',
        unexpected: 'ଅପେକ୍ଷିତ ନୁହେଁ ତ୍ରୁଟି ଘଟିଛି।',
      },
    },
    coursePlayer: {
      loading: 'କୋର୍ସ ପ୍ଲେୟର ଲୋଡ୍ ହେଉଛି...',
      errorPrefix: 'ତ୍ରୁଟି',
      courseContentNotFound: 'କୋର୍ସ ସମଗ୍ରୀ ମିଳିଲା ନାହିଁ।',
      progressComplete: '{{percent}}% ସମ୍ପୂର୍ଣ୍ଣ ({{completed}}/{{total}})',
      nonVideoFallback: 'ଏହି ପାଠର ପ୍ରଧାନ ସମଗ୍ରୀ ଏକ ଡାଉନଲୋଡ୍‌ଯୋଗ୍ୟ ସାଧନ।',
      lockedContentTitle: 'ଏହି ସମଗ୍ରୀ ଲକ୍ ଅଛି',
      lockedContentMessage: 'ଏହି ମଡ୍ୟୁଲ କେବଳ \'{{tier}}\' ସବ୍ସ୍କ୍ରାଇବରମାନଙ୍କ ପାଇଁ ଉପଲବ୍ଧ।',
      upgradePlan: 'ଆପଣଙ୍କ ପ୍ଲାନ ଅପଗ୍ରେଡ୍ କରନ୍ତୁ',
      completed: '✓ ସମ୍ପୂର୍ଣ୍ଣ',
      markAsComplete: 'ସମ୍ପୂର୍ଣ୍ଣ ଭାବେ ଚିହ୍ନିତ କରନ୍ତୁ',
      viewOrDownloadNotes: 'ନୋଟ୍ସ ଦେଖନ୍ତୁ କିମ୍ବା ଡାଉନଲୋଡ୍ କରନ୍ତୁ',
      welcomeTitle: 'ସ୍ୱାଗତ!',
      selectLessonPrompt: 'ଆପଣଙ୍କ ଯାତ୍ରା ଆରମ୍ଭ ପାଇଁ ସାଇଡବାରରୁ ଗୋଟିଏ ପାଠ ବାଛନ୍ତୁ।',
      errors: {
        fetchCourseContent: 'କୋର୍ସ ସମଗ୍ରୀ ଆଣିବାରେ ବିଫଳ।',
      },
    },
    shoppingCart: {
      title: 'ଆପଣଙ୍କ କାର୍ଟ',
      closeCart: 'କାର୍ଟ ବନ୍ଦ କରନ୍ତୁ',
      emptyTitle: 'ଆପଣଙ୍କ କାର୍ଟ ଖାଲି ଅଛି',
      emptyDescription: 'ଆରମ୍ଭ କରିବାକୁ କିଛି ଆଧ୍ୟାତ୍ମିକ ସାମଗ୍ରୀ ଯୋଡନ୍ତୁ।',
      subtotal: 'ଉପ-ମୋଟ',
      proceedToCheckout: 'ଚେକଆଉଟ୍‌କୁ ଯାଆନ୍ତୁ',
      decreaseQuantity: '{{name}} ର ପରିମାଣ କମାନ୍ତୁ',
      increaseQuantity: '{{name}} ର ପରିମାଣ ବଢାନ୍ତୁ',
      removeItem: '{{name}} କୁ କାର୍ଟରୁ ହଟାନ୍ତୁ',
      outOfStockRemovedMessage: 'ଏହି ଉତ୍ପାଦ(ଗୁଡିକ) ଷ୍ଟକ୍‌ରେ ନାହିଁ ଏବଂ ଆପଣଙ୍କ କାର୍ଟରୁ ହଟାଯାଇଛି: {{items}}',
      quantityExceedsStockMessage: 'ଅନୁରୋଧ ହୋଇଥିବା ପରିମାଣ ଉପଲବ୍ଧ ଷ୍ଟକ୍‌ଠାରୁ ଅଧିକ। ଆଗକୁ ବଢିବାକୁ ଦୟାକରି ପରିମାଣ କମାନ୍ତୁ।',
    },
    bhaktiYogaPage: {
      header: {
        title: 'ଭକ୍ତି ଯୋଗ ପାଠ୍ୟକ୍ରମ',
        subtitle: 'ଆଧ୍ୟାତ୍ମିକ, ଶାରୀରିକ ଏବଂ ମାନସିକ ସୁସ୍ଥତା ପାଇଁ ଆମର ଚୟନିତ ପାଠ୍ୟକ୍ରମ ସହିତ ଏକ ପରିବର୍ତ୍ତନଶୀଳ ଯାତ୍ରା ଆରମ୍ଭ କରନ୍ତୁ।',
      },
      loadingCourses: 'ପାଠ୍ୟକ୍ରମ ଲୋଡ୍ ହେଉଛି...',
      errorPrefix: 'ତ୍ରୁଟି',
      noCoursesMessage: 'ଏହି ମୁହୂର୍ତ୍ତରେ କୌଣସି ପାଠ୍ୟକ୍ରମ ଉପଲବ୍ଧ ନାହିଁ। ଦୟାକରି ପରେ ପୁଣି ଦେଖନ୍ତୁ।',
      errors: {
        loadCourses: 'ପାଠ୍ୟକ୍ରମ ଲୋଡ୍ କରିବାରେ ବିଫଳ।',
      },
      levels: {
        beginner: 'ଆରମ୍ଭିକ',
        intermediate: 'ମଧ୍ୟମ ସ୍ତର',
        advanced: 'ଉନ୍ନତ',
        all_levels: 'ସମସ୍ତ ସ୍ତର',
        all_level: 'ସମସ୍ତ ସ୍ତର',
        all_ages: 'ସମସ୍ତ ବୟସ୍',
        children: 'ଶିଶୁ',
        special: 'ବିଶେଷ',
      },
      tiers: {
        free: 'ନିଶୁଳ୍କ',
        plus: 'ପ୍ଲସ',
        premium: 'ପ୍ରିମିୟମ',
      },
      catalogues: {},
      courses: {},
    },
    bhaktiYogaCourseDetail: {
      loadingCourse: 'ପାଠ୍ୟକ୍ରମ ଲୋଡ୍ ହେଉଛି...',
      errorPrefix: 'ତ୍ରୁଟି',
      courseNotFound: 'ପାଠ୍ୟକ୍ରମ ମିଳିଲା ନାହିଁ।',
      minutesShort: 'ମିନିଟ',
      sections: {
        aboutThisCourse: 'ଏହି ପାଠ୍ୟକ୍ରମ ବିଷୟରେ',
        curriculum: 'ପାଠ୍ୟକ୍ରମ ଗଠନ',
      },
      actions: {
        goToCourse: 'ପାଠ୍ୟକ୍ରମକୁ ଯାଆନ୍ତୁ',
        loginToEnroll: 'ନାମଲେଖା ପାଇଁ ଲଗ୍ ଇନ କରନ୍ତୁ',
        processing: 'ପ୍ରକ୍ରିୟା ଚାଲିଛି...',
        startCourse: 'ପାଠ୍ୟକ୍ରମ ଆରମ୍ଭ କରନ୍ତୁ',
        enrolling: 'ନାମଲେଖା ହେଉଛି...',
        enrollForFree: 'ନିଶୁଳ୍କ ନାମଲେଖା କରନ୍ତୁ',
        subscribeToTier: '{{tier}} ପାଇଁ ସବ୍ସ୍କ୍ରାଇବ କରନ୍ତୁ',
      },
      form: {
        upiIdLabel: 'ୟୁପିଆଇ ଆଇଡି (ଇଚ୍ଛାନୁସାରେ)',
        upiIdPlaceholder: 'yourname@bank',
      },
      sidebar: {
        fullAccessNote: 'ନାମଲେଖା ପରେ ସମସ୍ତ କୋର୍ସ ଭିଡିଓ ଏବଂ ନୋଟ୍ସର ପୂର୍ଣ୍ଣ ଅଭିଗମ୍ୟତା ମିଳିବ।',
      },
      errors: {
        loadCourseDetails: 'ପାଠ୍ୟକ୍ରମ ବିବରଣୀ ଲୋଡ୍ କରିବାରେ ବିଫଳ।',
        invalidUpi: 'ଦୟାକରି ବୈଧ UPI ଆଇଡି ଲେଖନ୍ତୁ (ଉଦାହରଣ: name@bank)।',
        unexpected: 'ଅପେକ୍ଷିତ ନୁହେଁ ତ୍ରୁଟି ଘଟିଛି।',
      },
      courses: {},
      modules: {},
      lessons: {},
    },
    bhaktiJaapaPage: {
      header: {
        title: 'ଭକ୍ତି ଜପ',
        subtitle: 'ଆପଣଙ୍କ ଦୈନିକ ମନ୍ତ୍ର-ଜପ ଅଭ୍ୟାସ ପାଇଁ ଏକ ପବିତ୍ର ସ୍ଥାନ।',
      },
      settings: {
        chooseDivineName: 'ଏକ ଦିବ୍ୟ ନାମ ବାଛନ୍ତୁ:',
      },
      chantingArea: {
        tapToChant: 'ଜପ ପାଇଁ ସ୍ପର୍ଶ କରନ୍ତୁ',
      },
      counters: {
        sessionJaapa: 'ସେସନ ଜପ',
        malasCompleted: 'ସମ୍ପୂର୍ଣ୍ଣ ମାଳା',
      },
      analytics: {
        todaysTotalJaapas: 'ଆଜିର ମୋଟ ଜପ',
        todaysMalasCompleted: 'ଆଜିର ସମ୍ପୂର୍ଣ୍ଣ ମାଳା',
        viewMyAnalytics: 'ମୋର ଆନାଲିଟିକ୍ସ ଦେଖନ୍ତୁ',
      },
      voiceSelector: {
        loadingVoices: 'ଧ୍ୱନିଗୁଡ଼ିକ ଲୋଡ୍ ହେଉଛି...',
        selectVoice: 'ଧ୍ୱନି ବାଛନ୍ତୁ:',
        silent: 'ନିରବ',
        hindiIndian: 'ହିନ୍ଦୀ ଧ୍ୱନି (ଭାରତ)',
        hindiIndianCloser: 'ହିନ୍ଦୀ ଧ୍ୱନି (ଭାରତ - ସ୍ପଷ୍ଟ)',
      },
      soundToggle: {
        toggleBackgroundSound: 'ପୃଷ୍ଠଭୂମି ଧ୍ୱନି ଟଗଲ କରନ୍ତୁ',
        backgroundFlute: 'ପୃଷ୍ଠଭୂମି ବାଂଶୀ',
        mute: 'ନିରବ କରନ୍ତୁ',
        unmute: 'ଧ୍ୱନି ଚାଲୁ କରନ୍ତୁ',
      },
      divineNames: {
        omNamahaShivaya: 'ଓଁ ନମଃ ଶିବାୟ',
        omNamahShivaya: 'ଓଁ ନମଃ ଶିବାୟ',
        jaiShreeKrishna: 'ଜୟ ଶ୍ରୀ କୃଷ୍ଣ',
        jaiShreeRam: 'ଜୟ ଶ୍ରୀ ରାମ',
        shreeRadha: 'ଶ୍ରୀ ରାଧା',
        sitaRam: 'ସୀତା ରାମ',
        omGanGanapatayeNamah: 'ଓଁ ଗଂ ଗଣପତୟେ ନମଃ',
        omRudrayaNamah: 'ଓଁ ରୁଦ୍ରାୟ ନମଃ',
        radheKrishna: 'ରାଧେ କୃଷ୍ଣ',
        omSaiRam: 'ଓଁ ସାଇ ରାମ',
        omKalabhiravayNamah: 'ଓଁ କାଳଭୈରବାୟ ନମଃ',
        shreem: 'ଶ୍ରୀଂ',
        aim: 'ଐଂ',
        hareKrishnaMahaMantra: 'ହରେ କୃଷ୍ଣ ହରେ କୃଷ୍ଣ\nକୃଷ୍ଣ କୃଷ୍ଣ ହରେ ହରେ\nହରେ ରାମ ହରେ ରାମ\nରାମ ରାମ ହରେ ହରେ',
        // Backward compatibility for historical entries.
        hareKrishna: 'ହରେ କୃଷ୍ଣ',
        shreeRam: 'ଶ୍ରୀ ରାମ',
        shreeKrishna: 'ଶ୍ରୀ କୃଷ୍ଣ',
        jaiMaaDurga: 'ଜୟ ମା ଦୁର୍ଗା',
        maaDurga: 'ମା ଦୁର୍ଗା',
        jaiHanuman: 'ଜୟ ହନୁମାନ',
        hanuman: 'ହନୁମାନ',
      },
    },
    dashboard: {
      sidebar: {
        myPoojaBookings: 'ମୋର ପୂଜା ବୁକିଂ',
        myStoreOrders: 'ମୋର ଷ୍ଟୋର ଅର୍ଡର',
        myCourses: 'ମୋର କୋର୍ସ',
        jaapaAnalytics: 'ଜପ ଆନାଲିଟିକ୍ସ',
        myProfile: 'ମୋର ପ୍ରୋଫାଇଲ',
        menu: 'ମେନୁ',
      },
      common: {
        errorPrefix: 'ତ୍ରୁଟି',
        status: {
          pending: 'ଅପେକ୍ଷାରତ',
          paid: 'ଭୁଗତା ହୋଇଛି',
          completed: 'ସମ୍ପୂର୍ଣ୍ଣ',
          failed: 'ବିଫଳ',
          cancelled: 'ବାତିଲ',
          canceled: 'ବାତିଲ',
          processing: 'ପ୍ରକ୍ରିୟାରତ',
          shipped: 'ପଠାଯାଇଛି',
          delivered: 'ଡିଲିଭର୍ ହୋଇଛି',
          refunded: 'ରିଫଣ୍ଡ ହୋଇଛି',
        },
      },
      bookings: {
        loading: 'ଆପଣଙ୍କ ବୁକିଂ ଲୋଡ୍ ହେଉଛି...',
        emptyMessage: 'ଆପଣ ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି ପୂଜା ବୁକ୍ କରିନାହାନ୍ତି।',
        bookNow: 'ଏବେ ପୂଜା ବୁକ୍ କରନ୍ତୁ',
        fields: {
          bookingId: 'ବୁକିଂ ଆଇଡି',
          temple: 'ମନ୍ଦିର',
          date: 'ତାରିଖ',
          time: 'ସମୟ',
          bookedOn: 'ବୁକ୍ କରାଯାଇଥିବା ତାରିଖ',
        },
        errors: {
          fetchFailed: 'ବୁକିଂ ଆଣିବାରେ ବିଫଳ',
        },
      },
      orders: {
        loading: 'ଆପଣଙ୍କ ଅର୍ଡର ଲୋଡ୍ ହେଉଛି...',
        emptyMessage: 'ଆପଣ ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି ଅର୍ଡର କରିନାହାନ୍ତି।',
        shopNow: 'ଏବେ କିଣନ୍ତୁ',
        orderLabel: 'ଅର୍ଡର',
        placedOn: 'ଅର୍ଡର ତାରିଖ',
        quantity: 'ପରିମାଣ',
        total: 'ମୋଟ',
        errors: {
          fetchFailed: 'ଅର୍ଡର ଆଣିବାରେ ବିଫଳ',
        },
      },
      courses: {
        title: 'ମୋର ଭକ୍ତି ଯୋଗ କୋର୍ସ',
        loading: 'ଆପଣଙ୍କ କୋର୍ସ ଲୋଡ୍ ହେଉଛି...',
        emptyMessage: 'ଆପଣ ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି କୋର୍ସରେ ନାମଲେଖା କରିନାହାନ୍ତି।',
        exploreCourses: 'କୋର୍ସ ଦେଖନ୍ତୁ',
        courseTitleMissing: 'କୋର୍ସ ଶୀର୍ଷକ ଉପଲବ୍ଧ ନାହିଁ',
        progressComplete: '{{percent}}% ସମ୍ପୂର୍ଣ୍ଣ',
        resumeCourse: 'କୋର୍ସ ଜାରି ରଖନ୍ତୁ',
        startCourse: 'କୋର୍ସ ଆରମ୍ଭ କରନ୍ତୁ',
        errors: {
          fetchFailed: 'କୋର୍ସ ଆଣିବାରେ ବିଫଳ',
        },
      },
      profile: {
        loading: 'ପ୍ରୋଫାଇଲ ଲୋଡ୍ ହେଉଛି...',
        loadFailed: 'ଉପଯୋଗକର୍ତ୍ତା ପ୍ରୋଫାଇଲ ଲୋଡ୍ ହୋଇପାରିଲା ନାହିଁ। ଦୟାକରି ପୁଣି ଲଗ୍ ଇନ କରନ୍ତୁ।',
        avatarAlt: 'ଉପଯୋଗକର୍ତ୍ତା ଅଭତାର',
        confirmChangePassword: 'ପାସୱାର୍ଡ ସୁରକ୍ଷିତ ଭାବେ ପରିବର୍ତ୍ତନ ପାଇଁ ଆପଣଙ୍କୁ ଲଗ୍ ଆଉଟ୍ କରାଯିବ। ଆପଣ ଜାରି ରଖିବାକୁ ଚାହୁଁଛନ୍ତି କି?',
        fields: {
          fullName: 'ପୂର୍ଣ୍ଣ ନାମ',
          emailAddress: 'ଇମେଲ ଠିକଣା',
          role: 'ଭୂମିକା',
          memberSince: 'ସଦସ୍ୟ ହେବାର ତାରିଖ',
        },
        editProfile: 'ପ୍ରୋଫାଇଲ ସମ୍ପାଦନ କରନ୍ତୁ',
        changePassword: 'ପାସୱାର୍ଡ ପରିବର୍ତ୍ତନ କରନ୍ତୁ',
      },
    },
    jaapaAnalyticsPage: {
      title: 'ମୋର ଜପ ଆନାଲିଟିକ୍ସ',
      actions: {
        backToBhaktiJaapa: 'ଭକ୍ତି ଜପକୁ ଫେରନ୍ତୁ',
      },
      loadingAnalytics: 'ଆନାଲିଟିକ୍ସ ଲୋଡ୍ ହେଉଛି...',
      errorPrefix: 'ତ୍ରୁଟି',
      filters: {
        today: 'ଆଜି',
        thisWeek: 'ଏହି ସପ୍ତାହ',
        thisMonth: 'ଏହି ମାସ',
        allTime: 'ସମସ୍ତ ସମୟ',
      },
      cards: {
        totalJaapas: 'ମୋଟ ଜପ',
        malasCompleted: 'ସମ୍ପୂର୍ଣ୍ଣ ମାଳା',
      },
      breakdown: {
        title: 'ମନ୍ତ୍ର ବିବରଣୀ',
        chants: 'ଜପ',
        malaSingular: 'ମାଳା',
        malasPlural: 'ମାଳା',
        noData: 'ଏହି ଅବଧି ପାଇଁ କୌଣସି ଜପ ରେକର୍ଡ ନାହିଁ।',
        startChanting: 'ଜପ ଆରମ୍ଭ କରନ୍ତୁ',
      },
      errors: {
        fetchFailed: 'ଆନାଲିଟିକ୍ସ ଆଣିବାରେ ବିଫଳ',
      },
    },
    liveDarshan: {
      header: {
        title: 'ଭକ୍ତି ଦର୍ଶନ',
        subtitle: 'ଭାରତର ମନ୍ଦିର ଓ ତୀର୍ଥସ୍ଥଳରୁ ପବିତ୍ର ଦର୍ଶନ ଦେଖନ୍ତୁ।',
      },
      liveBadge: 'ଲାଇଭ୍',
      iframeTitle: 'ଭକ୍ତି ଦର୍ଶନ - {{name}}',
      temples: {
        'puri-jagannath': {
          name: 'ପୁରୀ ଜଗନ୍ନାଥ ମନ୍ଦିର (ସ୍ରୋତ: ଜୟ ଜଗନ୍ନାଥ ଟିଭି)',
          location: 'ପୁରୀ, ଓଡିଶା',
        },
        'kashi-vishwanath': {
          name: 'କାଶୀ ବିଶ୍ୱନାଥ ମନ୍ଦିର',
          location: 'ବାରାଣସୀ, ଉତ୍ତର ପ୍ରଦେଶ',
        },
        'shirdi-sai': {
          name: 'ଶିରଡି ସାଇ ବାବା ମନ୍ଦିର',
          location: 'ଶିରଡି, ମହାରାଷ୍ଟ୍ର',
        },
        'somnath-temple': {
          name: 'ସୋମନାଥ ମନ୍ଦିର',
          location: 'ଭେରାଭଲ, ଗୁଜରାଟ',
        },
        'vaishno-devi': {
          name: 'ବୈଷ୍ଣୋ ଦେବୀ ମନ୍ଦିର',
          location: 'କତ୍ରା, ଜମ୍ମୁ ଓ କାଶ୍ମୀର',
        },
        'golden-temple': {
          name: 'ସ୍ୱର୍ଣ୍ଣ ମନ୍ଦିର (ହରମନ୍ଦିର ସାହିବ)',
          location: 'ଅମୃତସର, ପଞ୍ଜାବ',
        },
        'tirupati-balaji': {
          name: 'ତିରୁପତି ବାଳାଜି ମନ୍ଦିର',
          location: 'ତିରୁପତି, ଆନ୍ଧ୍ର ପ୍ରଦେଶ',
        },
        rameshwaram: {
          name: 'ରାମେଶ୍ୱରମ ମନ୍ଦିର',
          location: 'ରାମେଶ୍ୱରମ, ତମିଳନାଡୁ',
        },
        'Vitthal-Rukmini': {
          name: 'ବିଠ୍ଠଳ-ରୁକ୍ମିଣୀ ମନ୍ଦିର',
          location: 'ପଣ୍ଢରପୁର, ମହାରାଷ୍ଟ୍ର',
        },
        Dwarkadhish: {
          name: 'ଦ୍ୱାରକାଧୀଶ ମନ୍ଦିର',
          location: 'ଦ୍ୱାରକା, ଗୁଜରାଟ',
        },
        Sidhhivinayak: {
          name: 'ସିଦ୍ଧିବିନାୟକ ମନ୍ଦିର',
          location: 'ମୁମ୍ବାଇ, ମହାରାଷ୍ଟ୍ର',
        },
        'ISKCON-Vrindavan': {
          name: 'ଇସ୍କନ୍ ମନ୍ଦିର',
          location: 'ବୃନ୍ଦାବନ, ଉତ୍ତର ପ୍ରଦେଶ',
        },
      },
    },
    bhaktiSamadhan: {
      hero: {
        title: 'ଭକ୍ତି ଏଆଇ ଗୁରୁ',
        subtitle: 'ବୁଦ୍ଧିମାନ ପରାମର୍ଶ: ଆପଣଙ୍କ ଜୀବନର ପବିତ୍ର ଯାତ୍ରା ପାଇଁ ଦିବ୍ୟ ଦିଗଦର୍ଶନ',
      },
      tabs: {
        askAdvisor: 'ଏଡଭାଇଜର୍ କୁ ପଚାରନ୍ତୁ',
        chat: 'ଚାଟ୍',
        browseRemedies: 'ଉପାୟ ଦେଖନ୍ତୁ',
      },
      advisor: {
        describeTitle: 'ଆପଣଙ୍କ ପରିସ୍ଥିତି ବର୍ଣ୍ଣନା କରନ୍ତୁ',
        describeDesc: 'ଆପଣଙ୍କ ବର୍ତ୍ତମାନ ପରିସ୍ଥିତି କିମ୍ବା କଉଥିପାଇଁ ଆଶୀର୍ବାଦ ଚାହୁଁଛନ୍ତି ସେଥି କହନ୍ତୁ। ଆମର ଏଆଇ ଭକ୍ତି ଗୁରୁ ସର୍ବୋତ୍ତମ ପୂଜା ଓ ଦେବତା ପରାମର୍ଶ ଦେବେ।',
        placeholder: 'ଉଦାହରଣ: ମୋ ପୁଅର ଆସନ୍ତା ଗୁରୁତ୍ୱପୂର୍ଣ୍ଣ ପରୀକ୍ଷାର ବାଧା ଦୂର ପାଇଁ କେଉଁ ପୂଜା କରିବି?',
        gettingRecommendation: 'ପରାମର୍ଶ ଆଣାଯାଉଛି...',
        getRecommendation: 'ପରାମର୍ଶ ପାଆନ୍ତୁ',
        consultingWisdom: 'ଆଧ୍ୟାତ୍ମିକ ଜ୍ଞାନରୁ ପରାମର୍ଶ ଚାଲିଛି...',
        spiritualGuidance: 'ଆଧ୍ୟାତ୍ମିକ ଦିଗଦର୍ଶନ',
        noRecommendation: 'କୌଣସି ପରାମର୍ଶ ଉପଲବ୍ଧ ନାହିଁ।',
        genericError: 'କ୍ଷମା କରିବେ, କିଛି ତ୍ରୁଟି ହୋଇଛି। ଦୟାକରି ପୁଣି ଚେଷ୍ଟା କରନ୍ତୁ।',
      },
      guest: {
        defaultLimitMessage: 'ଗେଷ୍ଟ ଦୈନିକ ସୀମା ପୂରା ହୋଇଛି। ଜାରି ରଖିବାକୁ ଲଗ୍ ଇନ କିମ୍ବା ସାଇନ୍ ଅପ୍ କରନ୍ତୁ।',
        tryAgainAfter: '{{baseMessage}} ଆପଣ {{time}} ପରେ ପୁଣି ଚେଷ୍ଟା କରିପାରିବେ।',
      },
      chat: {
        genericError: 'କ୍ଷମା କରିବେ, କିଛି ତ୍ରୁଟି ହୋଇଛି। ଦୟାକରି ପୁଣି ଚେଷ୍ଟା କରନ୍ତୁ।',
        historyTitle: 'ଚାଟ୍ ଇତିହାସ',
        newChat: 'ନୂଆ ଚାଟ୍',
        loading: 'ଲୋଡ୍ ହେଉଛି...',
        noConversations: 'ଏପର୍ଯ୍ୟନ୍ତ କୌଣସି ଆଲୋଚନା ନାହିଁ',
        untitled: 'ଶିରୋନାମ ବିହୀନ',
        deleteConversation: 'ଆଲୋଚନା ବିଲୋପ କରନ୍ତୁ',
        spiritualChat: 'ଆଧ୍ୟାତ୍ମିକ ଚାଟ୍',
        namaste: 'ନମସ୍କାର!',
        emptyPrompt: 'ମୋତେ ବେଦିକ ଜ୍ଞାନ, ପୂଜା, ମନ୍ତ୍ର, ଜ୍ୟୋତିଷ, ଯୋଗ, ଧ୍ୟାନ କିମ୍ବା ଯେକୌଣସି ଆଧ୍ୟାତ୍ମିକ ପ୍ରଶ୍ନ ପଚାରନ୍ତୁ।',
        guestModeInfo: 'ଗେଷ୍ଟ ମୋଡ୍ — 3 ସନ୍ଦେଶ/ଦିନ। ଅସୀମ ପାଇଁ ଲଗ୍ ଇନ କରନ୍ତୁ।',
        suggestions: [
          'ହନୁମାନ ଚାଳିସାର ମହତ୍ତ୍ୱ କଣ?',
          'କ୍ୟାରିଅର ଉନ୍ନତି ପାଇଁ କେଉଁ ପୂଜା କରିବି?',
          'ଭଗବଦ୍‌ଗୀତାରେ କର୍ମର ଅର୍ଥ ବ୍ୟାଖ୍ୟା କରନ୍ତୁ।',
          'ଓଁ ନମଃ ଶିବାୟ ଜପର କଣ ଉପକାର?',
          'ନକାରାତ୍ମକ ଚିନ୍ତାକୁ ଆଧ୍ୟାତ୍ମିକ ଭାବେ କିପରି କମେଇବି?',
          'ମାନସିକ ଶାନ୍ତି ଓ ଏକାଗ୍ରତା ପାଇଁ କେଉଁ ମନ୍ତ୍ର ଶ୍ରେଷ୍ଠ?',
          'ବିବାହର ବିଳମ୍ବ ହଟାଇବାକୁ କେଉଁ ପୂଜା ସାହାଯ୍ୟକାରୀ?',
          'ଘରେ ଅଧିକ ସକାରାତ୍ମକତା କିପରି ଆଣିବି?',
          'ଚାପ ଓ ଆତଙ୍କ ପାଇଁ କେଉଁ ଆଧ୍ୟାତ୍ମିକ ଅଭ୍ୟାସ ସାହାଯ୍ୟକାରୀ?',
          'ପାରିବାରିକ ସମନ୍ୱୟ ପାଇଁ ସର୍ବୋତ୍ତମ ଉପାୟ କଣ?'
        ],
        askPlaceholder: 'ଆପଣଙ୍କ ଆଧ୍ୟାତ୍ମିକ ପ୍ରଶ୍ନ ପଚାରନ୍ତୁ...',
        askButton: 'ପଚାରନ୍ତୁ',
      },
      categories: {
        education: 'ଶିକ୍ଷା',
        career: 'କ୍ୟାରିଅର',
        marriage: 'ବିବାହ',
        health: 'ସ୍ୱାସ୍ଥ୍ୟ',
        wealth: 'ଧନ',
        family: 'ପରିବାର',
        protection: 'ସୁରକ୍ଷା',
        children: 'ସନ୍ତାନ',
        spiritualGrowth: 'ଆଧ୍ୟାତ୍ମିକ ଉନ୍ନତି',
        allRemedies: 'ସମସ୍ତ ଉପାୟ',
      },
      remedies: {
        browseByCategory: 'ଶ୍ରେଣୀ ଅନୁଯାୟୀ ଦେଖନ୍ତୁ',
        primaryDeity: 'ମୁଖ୍ୟ ଦେବତା',
        recommendedPoojas: 'ସୁପାରିଶ କୃତ ପୂଜା',
        morePrompt: '{{title}} ବିଷୟରେ ଅଧିକ କହନ୍ତୁ — {{desc}}',
        wealthFinancialProsperity: {
          title: 'ଧନ ଓ ଆର୍ଥିକ ସମୃଦ୍ଧି',
          desc: 'ଆର୍ଥିକ ସ୍ଥିରତା, ବ୍ୟବସାୟିକ ସଫଳତା ଓ ସମୃଦ୍ଧି ପାଇଁ',
          deity: 'ମା ଲକ୍ଷ୍ମୀ',
          deityDesc: 'ମା ଲକ୍ଷ୍ମୀ ଧନ, ସମୃଦ୍ଧି ଓ ସଫଳତାର ପରମ ଉତ୍ସ। ସେ ଆର୍ଥିକ ଉନ୍ନତି ଓ ସୁଖ-ସମୃଦ୍ଧିର ଆଶୀର୍ବାଦ ଦିଅନ୍ତି।',
          poojas: ['ଲକ୍ଷ୍ମୀ ଅର୍ଚ୍ଚନା', 'ଲକ୍ଷ୍ମୀ ହୋମମ୍', 'ଲକ୍ଷ୍ମୀ ସହସ୍ରନାମ', 'କୁବେର ପୂଜା'],
        },
        familyHarmonyHouseholdPeace: {
          title: 'ପାରିବାରିକ ସମନ୍ୱୟ ଓ ଗୃହଶାନ୍ତି',
          desc: 'ଘରେ ଶାନ୍ତି, ବିବାଦ ସମାଧାନ ଓ ପରିବାରୀକ ସମୃଦ୍ଧି ପାଇଁ',
          deity: 'ମା ଅନ୍ନପୂର୍ଣ୍ଣା',
          deityDesc: 'ମା ଅନ୍ନପୂର୍ଣ୍ଣା ପୋଷଣ, ଯତ୍ନ ଓ ପରିବାରୀକ କଳ୍ୟାଣର ପ୍ରତୀକ। ସେ ଘରେ ସୁଖ-ଶାନ୍ତି ଓ ସମୃଦ୍ଧି ଦିଅନ୍ତି।',
          poojas: ['ଅନ୍ନପୂର୍ଣ୍ଣା ଅର୍ଚ୍ଚନା', 'ଦୁର୍ଗା ସପ୍ତଶତୀ', 'ଗଣେଶ ମହା ପୂଜା', 'ଗୃହ-ଆଶୀର୍ବାଦ ହବନ'],
        },
        academicExcellenceKnowledge: {
          title: 'ଶିକ୍ଷାଗତ ଉତ୍କର୍ଷ ଓ ଜ୍ଞାନ',
          desc: 'ପଢ଼ାଶୁଣା, ପରୀକ୍ଷା ଓ ଗଭୀର ଜ୍ଞାନରେ ସଫଳତା ପାଇଁ',
          deity: 'ମା ସରସ୍ୱତୀ',
          deityDesc: 'ମା ସରସ୍ୱତୀ ଜ୍ଞାନ, ସଙ୍ଗୀତ ଓ ଶିକ୍ଷାର ଦେବୀ। ସେ ବୁଦ୍ଧି ଓ ଶିକ୍ଷାରେ ସଫଳତା ଦିଅନ୍ତି।',
          poojas: ['ସରସ୍ୱତୀ ପୂଜା', 'ହୟଗ୍ରୀବ ହୋମମ୍', 'ବିଦ୍ୟା ଲକ୍ଷ୍ମୀ ପୂଜା', 'ଅକ୍ଷରାଭ୍ୟାସମ୍'],
        },
        careerGrowthProfessionalSuccess: {
          title: 'କ୍ୟାରିଅର ବୃଦ୍ଧି ଓ ପେଶାଗତ ସଫଳତା',
          desc: 'ଚାକିରିରେ ପଦୋନ୍ନତି, ବ୍ୟବସାୟ ବୃଦ୍ଧି ଓ ବାଧା ନିବାରଣ ପାଇଁ',
          deity: 'ଭଗବାନ ଗଣେଶ',
          deityDesc: 'ଭଗବାନ ଗଣେଶ ବିଘ୍ନହର୍ତ୍ତା ଓ ଶୁଭାରମ୍ଭର ଦେବତା। ସେ ସଫଳତାର ପଥ ଖୋଲିଦିଅନ୍ତି।',
          poojas: ['ଗଣେଶ ହୋମମ୍', 'ନବଗ୍ରହ ପୂଜା', 'ବିଷ୍ଣୁ ସହସ୍ରନାମ', 'ଶନି ପୂଜା'],
        },
        marriageRelationshipBliss: {
          title: 'ବିବାହ ଓ ସମ୍ପର୍କର ସୁଖ',
          desc: 'ଯୋଗ୍ୟ ଜୀବନସାଥୀ, ସୁଖୀ ବିବାହିତ ଜୀବନ ଓ ସମ୍ପର୍କ ସମସ୍ୟା ସମାଧାନ ପାଇଁ',
          deity: 'ମା ପାର୍ବତୀ',
          deityDesc: 'ମା ପାର୍ବତୀ ପ୍ରେମ, ଭକ୍ତି ଓ ଦାମ୍ପତ୍ୟ ସମନ୍ୱୟର ଦେବୀ। ସେ ଦୃଢ଼ ଓ ଦୀର୍ଘସ୍ଥାୟୀ ସମ୍ପର୍କ ଦିଅନ୍ତି।',
          poojas: ['ସ୍ୱୟଂବର ପାର୍ବତୀ ହୋମମ୍', 'ମଙ୍ଗଳା ଗୌରୀ ପୂଜା', 'ବିବାହ ପଞ୍ଚମୀ ପୂଜା', 'କାତ୍ୟାୟନୀ ପୂଜା'],
        },
        healthHealing: {
          title: 'ସ୍ୱାସ୍ଥ୍ୟ ଓ ଆରୋଗ୍ୟ',
          desc: 'ରୋଗମୁକ୍ତି, ଭଲ ସ୍ୱାସ୍ଥ୍ୟ ଓ ଦୀର୍ଘାୟୁ ପାଇଁ',
          deity: 'ଭଗବାନ ଧନ୍ୱନ୍ତରି',
          deityDesc: 'ଭଗବାନ ଧନ୍ୱନ୍ତରି ଆୟୁର୍ବେଦର ଦେବତା ଓ ଦିବ୍ୟ ଚିକିତ୍ସକ। ସେ ଆରୋଗ୍ୟ ଓ ସୁସ୍ଥତାର ଆଶୀର୍ବାଦ ଦିଅନ୍ତି।',
          poojas: ['ମହାମୃତ୍ୟୁଞ୍ଜୟ ଜାପ', 'ଧନ୍ୱନ୍ତରି ହୋମମ୍', 'ସୁଦର୍ଶନ ହୋମମ୍', 'ଆୟୁଷ ହୋମମ୍'],
        },
        protectionSafety: {
          title: 'ରକ୍ଷା ଓ ସୁରକ୍ଷା',
          desc: 'ନକାରାତ୍ମକ ଶକ୍ତି, ଦୃଷ୍ଟିଦୋଷ ଓ ପରିବାର ସୁରକ୍ଷା ପାଇଁ',
          deity: 'ଭଗବାନ ହନୁମାନ',
          deityDesc: 'ଭଗବାନ ହନୁମାନ ଶକ୍ତି, ସାହସ ଓ ଭକ୍ତିର ପ୍ରତୀକ। ସେ ଭକ୍ତଙ୍କୁ ସମସ୍ତ ସଙ୍କଟରୁ ରକ୍ଷା କରନ୍ତି।',
          poojas: ['ହନୁମାନ ଚାଳିସା ପାଠ', 'ସୁଦର୍ଶନ ହୋମମ୍', 'ଦୁର୍ଗା କବଚ ପାଠ', 'ବଗଳାମୁଖୀ ପୂଜା'],
        },
        childrenProgeny: {
          title: 'ସନ୍ତାନ ଓ ବଂଶବୃଦ୍ଧି',
          desc: 'ସୁଖୀ ପିତୃମାତୃତ୍ୱ, ଶିଶୁ ସ୍ୱାସ୍ଥ୍ୟ ଓ ଭବିଷ୍ୟତ ସଫଳତା ପାଇଁ',
          deity: 'ସନ୍ତୋଷୀ ମା',
          deityDesc: 'ସନ୍ତୋଷୀ ମା ସନ୍ତୋଷ ଓ ଖୁସିର ଦେବୀ। ସେ ପରିବାରକୁ ସୁସ୍ଥ ସନ୍ତାନ ଓ ଆନନ୍ଦ ଦିଅନ୍ତି।',
          poojas: ['ସନ୍ତାନ ଗୋପାଳ ହୋମମ୍', 'ପୁତ୍ରକାମେଷ୍ଟି ଯଜ୍ଞ', 'ଗର୍ଭ ରକ୍ଷା ପୂଜା', 'ସନ୍ତୋଷୀ ମା ବ୍ରତ'],
        },
        spiritualAwakeningInnerPeace: {
          title: 'ଆଧ୍ୟାତ୍ମିକ ଜାଗରଣ ଓ ଅନ୍ତର୍ଶାନ୍ତି',
          desc: 'ଗଭୀର ଧ୍ୟାନ, ଆଧ୍ୟାତ୍ମିକ ଉନ୍ନତି ଓ ଆତ୍ମସାକ୍ଷାତ୍କାର ପାଇଁ',
          deity: 'ଭଗବାନ ଶିବ',
          deityDesc: 'ଭଗବାନ ଶିବ ପରମ ଚେତନା, ଧ୍ୟାନ ଓ ପରିବର୍ତ୍ତନର ପ୍ରତୀକ। ସେ ମୋକ୍ଷ ଓ ଅନ୍ତର୍ଶାନ୍ତି ଦିଅନ୍ତି।',
          poojas: ['ରୁଦ୍ର ଅଭିଷେକ', 'ମହାଶିବରାତ୍ରି ପୂଜା', 'ଲିଙ୍ଗାଷ୍ଟକମ୍ ପାଠ', 'ଧ୍ୟାନ ପୂଜା'],
        },
      },
    },
  },
  bn: {
  "nav": {
    "home": "বাড়ি",
    "bhaktiSamadhan": "ভক্তি সমাধন",
    "onlinePooja": "অনলাইন পুজো",
    "bhaktiDarshan": "ভক্তি দর্শন",
    "bhaktiStore": "ভক্তি স্টোর",
    "bhaktiYoga": "ভক্তি যোগ",
    "bhaktiJaapa": "ভক্তি জাপা",
    "bhaktiBalChitraKatha": "বাল চিত্র কথা",
    "dashboard": "ড্যাশবোর্ড",
    "adminPanel": "অ্যাডমিন প্যানেল",
    "logout": "লগআউট",
    "login": "লগইন করুন",
    "signUp": "সাইন আপ করুন",
    "selectLanguage": "ভাষা নির্বাচন করুন",
    "language": "ভাষা",
    "openShoppingCart": "শপিং কার্ট খুলুন"
  },
  "footer": {
    "contact": "যোগাযোগ",
    "allRightsReserved": "সর্বস্বত্ব সংরক্ষিত।"
  },
  "auth": {
    "login": {
      "welcomeBack": "স্বাগত ফিরে",
      "subtitle": "আপনার আধ্যাত্মিক যাত্রা চালিয়ে যেতে সাইন ইন করুন",
      "googleTermsPrefix": "Google এর সাথে সাইন ইন করে, আপনি আমাদের সাথে সম্মত হন",
      "termsAndPrivacy": "শর্তাবলী এবং গোপনীয়তা নীতি",
      "separator": "বা",
      "redirectMessage": "আপনি যে পৃষ্ঠাটি অ্যাক্সেস করার চেষ্টা করছেন তা দেখতে আপনাকে অবশ্যই লগ ইন করতে হবে৷",
      "emailAddress": "ইমেইল ঠিকানা",
      "enterEmail": "আপনার ইমেইল লিখুন",
      "password": "পাসওয়ার্ড",
      "enterPassword": "আপনার পাসওয়ার্ড লিখুন",
      "rememberMe": "আমাকে মনে রেখো",
      "forgotPassword": "পাসওয়ার্ড ভুলে গেছেন?",
      "signingIn": "সাইন ইন হচ্ছে...",
      "signIn": "সাইন ইন করুন",
      "noAccount": "একটি অ্যাকাউন্ট নেই?",
      "signUp": "সাইন আপ করুন",
      "welcomeToast": "আবার স্বাগতম, {{name}}!",
      "emailRequired": "ইমেল প্রয়োজন",
      "emailInvalid": "ইমেল অবৈধ",
      "passwordRequired": "পাসওয়ার্ড প্রয়োজন",
      "passwordMin": "পাসওয়ার্ড কমপক্ষে 6 অক্ষরের হতে হবে",
      "loginFailed": "লগইন ব্যর্থ হয়েছে. আবার চেষ্টা করুন."
    },
    "signup": {
      "joinAnandmaya": "আনন্দমায়ায় যোগ দিন",
      "subtitle": "আমাদের সাথে আপনার আধ্যাত্মিক যাত্রা শুরু করুন",
      "firstName": "প্রথম নাম",
      "enterFirstName": "প্রথম নাম লিখুন",
      "lastName": "পদবি",
      "enterLastName": "পদবি লিখুন",
      "emailAddress": "ইমেইল ঠিকানা",
      "enterEmail": "আপনার ইমেইল লিখুন",
      "password": "পাসওয়ার্ড",
      "createPassword": "একটি পাসওয়ার্ড তৈরি করুন",
      "confirmPassword": "পাসওয়ার্ড নিশ্চিত করুন",
      "confirmPasswordPlaceholder": "আপনার পাসওয়ার্ড নিশ্চিত করুন",
      "agreeToPrefix": "আমি রাজি",
      "termsAndConditions": "শর্তাবলী",
      "and": "এবং",
      "privacyPolicy": "গোপনীয়তা নীতি",
      "creatingAccount": "অ্যাকাউন্ট তৈরি করা হচ্ছে...",
      "createAccount": "অ্যাকাউন্ট তৈরি করুন",
      "alreadyHaveAccount": "ইতিমধ্যে একটি অ্যাকাউন্ট আছে?",
      "signIn": "সাইন ইন করুন",
      "accountCreatedAlert": "অ্যাকাউন্ট সফলভাবে তৈরি করা হয়েছে! আনন্দময়ায় স্বাগতম!",
      "firstNameRequired": "প্রথম নাম প্রয়োজন",
      "lastNameRequired": "পদবি প্রয়োজন",
      "emailRequired": "ইমেল প্রয়োজন",
      "emailInvalid": "ইমেল অবৈধ",
      "passwordRequired": "পাসওয়ার্ড প্রয়োজন",
      "passwordMin": "পাসওয়ার্ড কমপক্ষে 6 অক্ষরের হতে হবে",
      "confirmPasswordRequired": "আপনার পাসওয়ার্ড নিশ্চিত করুন",
      "passwordsNoMatch": "পাসওয়ার্ড মেলে না",
      "agreeToTermsRequired": "আপনি শর্তাবলী সম্মত হতে হবে",
      "registrationFailed": "নিবন্ধন ব্যর্থ হয়েছে. আবার চেষ্টা করুন."
    }
  },
  "home": {
    "hero": {
      "liveDarshan": "ঐশ্বরিক দর্শন",
      "watchNow": "এখন দেখুন",
      "bhakti": "ভক্তি",
      "balChitrakatha": "বাল-চিত্রকথা",
      "mindBodySoul": "শরীর ~ মন ~ আত্মা",
      "subtitle": "ভক্তি, আধ্যাত্মিক জ্ঞান এবং শারীরিক সুস্থতার পথ আবিষ্কার করুন",
      "deviGalleryAria": "দেবী গ্যালারি ঘোরানো",
      "cards": {
        "bhaktiSamadhan": {
          "title": "ভক্তি\nসমাধান",
          "description": "পূজা, মন্ত্র এবং বৈদিক প্রতিকার সম্পর্কে এআই-চালিত আধ্যাত্মিক নির্দেশিকা।"
        },
        "onlinePooja": {
          "title": "অনলাইন পুজো",
          "description": "আপনার বাড়ির আরাম থেকে পবিত্র বৈদিক আচার-অনুষ্ঠানে অংশগ্রহণ করুন।"
        },
        "bhaktiDarshan": {
          "title": "ভক্তি\nদর্শন",
          "description": "সারা ভারত জুড়ে প্রধান মন্দির থেকে রিয়েল-টাইম ঐশ্বরিক দর্শন।"
        },
        "bhaktiStore": {
          "title": "ভক্তি স্টোর",
          "description": "আপনার যাত্রার জন্য আধ্যাত্মিক আইটেম, মূর্তি এবং বইগুলি কিউরেট করা হয়েছে।"
        },
        "bhaktiYoga": {
          "title": "ভক্তি যোগ",
          "description": "ভক্তিমূলক যোগ অনুশীলনের মাধ্যমে শরীর, মন এবং আত্মাকে সংযুক্ত করুন।"
        },
        "bhaktiJaapa": {
          "title": "ভক্তি জাপা",
          "description": "আপনার প্রতিদিনের মন্ত্র জপ অনুশীলন ট্র্যাক করুন এবং গভীর করুন।"
        }
      },
      "deity": {
        "maaDurga": "মা দুর্গা",
        "goddessSaraswati": "দেবী সরস্বতী",
        "maaParvati": "মা পার্বতী",
        "maaKali": "কালীর দেশ",
        "maaLakshmi": "মা লক্ষ্মী",
        "lordGanesha": "প্রভু গণেশ",
        "lordHanuman": "ভগবান হনুমান",
        "lordShiva": "ভগবান শিব",
        "lordVishnu": "ভগবান বিষ্ণু",
        "lordKrishna": "ভগবান কৃষ্ণ",
        "lordMurugan": "লর্ড মুরুগান",
        "lordBrahma": "ভগবান ব্রহ্মা",
        "maaBagalamukhi": "মা বগালামুখী",
        "lordKubera": "ভগবান কুবের",
        "lordShani": "ভগবান শনি",
        "navgraha": "নবগ্রহ",
        "vastuPurusha": "বাস্তু পুরুষ",
        "guru": "আধ্যাত্মিক গুরু"
      }
    },
    "sections": {
      "bhaktiSamadhan": {
        "title": "ভক্তি সমাধন",
        "subtitle": "আপনার জীবনের পরিস্থিতির জন্য এআই-চালিত আধ্যাত্মিক নির্দেশিকা",
        "description": "এআই দ্বারা চালিত ব্যক্তিগতকৃত বৈদিক নির্দেশিকা পান। পূজা, মন্ত্র, জ্যোতিষশাস্ত্র, ধ্যান বা কোনো আধ্যাত্মিক প্রশ্ন সম্পর্কে জিজ্ঞাসা করুন। স্বাস্থ্য, সম্পদ, ক্যারিয়ার, সম্পর্ক এবং আরও অনেক কিছুর জন্য কিউরেটেড প্রতিকার ব্রাউজ করুন।",
        "features": [
          "এআই-চালিত পূজার সুপারিশ",
          "ব্যক্তিগতকৃত আধ্যাত্মিক চ্যাট সহকারী",
          "বিভাগ দ্বারা কিউরেটেড বৈদিক প্রতিকার",
          "পবিত্র ধর্মগ্রন্থ থেকে উদ্ধৃতি"
        ],
        "buttonText": "আধ্যাত্মিক দিকনির্দেশনা পান"
      },
      "onlinePooja": {
        "title": "অনলাইন পুজো",
        "subtitle": "বিশ্বের যে কোনো স্থান থেকে পবিত্র আচার এবং প্রার্থনা সম্পাদন করুন",
        "description": "আমাদের অনলাইন প্ল্যাটফর্মের মাধ্যমে ঐতিহ্যবাহী পূজা অনুষ্ঠানের শক্তির অভিজ্ঞতা নিন। আমাদের অভিজ্ঞ পুরোহিতরা লাইভ পূজা সেশন পরিচালনা করেন যেগুলিতে আপনি আপনার বাড়ির আরাম থেকে অংশগ্রহণ করতে পারেন।",
        "features": [
          "ব্যক্তিগতকৃত প্রার্থনা এবং নৈবেদ্য"
        ],
        "buttonText": "অনলাইনে পুজো বুক করুন"
      },
      "bhaktiDarshan": {
        "title": "ভক্তি দর্শন",
        "subtitle": "আপনি যেখানেই থাকুন না কেন, ঈশ্বরের সাথে সংযুক্ত থাকুন",
        "description": "বিখ্যাত আধ্যাত্মিক কেন্দ্রগুলি থেকে মন্দির দর্শনের আমাদের লাইভ স্ট্রিমিংয়ের মাধ্যমে ঐশ্বরিক উপস্থিতির অভিজ্ঞতা নিন। রিয়েল-টাইম উপাসনায় হাজার হাজার ভক্তদের সাথে যোগ দিন এবং পবিত্র দেবতাদের কাছ থেকে আশীর্বাদ পান।",
        "features": [
          "ভারতের পবিত্র মন্দিরগুলির ঐশ্বরিক সারাংশ আবিষ্কার করুন",
          "ধনী, প্রাণময় আধ্যাত্মিক অভিজ্ঞতায় নিজেকে নিমজ্জিত করুন",
          "প্রতিটি মুহূর্তে ঈশ্বরের উপস্থিতি অনুভব করুন"
        ],
        "buttonText": "ভক্তি দর্শন দেখুন",
        "secondaryButtonText": "ভক্তি বল-চিত্রকথা"
      },
      "bhaktiStore": {
        "title": "ভক্তি স্টোর",
        "subtitle": "আপনার যাত্রার জন্য পবিত্র আইটেম, বই এবং আধ্যাত্মিক নৈবেদ্য",
        "description": "আধ্যাত্মিক আইটেম, পবিত্র বই, ধ্যানের সরঞ্জাম এবং ভক্তিমূলক অফারগুলির একটি সংকলিত সংগ্রহ আবিষ্কার করুন। প্রতিটি আইটেম আপনার আধ্যাত্মিক অনুশীলন উন্নত করার জন্য সাবধানে নির্বাচন করা হয়.",
        "features": [
          "পবিত্র মূর্তি এবং দেবতা",
          "আধ্যাত্মিক বই এবং ধর্মগ্রন্থ",
          "ধ্যান এবং যোগব্যায়াম আনুষাঙ্গিক",
          "ধূপ, মোমবাতি, এবং নৈবেদ্য"
        ],
        "buttonText": "দোকানে যান"
      },
      "bhaktiYoga": {
        "title": "ভক্তি যোগ",
        "subtitle": "যোগ অনুশীলন যা শরীর, মন এবং আত্মাকে সংযুক্ত করে",
        "description": "ভক্তি যোগের রূপান্তরকারী শক্তির অভিজ্ঞতা নিন, যেখানে শারীরিক ভঙ্গি আধ্যাত্মিক ভক্তির সাথে মিলিত হয়। আমাদের ক্লাসগুলি সম্পূর্ণ আধ্যাত্মিক বৃদ্ধির জন্য ভক্তিমূলক অনুশীলনের সাথে ঐতিহ্যগত যোগব্যায়ামকে একত্রিত করে।",
        "features": [
          "ঐতিহ্যগত যোগব্যায়াম, প্রাণায়াম এবং আসন",
          "ভক্তিমূলক জপ এবং মন্ত্র",
          "ধ্যান এবং প্রাণায়াম",
          "আধ্যাত্মিক দর্শন একীকরণ"
        ],
        "buttonText": "যোগব্যায়াম কোর্সে যোগ দিন"
      },
      "bhaktiJaapa": {
        "title": "ভক্তি জাপা",
        "subtitle": "আপনার প্রতিদিনের মন্ত্র জপ অনুশীলন ট্র্যাক করুন এবং গভীর করুন",
        "description": "আমাদের জাপা ট্র্যাকারের সাথে একটি ধারাবাহিক আধ্যাত্মিক অনুশীলন বজায় রাখুন। আপনার প্রতিদিনের মন্ত্রের পুনরাবৃত্তিগুলি লগ করুন, সময়ের সাথে সাথে আপনার অগ্রগতি ট্র্যাক করুন এবং ভক্তিমূলক জপের একটি শক্তিশালী অভ্যাস গড়ে তুলুন।",
        "features": [
          "দৈনিক মন্ত্র জপ ট্র্যাকার",
          "অগ্রগতি লগ এবং streaks",
          "একাধিক মন্ত্র সমর্থন",
          "ব্যক্তিগত আধ্যাত্মিক জার্নাল"
        ],
        "buttonText": "জাপা অনুশীলন শুরু করুন"
      },
      "upcoming": {
        "title": "অন্যান্য আসন্ন পরিষেবা",
        "subtitle": "আসন্ন পরিষেবার জন্য আমাদের সাথে থাকুন যেমন...",
        "features": [
          "এআই জ্যোতিষ ও দৈনিক রাশিফল: ব্যক্তিগতকৃত কুন্ডলি/জন্ম চার্ট বিশ্লেষণ, দৈনিক \"শুভ মুহুর্ত\" (শুভ সময়) এবং এআই-চালিত ব্যক্তিগতকৃত প্রতিকারগুলিকে একীভূত করুন।",
          "ভার্চুয়াল \"সেবা\" এবং দাতব্য: ব্যবহারকারীদের গৌ সেবা (গরু খাওয়ানো), ব্রাহ্মণ ভোজন, বা ডিজিটাল শংসাপত্র এবং ভিডিও প্রমাণ সহ নির্দিষ্ট মন্দির সংস্কার প্রকল্পে দান করার অনুমতি দিন।",
          "সাবস্ক্রিপশন-ভিত্তিক \"নিরন্তর চাধাভা\": একটি নির্বাচিত মন্দিরে ব্যবহারকারীর নামে তৈরি স্বয়ংক্রিয় সাপ্তাহিক বা মাসিক নৈবেদ্য (ফুল/মিষ্টি)।",
          "আধ্যাত্মিক বিষয়বস্তু ফিড: অল্পবয়সী ব্যবহারকারীদের শিক্ষিত করার জন্য কথা, দৈনিক মন্ত্র এবং হিন্দু আচারের ব্যাখ্যা সহ সংক্ষিপ্ত আকারের ভিডিও সামগ্রী।"
        ]
      }
    },
    "contact": {
      "mailSubject": "আনন্দমায়ার জন্য গ্রাহক প্রতিক্রিয়া",
      "getInTouch": "যোগাযোগ করুন",
      "subtitle": "আমরা আপনার কাছ থেকে শুনতে এবং আপনার আধ্যাত্মিক যাত্রায় আপনাকে সাহায্য করতে চাই",
      "address": "ঠিকানা",
      "addressLine1": "ভুবনেশ্বর",
      "addressLine2": "ওড়িশা, ভারত 751006",
      "phone": "ফোন",
      "email": "ইমেইল",
      "prompt": "একটি প্রশ্ন বা একটি বিশেষ অনুরোধ আছে? আপনার প্রিয় ইমেল অ্যাপ্লিকেশন থেকে সরাসরি আমাদের একটি ইমেল পাঠাতে নীচের বোতামে ক্লিক করুন।",
      "sendEmail": "একটি ইমেল পাঠান"
    }
  },
  "onlinePooja": {
    "pageHeader": {
      "title": "অনলাইন পূজা সেবা",
      "subtitle": "আপনার পবিত্র অনুষ্ঠান বুক করুন এবং বাড়ি থেকে ঐশ্বরিক আশীর্বাদ পান।"
    },
    "poojaTypes": {
      "sectionTitle": "আপনার অনলাইন পূজা বুক করুন",
      "sectionSubtitle": "বিভিন্ন অনুষ্ঠান এবং প্রয়োজনের জন্য ডিজাইন করা আমাদের বিভিন্ন পূজা পরিষেবা থেকে বেছে নিন",
      "mostPopular": "সর্বাধিক জনপ্রিয়",
      "bookNow": "এখন বুক করুন",
      "items": {
        "daily": {
          "title": "প্রতিদিনের পুজো",
          "description": "আধ্যাত্মিক সুস্থতার জন্য নিয়মিত দৈনিক প্রার্থনা।"
        },
        "special": {
          "title": "বিশেষ উপলক্ষ পূজা",
          "description": "জন্মদিন, বার্ষিকী, এবং বিশেষ মাইলফলকগুলির জন্য কাস্টমাইজড পূজা।"
        },
        "festival": {
          "title": "উৎসব পূজা",
          "description": "প্রধান হিন্দু উৎসবের অনুষ্ঠান।"
        },
        "remedial": {
          "title": "প্রতিকারমূলক পূজা",
          "description": "বাধা অতিক্রম করে ইতিবাচক শক্তি আনতে।"
        },
        "house-warming": {
          "title": "হাউস ওয়ার্মিং পুজো",
          "description": "নতুন বাড়ি আশীর্বাদ করার জন্য পবিত্র অনুষ্ঠান।"
        },
        "success": {
          "title": "সফল পুজো",
          "description": "একাডেমিক সাফল্য এবং কর্মজীবন বৃদ্ধির জন্য।"
        }
      }
    },
    "bookingForm": {
      "title": "আপনার পুজো বুক করুন",
      "subtitle": "আপনার পবিত্র অনুষ্ঠান বুক করার জন্য বিস্তারিত পূরণ করুন",
      "labels": {
        "poojaType": "পূজার ধরন নির্বাচন করুন",
        "temple": "মন্দির নির্বাচন করুন",
        "preferredDate": "পছন্দের তারিখ",
        "preferredTime": "পছন্দের সময়",
        "devoteeName": "ভক্তের নাম",
        "email": "ইমেইল ঠিকানা",
        "phone": "ফোন নম্বর",
        "upiId": "UPI আইডি (ঐচ্ছিক)",
        "specialRequests": "বিশেষ অনুরোধ (ঐচ্ছিক)"
      },
      "placeholders": {
        "choosePoojaType": "পূজার ধরন বেছে নিন",
        "chooseTemple": "মন্দির বেছে নিন",
        "selectTime": "সময় নির্বাচন করুন",
        "devoteeName": "আপনার পুরো নাম লিখুন",
        "email": "আপনার ইমেইল লিখুন",
        "phone": "আপনার ফোন নম্বর লিখুন",
        "upiId": "yourname@bank",
        "specialRequests": "ডেলিভারি পেতে পিনকোড সহ আপনার সম্পূর্ণ ঠিকানা লিখুন (প্রসাদ, পূজা মালা/ফুল, কুমকুম/হলদি/চন্দন/বিভূতি, পূজার ধূপকাঠি ইত্যাদি)"
      },
      "errors": {
        "selectPoojaType": "অনুগ্রহ করে একটি পূজার ধরন নির্বাচন করুন",
        "selectTemple": "একটি মন্দির নির্বাচন করুন",
        "selectDate": "একটি তারিখ নির্বাচন করুন",
        "selectTime": "একটি সময় নির্বাচন করুন",
        "enterName": "আপনার নাম লিখুন",
        "validEmail": "একটি বৈধ ইমেল লিখুন",
        "validPhone": "একটি বৈধ ফোন নম্বর লিখুন",
        "validUpi": "অনুগ্রহ করে একটি বৈধ UPI আইডি লিখুন (উদাহরণ: name@bank)"
      },
      "submit": {
        "processing": "প্রক্রিয়া করা হচ্ছে...",
        "proceedToPayment": "পেমেন্ট করতে এগিয়ে যান"
      },
      "toasts": {
        "loginRequired": "একটি পূজা বুক করার জন্য লগ ইন করুন.",
        "poojaDetailsMissing": "অর্থপ্রদানের জন্য পূজার বিবরণ খুঁজে পাওয়া যায়নি।",
        "bookingCreationFailed": "বুকিং তৈরি করা ব্যর্থ হয়েছে৷",
        "orderCreationFailed": "পেমেন্ট অর্ডার তৈরি করতে ব্যর্থ হয়েছে৷",
        "bookingConfirmed": "বুকিং নিশ্চিত!",
        "viewBookings": "বুকিং দেখুন",
        "paymentVerificationFailed": "অর্থপ্রদান যাচাই ব্যর্থ হয়েছে৷",
        "paymentCancelled": "পেমেন্ট বাতিল করা হয়েছে। আপনার বুকিং পেমেন্ট মুলতুবি আছে."
      },
      "paymentDescription": "{{title}} এর জন্য অর্থপ্রদান",
      "temples": {
        "varanasi": "কাশী বিশ্বনাথ মন্দির, বারাণসী",
        "jagannath": "জগন্নাথ মন্দির, পুরী",
        "sidhhaMahavir": "সিদ্ধ মহাবীর মন্দির, পুরী",
        "navaGraha": "নবগ্রহ মন্দির, পুরী",
        "loknath": "লোকনাথ মন্দির, পুরী",
        "mangala": "বাটা মঙ্গলা মন্দির, পুরী",
        "cuttackChandi": "চণ্ডী মন্দির, কটক",
        "ugraTara": "উগরা তারা মন্দির, খোরধা",
        "tarini": "তারিণী মন্দির",
        "mahavir": "শিরুলি মহাবীর মন্দির, পুরী",
        "mangalnath": "মঙ্গলনাথ মন্দির, উজ্জয়িনী",
        "lakshmi": "লক্ষ্মী মন্দির, পুরী",
        "vimala": "বিমলা মন্দির, পুরী",
        "bhubaneswari": "ভুবনেশ্বরী মন্দির, ভুবনেশ্বর",
        "bagalamukhi": "মা বগালামুখী মন্দির, পুরী",
        "lingaraj": "লিঙ্গরাজ মন্দির, ভুবনেশ্বর"
      },
      "timeSlots": {
        "06_00": "6:00 AM",
        "08_00": "সকাল ৮টা",
        "10_00": "সকাল ১০টা",
        "12_00": "দুপুর ১২টা",
        "14_00": "দুপুর 2:00 PM",
        "16_00": "বিকাল 4:00 PM",
        "18_00": "সন্ধ্যা ৬:০০",
        "20_00": "রাত ৮টা"
      }
    },
    "howItWorks": {
      "title": "কিভাবে অনলাইন পূজা কাজ করে",
      "subtitle": "আমাদের পবিত্র অনুষ্ঠানে বুকিং এবং অংশগ্রহণের সহজ পদক্ষেপ",
      "steps": [
        {
          "title": "আপনার পূজা চয়ন করুন",
          "description": "আপনার প্রয়োজন এবং উপলক্ষ্য অনুসারে পূজার ধরন নির্বাচন করুন"
        },
        {
          "title": "বুক এবং পে",
          "description": "আপনার বুকিং সম্পূর্ণ করুন এবং অনলাইনে নিরাপদ অর্থপ্রদান করুন"
        },
        {
          "title": "বিস্তারিত প্রাপ্ত করুন",
          "description": "পূজার বিবরণ এবং লাইভ স্ট্রিমিং লিঙ্কের সাথে নিশ্চিতকরণ পান"
        }
      ]
    },
    "testimonials": {
      "title": "আমাদের ভক্তরা যা বলে",
      "subtitle": "আমাদের আধ্যাত্মিক অনুসন্ধানকারীদের সম্প্রদায়ের অভিজ্ঞতা",
      "items": [
        {
          "content": "অনলাইন পুজোর অভিজ্ঞতা সত্যিই ঐশ্বরিক ছিল। আমি মাইল দূরে থেকেও ঐশ্বরিক শক্তির সাথে সংযুক্ত অনুভব করেছি। পুরোহিত অত্যন্ত জ্ঞানী ছিলেন এবং অনুষ্ঠানটি অত্যন্ত নিষ্ঠার সাথে পরিচালিত হয়েছিল।",
          "author": "প্রিয়া শর্মা",
          "location": "মুম্বাই, ভারত"
        },
        {
          "content": "আমি প্রথম দিকে অনলাইন পূজা নিয়ে সন্দিহান ছিলাম, কিন্তু অভিজ্ঞতা আমার প্রত্যাশা ছাড়িয়ে গেছে। অনুষ্ঠানের মান এবং আধ্যাত্মিক শক্তি ছিল অবিশ্বাস্য। অত্যন্ত প্রস্তাবিত!",
          "author": "রাজেশ কুমার",
          "location": "দিল্লি, ভারত"
        },
        {
          "content": "বিদেশে বসবাসকারী কেউ হিসাবে, এই অনলাইন পূজা সেবা একটি আশীর্বাদ হয়েছে. আমি এখন ঐতিহ্যবাহী অনুষ্ঠানে অংশগ্রহণ করতে পারি এবং আমার শিকড়ের সাথে আমার আধ্যাত্মিক সংযোগ বজায় রাখতে পারি।",
          "author": "অনিতা প্যাটেল",
          "location": "নিউইয়র্ক, মার্কিন যুক্তরাষ্ট্র"
        }
      ]
    }
  },
  "bhaktiStore": {
    "pageHeader": {
      "title": "ভক্তি স্টোর",
      "subtitle": "আপনার আধ্যাত্মিক যাত্রার জন্য পবিত্র আইটেমগুলির একটি সংকলিত সংগ্রহ আবিষ্কার করুন।"
    },
    "loadingProducts": "পণ্য লোড হচ্ছে...",
    "errorPrefix": "ত্রুটি",
    "messages": {
      "fetchFailed": "পণ্য আনতে ব্যর্থ হয়েছে",
      "addedToCart": "কার্টে যোগ করা হয়েছে!",
      "viewCart": "কার্ট দেখুন",
      "noProductsInCategory": "এই বিভাগে কোন পণ্য পাওয়া যায়নি.",
      "outOfStock": "এই পণ্য স্টক আউট."
    },
    "actions": {
      "addToCart": "কার্টে যোগ করুন",
      "buyNow": "এখনই কিনুন",
      "outOfStock": "স্টক আউট"
    },
    "categories": {
      "allProducts": "সমস্ত পণ্য",
      "sacred_idols": "পবিত্র মূর্তি",
      "malas_and_beads": "মালা ও পুঁতি",
      "spiritual_books": "আধ্যাত্মিক বই",
      "incense_and_fragrance": "ধূপ ও সুবাস",
      "pooja_items": "পূজা আইটেম",
      "yoga_accessories": "যোগব্যায়াম আনুষাঙ্গিক"
    },
    "products": {
      "sacred_ganesha_idol": {
        "name": "পবিত্র গণেশ মূর্তি",
        "description": "বাড়ির পূজা এবং সমৃদ্ধির আশীর্বাদের জন্য সুন্দর পিতলের গণেশ মূর্তি।"
      },
      "rudraksha_panch_mukhi_original": {
        "name": "রুদ্রাক্ষ পঞ্চমুখী (মূল)",
        "description": "জপ এবং আধ্যাত্মিক সুস্থতার জন্য প্রামাণিক পঞ্চমুখী রুদ্রাক্ষ।"
      },
      "rudraksha_mala": {
        "name": "রুদ্রাক্ষ মালা",
        "description": "ধ্যান ও জপের জন্য প্রামাণিক 108-মালা 5-মুখী রুদ্রাক্ষ মালা।"
      },
      "bhagavad_gita_book": {
        "name": "ভগবদ্গীতা বই",
        "description": "বিস্তারিত ভাষ্য ও অনুবাদ সহ সম্পূর্ণ ভগবদ্গীতা।"
      },
      "sandalwood_incense": {
        "name": "চন্দন ধূপ",
        "description": "পূজা এবং ধ্যানের জন্য 50টি খাঁটি, সুগন্ধযুক্ত চন্দন কাঠের ধূপকাঠির প্যাক।"
      },
      "copper_pooja_thali": {
        "name": "তামার পূজার থালি",
        "description": "একটি ঐতিহ্যবাহী, সুন্দর কারুকাজ করা তামার পূজা থালি প্রতিদিনের আচার-অনুষ্ঠানের জন্য সেট।"
      },
      "crystal_shiva_lingam": {
        "name": "স্ফটিক শিব লিঙ্গম",
        "description": "শক্তিশালী ধ্যান এবং শক্তির জন্য একটি প্রাকৃতিক, উচ্চ-মানের স্ফটিক শিব লিঙ্গম।"
      },
      "eco_friendly_yoga_mat": {
        "name": "ইকো-ফ্রেন্ডলি যোগ ম্যাট",
        "description": "আপনার আধ্যাত্মিক এবং শারীরিক অনুশীলনের জন্য একটি নন-স্লিপ, ইকো-বন্ধুত্বপূর্ণ যোগ ম্যাট।"
      },
      "tulsi_mala": {
        "name": "তুলসীর মালা",
        "description": "জপ এবং পরার জন্য একটি পবিত্র 108-পুঁতির তুলসী কাঠের মালা।"
      }
    }
  },
  "checkout": {
    "emptyCartTitle": "আপনার কার্ট খালি.",
    "continueShopping": "কেনাকাটা চালিয়ে যান",
    "title": "চেকআউট",
    "form": {
      "shippingAddress": "শিপিং ঠিকানা",
      "address": "ঠিকানা",
      "city": "শহর",
      "state": "রাজ্য",
      "postalCode": "পোস্টাল কোড",
      "countryDisplay": "ভারত",
      "phoneNumber": "ফোন নম্বর",
      "gstNumberLabel": "জিএসটি নম্বর (ঐচ্ছিক)",
      "gstNumberPlaceholder": "যেমন, 22AAAAA0000A1Z5",
      "upiIdLabel": "UPI আইডি (ঐচ্ছিক)",
      "upiIdPlaceholder": "yourname@bank"
    },
    "actions": {
      "processing": "প্রক্রিয়া করা হচ্ছে...",
      "pay": "₹{{amount}} দিন"
    },
    "orderSummary": {
      "title": "অর্ডার সারাংশ",
      "itemLine": "{{name}} x {{পরিমাণ}}",
      "total": "মোট"
    },
    "errors": {
      "invalidUpi": "অনুগ্রহ করে একটি বৈধ UPI আইডি লিখুন (উদাহরণ: name@bank)।",
      "paymentFailedPrefix": "অর্থপ্রদান ব্যর্থ হয়েছে৷",
      "unexpected": "একটি অপ্রত্যাশিত ত্রুটি ঘটেছে৷"
    }
  },
  "coursePlayer": {
    "loading": "কোর্স প্লেয়ার লোড হচ্ছে...",
    "errorPrefix": "ত্রুটি",
    "courseContentNotFound": "কোর্স বিষয়বস্তু পাওয়া যায়নি.",
    "progressComplete": "{{percent}}% সম্পূর্ণ ({{completed}}/{{total}})",
    "nonVideoFallback": "এই পাঠের প্রাথমিক বিষয়বস্তু একটি ডাউনলোডযোগ্য সম্পদ।",
    "lockedContentTitle": "এই বিষয়বস্তু লক করা আছে",
    "lockedContentMessage": "এই মডিউলটি শুধুমাত্র '{{tier}}' গ্রাহকদের জন্য উপলব্ধ৷",
    "upgradePlan": "আপনার পরিকল্পনা আপগ্রেড করুন",
    "completed": "✓ সম্পন্ন",
    "markAsComplete": "সম্পূর্ণ হিসাবে চিহ্নিত করুন",
    "viewOrDownloadNotes": "নোট দেখুন বা ডাউনলোড করুন",
    "welcomeTitle": "স্বাগতম!",
    "selectLessonPrompt": "আপনার যাত্রা শুরু করতে সাইডবার থেকে একটি পাঠ নির্বাচন করুন।",
    "errors": {
      "fetchCourseContent": "কোর্স কন্টেন্ট আনতে ব্যর্থ."
    }
  },
  "shoppingCart": {
    "title": "আপনার কার্ট",
    "closeCart": "কার্ট বন্ধ করুন",
    "emptyTitle": "আপনার কার্ট খালি",
    "emptyDescription": "শুরু করতে কিছু আধ্যাত্মিক আইটেম যোগ করুন.",
    "subtotal": "সাবটোটাল",
    "proceedToCheckout": "চেকআউটে এগিয়ে যান",
    "decreaseQuantity": "{{name}} এর জন্য পরিমাণ হ্রাস করুন",
    "increaseQuantity": "{{name}} এর জন্য পরিমাণ বাড়ান",
    "removeItem": "কার্ট থেকে {{name}} সরান",
    "outOfStockRemovedMessage": "এই পণ্য(গুলি) স্টক নেই এবং আপনার কার্ট থেকে সরানো হয়েছে: {{items}}",
    "quantityExceedsStockMessage": "অনুরোধকৃত পরিমাণ উপলব্ধ স্টক ছাড়িয়ে গেছে। এগিয়ে যেতে পরিমাণ কমান."
  },
  "bhaktiYogaPage": {
    "header": {
      "title": "ভক্তি যোগ কোর্স",
      "subtitle": "আধ্যাত্মিক, শারীরিক এবং মানসিক সুস্থতার জন্য আমাদের কিউরেট করা কোর্সগুলির সাথে একটি রূপান্তরমূলক যাত্রা শুরু করুন।"
    },
    "loadingCourses": "কোর্স লোড হচ্ছে...",
    "errorPrefix": "ত্রুটি",
    "noCoursesMessage": "কোন কোর্স এই মুহূর্তে উপলব্ধ. পরে আবার চেক করুন.",
    "errors": {
      "loadCourses": "কোর্স লোড করতে ব্যর্থ হয়েছে."
    },
    "levels": {
      "beginner": "শিক্ষানবিস",
      "intermediate": "মধ্যবর্তী",
      "advanced": "উন্নত",
      "all_levels": "সমস্ত স্তর",
      "all_level": "সমস্ত স্তর",
      "all_ages": "সমস্ত বয়স",
      "children": "শিশুরা",
      "special": "বিশেষ"
    },
    "tiers": {
      "free": "বিনামূল্যে",
      "plus": "প্লাস",
      "premium": "প্রিমিয়াম"
    },
    "catalogues": {},
    "courses": {}
  },
  "bhaktiYogaCourseDetail": {
    "loadingCourse": "কোর্স লোড হচ্ছে...",
    "errorPrefix": "ত্রুটি",
    "courseNotFound": "কোর্স পাওয়া যায়নি.",
    "minutesShort": "মিনিট",
    "sections": {
      "aboutThisCourse": "এই কোর্স সম্পর্কে",
      "curriculum": "পাঠ্যক্রম"
    },
    "actions": {
      "goToCourse": "কোর্সে যান",
      "loginToEnroll": "নথিভুক্ত করতে লগইন করুন",
      "processing": "প্রক্রিয়া করা হচ্ছে...",
      "startCourse": "কোর্স শুরু করুন",
      "enrolling": "নথিভুক্ত করা হচ্ছে...",
      "enrollForFree": "বিনামূল্যে নথিভুক্ত করুন",
      "subscribeToTier": "{{tier}}-এ সদস্যতা নিন"
    },
    "form": {
      "upiIdLabel": "UPI আইডি (ঐচ্ছিক)",
      "upiIdPlaceholder": "yourname@bank"
    },
    "sidebar": {
      "fullAccessNote": "তালিকাভুক্তির পরে সমস্ত কোর্স ভিডিও এবং নোটগুলিতে সম্পূর্ণ অ্যাক্সেস।"
    },
    "errors": {
      "loadCourseDetails": "কোর্সের বিবরণ লোড করা যায়নি।",
      "invalidUpi": "অনুগ্রহ করে একটি বৈধ UPI আইডি লিখুন (উদাহরণ: name@bank)।",
      "unexpected": "একটি অপ্রত্যাশিত ত্রুটি ঘটেছে৷"
    },
    "courses": {},
    "modules": {},
    "lessons": {}
  },
  "bhaktiJaapaPage": {
    "header": {
      "title": "ভক্তি জাপা",
      "subtitle": "আপনার প্রতিদিনের জপ অনুশীলনের জন্য একটি পবিত্র স্থান।"
    },
    "settings": {
      "chooseDivineName": "একটি ঐশ্বরিক নাম চয়ন করুন:"
    },
    "chantingArea": {
      "tapToChant": "জপ করতে আলতো চাপুন"
    },
    "counters": {
      "sessionJaapa": "সেশন জাপা",
      "malasCompleted": "মালাস সম্পন্ন"
    },
    "analytics": {
      "todaysTotalJaapas": "আজকের টোটাল জাপস",
      "todaysMalasCompleted": "আজকের মালা সমাপ্ত",
      "viewMyAnalytics": "আমার বিশ্লেষণ দেখুন"
    },
    "voiceSelector": {
      "loadingVoices": "ভয়েস লোড হচ্ছে...",
      "selectVoice": "ভয়েস নির্বাচন করুন:",
      "silent": "নীরব",
      "hindiIndian": "হিন্দি ভয়েস (ভারত)",
      "hindiIndianCloser": "হিন্দি ভয়েস (ভারত - পরিষ্কার)"
    },
    "soundToggle": {
      "toggleBackgroundSound": "পটভূমি শব্দ টগল করুন",
      "backgroundFlute": "পটভূমির বাঁশি",
      "mute": "নিঃশব্দ",
      "unmute": "বিরক্তি"
    },
    "divineNames": {
      "omNamahaShivaya": "ওম নমহা শিবায়",
      "omNamahShivaya": "ওম নমঃ শিবায়",
      "jaiShreeKrishna": "জয় শ্রী কৃষ্ণ",
      "jaiShreeRam": "জয় শ্রী রাম",
      "shreeRadha": "শ্রী রাধা",
      "sitaRam": "সীতা রাম",
      "omGanGanapatayeNamah": "ওম গণ গণপতয়ে নমঃ",
      "omRudrayaNamah": "কাকা রুদ্রায় নমঃ |",
      "radheKrishna": "রাধে কৃষ্ণ",
      "omSaiRam": "সাই রাম সম্পর্কে",
      "omKalabhiravayNamah": "ওম কালবিরাবায় নমঃ",
      "shreem": "শ্রীম",
      "aim": "লক্ষ্য",
      "hareKrishnaMahaMantra": "হরে কৃষ্ণ হরে কৃষ্ণ\nকৃষ্ণ কৃষ্ণ হরে হরে\nহরে রাম হরে রাম\nরাম রাম হরে হরে",
      "hareKrishna": "হরে কৃষ্ণ",
      "shreeRam": "শ্রী রাম",
      "shreeKrishna": "শ্রীকৃষ্ণ",
      "jaiMaaDurga": "জয় মা দুর্গা",
      "maaDurga": "মা দুর্গা",
      "jaiHanuman": "জয় হনুমান",
      "hanuman": "হনুমান"
    }
  },
  "dashboard": {
    "sidebar": {
      "myPoojaBookings": "আমার পুজোর বুকিং",
      "myStoreOrders": "আমার দোকান আদেশ",
      "myCourses": "আমার কোর্স",
      "jaapaAnalytics": "জাপা বিশ্লেষণ",
      "myProfile": "আমার প্রোফাইল",
      "menu": "মেনু"
    },
    "common": {
      "errorPrefix": "ত্রুটি",
      "status": {
        "pending": "মুলতুবি",
        "paid": "পেড",
        "completed": "সম্পন্ন",
        "failed": "ব্যর্থ হয়েছে",
        "cancelled": "বাতিল",
        "canceled": "বাতিল",
        "processing": "প্রক্রিয়াকরণ",
        "shipped": "পাঠানো হয়েছে",
        "delivered": "বিতরণ করা হয়েছে",
        "refunded": "ফেরত দেওয়া হয়েছে"
      }
    },
    "bookings": {
      "loading": "আপনার বুকিং লোড হচ্ছে...",
      "emptyMessage": "আপনি এখনও কোনো পূজার বুকিং করেননি.",
      "bookNow": "এখনই একটি পুজো বুক করুন",
      "fields": {
        "bookingId": "বুকিং আইডি",
        "temple": "মন্দির",
        "date": "তারিখ",
        "time": "সময়",
        "bookedOn": "বুক করা হয়েছে"
      },
      "errors": {
        "fetchFailed": "বুকিং আনতে ব্যর্থ হয়েছে"
      }
    },
    "orders": {
      "loading": "আপনার অর্ডার লোড হচ্ছে...",
      "emptyMessage": "আপনি এখনও কোনো আদেশ স্থাপন করেননি.",
      "shopNow": "এখনই কেনাকাটা করুন",
      "orderLabel": "অর্ডার",
      "placedOn": "উপর স্থাপন",
      "quantity": "পরিমাণ",
      "total": "মোট",
      "errors": {
        "fetchFailed": "অর্ডার আনতে ব্যর্থ হয়েছে"
      }
    },
    "courses": {
      "title": "আমার ভক্তি যোগ কোর্স",
      "loading": "আপনার কোর্স লোড হচ্ছে...",
      "emptyMessage": "আপনি এখনো কোনো কোর্সে নথিভুক্ত হননি।",
      "exploreCourses": "অন্বেষণ কোর্স",
      "courseTitleMissing": "কোর্স শিরোনাম অনুপস্থিত",
      "progressComplete": "{{percent}}% সম্পূর্ণ",
      "resumeCourse": "কোর্স পুনরায় শুরু করুন",
      "startCourse": "কোর্স শুরু করুন",
      "errors": {
        "fetchFailed": "কোর্স আনতে ব্যর্থ হয়েছে"
      }
    },
    "profile": {
      "loading": "প্রোফাইল লোড হচ্ছে...",
      "loadFailed": "ব্যবহারকারীর প্রোফাইল লোড করা যায়নি। আবার লগ ইন করার চেষ্টা করুন.",
      "avatarAlt": "ব্যবহারকারী অবতার",
      "confirmChangePassword": "নিরাপদে আপনার পাসওয়ার্ড পরিবর্তন করতে আপনাকে লগ আউট করা হবে। আপনি কি চালিয়ে যেতে চান?",
      "fields": {
        "fullName": "পুরো নাম",
        "emailAddress": "ইমেইল ঠিকানা",
        "role": "ভূমিকা",
        "memberSince": "থেকে সদস্য"
      },
      "editProfile": "প্রোফাইল সম্পাদনা করুন",
      "changePassword": "পাসওয়ার্ড পরিবর্তন করুন"
    }
  },
  "jaapaAnalyticsPage": {
    "title": "আমার Jaapa বিশ্লেষণ",
    "actions": {
      "backToBhaktiJaapa": "ভক্তি জপ-এ ফেরত যান"
    },
    "loadingAnalytics": "বিশ্লেষণ লোড হচ্ছে...",
    "errorPrefix": "ত্রুটি",
    "filters": {
      "today": "আজ",
      "thisWeek": "এই সপ্তাহে",
      "thisMonth": "এই মাসে",
      "allTime": "সব সময়"
    },
    "cards": {
      "totalJaapas": "মোট জাপাস",
      "malasCompleted": "মালাস সম্পন্ন"
    },
    "breakdown": {
      "title": "মন্ত্র ভাঙ্গন",
      "chants": "গান",
      "malaSingular": "মালা",
      "malasPlural": "অলস",
      "noData": "এই সময়ের জন্য কোনও জপ রেকর্ড করা হয়নি।",
      "startChanting": "জপ করা শুরু করুন"
    },
    "errors": {
      "fetchFailed": "বিশ্লেষণ আনতে ব্যর্থ হয়েছে"
    }
  },
  "liveDarshan": {
    "header": {
      "title": "ভক্তি দর্শন",
      "subtitle": "ভারত জুড়ে মন্দির এবং উপাসনালয় থেকে পবিত্র দর্শন দেখুন।"
    },
    "liveBadge": "লাইভ",
    "iframeTitle": "ভক্তি দর্শন - {{name}}",
    "temples": {
      "puri-jagannath": {
        "name": "পুরী জগন্নাথ মন্দির (সূত্র: জয় জগন্নাথ টিভি)",
        "location": "পুরী, ওড়িশা"
      },
      "kashi-vishwanath": {
        "name": "কাশী বিশ্বনাথ মন্দির",
        "location": "বারাণসী, উত্তরপ্রদেশ"
      },
      "shirdi-sai": {
        "name": "শিরডি সাই বাবা মন্দির",
        "location": "শিরডি, মহারাষ্ট্র"
      },
      "somnath-temple": {
        "name": "সোমনাথ মন্দির",
        "location": "ভেরাভাল, গুজরাট"
      },
      "vaishno-devi": {
        "name": "বৈষ্ণো দেবী মন্দির",
        "location": "কাটরা, জম্মু ও কাশ্মীর"
      },
      "golden-temple": {
        "name": "স্বর্ণ মন্দির (হরমন্দির সাহেব)",
        "location": "অমৃতসর, পাঞ্জাব"
      },
      "tirupati-balaji": {
        "name": "তিরুপতি বালাজি মন্দির",
        "location": "তিরুপতি, অন্ধ্রপ্রদেশ"
      },
      "rameshwaram": {
        "name": "রামেশ্বরম মন্দির",
        "location": "রামেশ্বরম, তামিলনাড়ু"
      },
      "Vitthal-Rukmini": {
        "name": "বিঠল-রুক্মিণী মন্দির",
        "location": "পন্ধরপুর, মহারাষ্ট্র"
      },
      "Dwarkadhish": {
        "name": "দ্বারকাধীশ মন্দির",
        "location": "দ্বারকা, গুজরাট"
      },
      "Sidhhivinayak": {
        "name": "সিদ্ধিবিনায়ক মন্দির",
        "location": "মুম্বাই, মহারাষ্ট্র"
      },
      "ISKCON-Vrindavan": {
        "name": "ইসকন মন্দির",
        "location": "বৃন্দাবন, উত্তরপ্রদেশ"
      }
    }
  },
  "bhaktiSamadhan": {
    "hero": {
      "title": "ভক্তি এআই গুরু",
      "subtitle": "বুদ্ধিমান গাইডেন্স: আপনার জীবনের পবিত্র যাত্রার জন্য ঐশ্বরিক নির্দেশনা"
    },
    "tabs": {
      "askAdvisor": "উপদেষ্টাকে জিজ্ঞাসা করুন",
      "chat": "চ্যাট",
      "browseRemedies": "প্রতিকার ব্রাউজ করুন"
    },
    "advisor": {
      "describeTitle": "আপনার পরিস্থিতি বর্ণনা করুন",
      "describeDesc": "আপনার বর্তমান পরিস্থিতি বা আপনি কিসের জন্য আশীর্বাদ চাইছেন সে সম্পর্কে আমাদের বলুন এবং আমাদের এআই ভক্তি গুরু সবচেয়ে উপযুক্ত পূজা এবং দেবতার সুপারিশ করবেন।",
      "placeholder": "যেমন, আমার ছেলের আসন্ন গুরুত্বপূর্ণ পরীক্ষার বাধা দূর করতে আমাকে পূজার পরামর্শ দিন",
      "gettingRecommendation": "সুপারিশ পাওয়া যাচ্ছে...",
      "getRecommendation": "সুপারিশ পান",
      "consultingWisdom": "আধ্যাত্মিক জ্ঞানের সাথে পরামর্শ করা...",
      "spiritualGuidance": "আধ্যাত্মিক নির্দেশনা",
      "noRecommendation": "কোন সুপারিশ উপলব্ধ.",
      "genericError": "দুঃখিত, কিছু ভুল হয়েছে. আবার চেষ্টা করুন."
    },
    "guest": {
      "defaultLimitMessage": "দৈনিক সীমা ছাড়িয়ে গেছে। অতিথি ব্যবহারকারী হিসেবে আপনি প্রতিদিন সর্বোচ্চ ৩টি অনুরোধে পৌঁছেছেন। সীমাহীন অ্যাক্সেসের সাথে চালিয়ে যেতে অনুগ্রহ করে লগ ইন করুন বা সাইন আপ করুন৷",
      "tryAgainAfter": "{{baseMessage}} আপনি {{time}} পরে আবার চেষ্টা করতে পারেন।"
    },
    "chat": {
      "genericError": "আমি ক্ষমাপ্রার্থী, কিছু ভুল হয়েছে. আবার চেষ্টা করুন.",
      "historyTitle": "চ্যাট ইতিহাস",
      "newChat": "নতুন চ্যাট",
      "loading": "লোড হচ্ছে...",
      "noConversations": "এখনো কোনো কথোপকথন নেই",
      "untitled": "শিরোনামহীন",
      "deleteConversation": "কথোপকথন মুছুন",
      "spiritualChat": "আধ্যাত্মিক আড্ডা",
      "namaste": "নমস্তে !",
      "emptyPrompt": "আমাকে বৈদিক জ্ঞান, পূজা, মন্ত্র, জ্যোতিষশাস্ত্র, যোগব্যায়াম, ধ্যান বা যেকোনো আধ্যাত্মিক প্রশ্ন সম্পর্কে জিজ্ঞাসা করুন।",
      "guestModeInfo": "অতিথি মোড - 3টি বার্তা/দিন। সীমাহীন প্রশ্ন জিজ্ঞাসা করার জন্য লগ ইন করুন",
      "suggestions": [
        "হনুমান চালিসার তাৎপর্য কি?",
        "কর্মজীবন বৃদ্ধির জন্য আমার কোন পূজা করা উচিত?",
        "ভগবদ্গীতায় কর্মের ব্যাখ্যা কর",
        "ওম নমঃ শিবায় জপের উপকারিতা?",
        "আমি কিভাবে নেতিবাচক চিন্তা আধ্যাত্মিকভাবে কমাতে পারি?",
        "মানসিক শান্তি এবং ফোকাসের জন্য কোন মন্ত্র সবচেয়ে ভালো?",
        "কোন পূজা বিবাহ বিলম্বে সাহায্য করতে পারে?",
        "আমি কিভাবে আমার বাড়িতে আরো ইতিবাচকতা আনতে পারি?",
        "কোন আধ্যাত্মিক অনুশীলন চাপ এবং উদ্বেগ সঙ্গে সাহায্য করে?",
        "পারিবারিক সম্প্রীতির জন্য কোন প্রতিকার সবচেয়ে ভালো?"
      ],
      "askPlaceholder": "আপনার আধ্যাত্মিক প্রশ্ন জিজ্ঞাসা করুন...",
      "askButton": "জিজ্ঞাসা করুন"
    },
    "categories": {
      "education": "শিক্ষা",
      "career": "কর্মজীবন",
      "marriage": "বিবাহ",
      "health": "স্বাস্থ্য",
      "wealth": "সম্পদ",
      "family": "পরিবার",
      "protection": "সুরক্ষা",
      "children": "শিশুরা",
      "spiritualGrowth": "আধ্যাত্মিক বৃদ্ধি",
      "allRemedies": "সমস্ত প্রতিকার"
    },
    "remedies": {
      "browseByCategory": "বিভাগ দ্বারা ব্রাউজ করুন",
      "primaryDeity": "প্রাথমিক দেবতা",
      "recommendedPoojas": "প্রস্তাবিত পূজা",
      "morePrompt": "আমাকে {{title}} — {{desc}} সম্পর্কে আরও বলুন",
      "wealthFinancialProsperity": {
        "title": "সম্পদ এবং আর্থিক সমৃদ্ধি",
        "desc": "আর্থিক স্থিতিশীলতা, ব্যবসায়িক সাফল্য এবং বস্তুগত সমৃদ্ধি অর্জনের জন্য",
        "deity": "লক্ষ্মী",
        "deityDesc": "লক্ষ্মী হলেন সমস্ত সম্পদ, প্রাচুর্য এবং সমৃদ্ধির সর্বোচ্চ উৎস। তিনি আর্থিক সাফল্য এবং বস্তুগত স্বাচ্ছন্দ্যের সাথে আশীর্বাদ করেন।",
        "poojas": [
          "লক্ষ্মী-অর্চনা",
          "লক্ষ্মী-হোম",
          "লক্ষ্মী-সহস্রনাম",
          "কুবের-পূজা"
        ]
      },
      "familyHarmonyHouseholdPeace": {
        "title": "পারিবারিক সম্প্রীতি এবং পারিবারিক শান্তি",
        "desc": "শান্তিপূর্ণ গৃহ পরিবেশ সৃষ্টি, পারিবারিক কলহ নিরসন এবং ঘরোয়া সম্প্রীতি বজায় রাখার জন্য",
        "deity": "অন্নপূর্ণা",
        "deityDesc": "অন্নপূর্ণা লালন-পালন, যত্ন এবং পারিবারিক কল্যাণের প্রতীক। তিনি পারিবারিক সম্প্রীতি এবং সমৃদ্ধি নিশ্চিত করেন।",
        "poojas": [
          "অন্নপূর্ণা-অর্চনা",
          "দুর্গা সপ্তশতী",
          "গণেশ-মহা-পূজা",
          "গৃহ-আশীর্বাদ-হবন"
        ]
      },
      "academicExcellenceKnowledge": {
        "title": "একাডেমিক শ্রেষ্ঠত্ব এবং জ্ঞান",
        "desc": "পড়াশোনা, পরীক্ষায় সাফল্যের জন্য এবং গভীর জ্ঞান ও প্রজ্ঞা অর্জনের জন্য",
        "deity": "সরস্বতী",
        "deityDesc": "সরস্বতী জ্ঞান, সঙ্গীত এবং শিক্ষার দেবী। তিনি জ্ঞান, বুদ্ধি এবং একাডেমিক সাফল্য প্রদান করেন।",
        "poojas": [
          "সরস্বতী পূজা",
          "হায়গ্রীব-হোমম",
          "বিদ্যা-লক্ষ্মী-পূজা",
          "অক্ষরভ্যাসম"
        ]
      },
      "careerGrowthProfessionalSuccess": {
        "title": "কর্মজীবন বৃদ্ধি এবং পেশাগত সাফল্য",
        "desc": "চাকরির প্রচার, ব্যবসায়িক বৃদ্ধি, পেশাগত বাধা দূর করা এবং ক্যারিয়ারের লক্ষ্য অর্জনের জন্য",
        "deity": "গণেশ",
        "deityDesc": "গণেশ বাধা অপসারণকারী এবং নতুন শুরুর অধিপতি। তিনি ক্যারিয়ারের অগ্রগতির পথ পরিষ্কার করেন।",
        "poojas": [
          "গণেশ-হোমম",
          "নবগ্রহ-পূজা",
          "বিষ্ণু-সহস্রনাম",
          "শনি-পূজা"
        ]
      },
      "marriageRelationshipBliss": {
        "title": "বিবাহ এবং সম্পর্ক সুখ",
        "desc": "সঠিক সঙ্গী, সুখী দাম্পত্য জীবন এবং সম্পর্কের সমস্যা সমাধানের জন্য",
        "deity": "পার্বতী",
        "deityDesc": "পার্বতী প্রেম, ভক্তি এবং বৈবাহিক সম্প্রীতির দেবী। তিনি শক্তিশালী এবং দীর্ঘস্থায়ী সম্পর্কের সাথে আশীর্বাদ করেন।",
        "poojas": [
          "স্বয়ম্বর-পার্বতী-হোমম",
          "মঙ্গলা-গৌরী-পূজা",
          "বিবাহ-পঞ্চমী-পূজা",
          "কাত্যায়নী-পূজা"
        ]
      },
      "healthHealing": {
        "title": "স্বাস্থ্য এবং নিরাময়",
        "desc": "অসুস্থতা থেকে পুনরুদ্ধারের জন্য, সুস্বাস্থ্য, দীর্ঘায়ু এবং সামগ্রিক শারীরিক সুস্থতা বজায় রাখা",
        "deity": "ধন্বন্তরী",
        "deityDesc": "ধন্বন্তরী হলেন ঐশ্বরিক চিকিৎসক এবং আয়ুর্বেদের দেবতা। তিনি নিরাময়, স্বাস্থ্য এবং রোগ থেকে মুক্তি প্রদান করেন।",
        "poojas": [
          "মহা-মৃত্যুঞ্জয়-জাপ",
          "ধন্বন্তরী-হোমম",
          "সুদর্শনা-হোমম",
          "আয়ুষ-হোমাম"
        ]
      },
      "protectionSafety": {
        "title": "সুরক্ষা এবং নিরাপত্তা",
        "desc": "নেতিবাচক শক্তি, কুদৃষ্টি থেকে রক্ষা এবং পরিবার ও সম্পত্তির নিরাপত্তা নিশ্চিত করার জন্য",
        "deity": "হনুমান",
        "deityDesc": "হনুমান শক্তি, সাহস এবং ভক্তির মূর্ত প্রতীক। তিনি ভক্তদের সকল বিপদ ও অশুভ শক্তি থেকে রক্ষা করেন।",
        "poojas": [
          "হনুমান-চালিসা-পাঠ",
          "সুদর্শনা-হোমম",
          "দুর্গা-কবচ-পথ",
          "বগলামুখী-পূজা"
        ]
      },
      "childrenProgeny": {
        "title": "শিশু এবং বংশধর",
        "desc": "ধন্য পিতৃত্ব, শিশু স্বাস্থ্য, শিশুদের একাডেমিক সাফল্য এবং তাদের সামগ্রিক সুস্থতার জন্য",
        "deity": "সন্তোষী মা",
        "deityDesc": "সন্তোষী মা তৃপ্তি ও সুখের দেবী। তিনি সুস্থ সন্তান এবং তৃপ্তি সঙ্গে পরিবার আশীর্বাদ.",
        "poojas": [
          "সান্তনা-গোপাল-হোমম",
          "পুত্রকামেষ্টী-যজ্ঞ",
          "গরবা-রক্ষা-পূজা",
          "সন্তোষী-মা-ব্রত"
        ]
      },
      "spiritualAwakeningInnerPeace": {
        "title": "আধ্যাত্মিক জাগরণ এবং অভ্যন্তরীণ শান্তি",
        "desc": "গভীর ধ্যান, আধ্যাত্মিক উন্নতি, অভ্যন্তরীণ শান্তি অর্জন এবং আত্ম-উপলব্ধির জন্য",
        "deity": "শিব",
        "deityDesc": "শিব হলেন পরম চেতনা, ধ্যান ও রূপান্তরের অধিপতি। তিনি মুক্তি এবং অভ্যন্তরীণ শান্তি প্রদান করেন।",
        "poojas": [
          "রুদ্র-অভিষেক",
          "মহা-শিবরাত্রি-পূজা",
          "লিঙ্গাষ্টকম-পথ",
          "ধ্যান-পূজা"
        ]
      }
    }
  }
}
};

export default translations;
